(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('@renoworks/perspective-tool')) :
	typeof define === 'function' && define.amd ? define(['@renoworks/perspective-tool'], factory) :
	(global.MaskingModule = factory(global.PerspectiveToolModule));
}(this, (function (PerspectiveToolModule) { 'use strict';

PerspectiveToolModule = PerspectiveToolModule && PerspectiveToolModule.hasOwnProperty('default') ? PerspectiveToolModule['default'] : PerspectiveToolModule;

/*!
 * Magic Wand (Fuzzy Selection Tool) for Javascript
 * https://github.com/Tamersoul/magic-wand-js
 *
 * The MIT License (MIT)
 *
 * Copyright (c) 2014, Ryasnoy Paul (ryasnoypaul@gmail.com)
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */
window.MagicWand = function () {
    var lib = {};

    /** Create a binary mask on the image by color threshold
      * Algorithm: Scanline flood fill (http://en.wikipedia.org/wiki/Flood_fill)
      * @param {Object} image: {Uint8Array} data, {int} width, {int} height, {int} bytes
      * @param {int} x of start pixel
      * @param {int} y of start pixel
      * @param {int} color threshold
      * @param {Uint8Array} mask of visited points (optional)
      * @return {Object} mask: {Uint8Array} data, {int} width, {int} height, {Object} bounds
      */
    lib.floodFill = function (image, px, py, colorThreshold, mask) {

        var c,
            x,
            newY,
            el,
            xr,
            xl,
            dy,
            dyl,
            dyr,
            checkY,
            data = image.data,
            w = image.width,
            h = image.height,
            bytes = image.bytes,
            // number of bytes in the color
        maxX = -1,
            minX = w + 1,
            maxY = -1,
            minY = h + 1,
            i = py * w + px,
            // start point index in the mask data
        result = new Uint8Array(w * h),
            // result mask
        visited = new Uint8Array(mask ? mask : w * h); // mask of visited points

        if (visited[i] === 1) return null;

        i = i * bytes; // start point index in the image data
        var sampleColor = [data[i], data[i + 1], data[i + 2], data[i + 3]]; // start point color (sample)

        var stack = [{ y: py, left: px - 1, right: px + 1, dir: 1 }]; // first scanning line
        do {
            el = stack.shift(); // get line for scanning

            checkY = false;
            for (x = el.left + 1; x < el.right; x++) {
                dy = el.y * w;
                i = (dy + x) * bytes; // point index in the image data

                if (visited[dy + x] === 1) continue; // check whether the point has been visited
                // compare the color of the sample
                c = data[i] - sampleColor[0]; // check by red
                if (c > colorThreshold || c < -colorThreshold) continue;
                c = data[i + 1] - sampleColor[1]; // check by green
                if (c > colorThreshold || c < -colorThreshold) continue;
                c = data[i + 2] - sampleColor[2]; // check by blue
                if (c > colorThreshold || c < -colorThreshold) continue;

                checkY = true; // if the color of the new point(x,y) is similar to the sample color need to check minmax for Y

                result[dy + x] = 1; // mark a new point in mask
                visited[dy + x] = 1; // mark a new point as visited

                xl = x - 1;
                // walk to left side starting with the left neighbor
                while (xl > -1) {
                    dyl = dy + xl;
                    i = dyl * bytes; // point index in the image data
                    if (visited[dyl] === 1) break; // check whether the point has been visited
                    // compare the color of the sample
                    c = data[i] - sampleColor[0]; // check by red
                    if (c > colorThreshold || c < -colorThreshold) break;
                    c = data[i + 1] - sampleColor[1]; // check by green
                    if (c > colorThreshold || c < -colorThreshold) break;
                    c = data[i + 2] - sampleColor[2]; // check by blue
                    if (c > colorThreshold || c < -colorThreshold) break;

                    result[dyl] = 1;
                    visited[dyl] = 1;

                    xl--;
                }
                xr = x + 1;
                // walk to right side starting with the right neighbor
                while (xr < w) {
                    dyr = dy + xr;
                    i = dyr * bytes; // index point in the image data
                    if (visited[dyr] === 1) break; // check whether the point has been visited
                    // compare the color of the sample
                    c = data[i] - sampleColor[0]; // check by red
                    if (c > colorThreshold || c < -colorThreshold) break;
                    c = data[i + 1] - sampleColor[1]; // check by green
                    if (c > colorThreshold || c < -colorThreshold) break;
                    c = data[i + 2] - sampleColor[2]; // check by blue
                    if (c > colorThreshold || c < -colorThreshold) break;

                    result[dyr] = 1;
                    visited[dyr] = 1;

                    xr++;
                }

                // check minmax for X
                if (xl < minX) minX = xl + 1;
                if (xr > maxX) maxX = xr - 1;

                newY = el.y - el.dir;
                if (newY >= 0 && newY < h) {
                    // add two scanning lines in the opposite direction (y - dir) if necessary
                    if (xl < el.left) stack.push({ y: newY, left: xl, right: el.left, dir: -el.dir }); // from "new left" to "current left"
                    if (el.right < xr) stack.push({ y: newY, left: el.right, right: xr, dir: -el.dir }); // from "current right" to "new right"
                }
                newY = el.y + el.dir;
                if (newY >= 0 && newY < h) {
                    // add the scanning line in the direction (y + dir) if necessary
                    if (xl < xr) stack.push({ y: newY, left: xl, right: xr, dir: el.dir }); // from "new left" to "new right"
                }
            }
            // check minmax for Y if necessary
            if (checkY) {
                if (el.y < minY) minY = el.y;
                if (el.y > maxY) maxY = el.y;
            }
        } while (stack.length > 0);

        return {
            data: result,
            width: image.width,
            height: image.height,
            bounds: {
                minX: minX,
                minY: minY,
                maxX: maxX,
                maxY: maxY
            }
        };
    };

    /** Apply the gauss-blur filter to binary mask
      * Algorithms: http://blog.ivank.net/fastest-gaussian-blur.html
      * http://www.librow.com/articles/article-9
      * http://elynxsdk.free.fr/ext-docs/Blur/Fast_box_blur.pdf
      * @param {Object} mask: {Uint8Array} data, {int} width, {int} height, {Object} bounds
      * @param {int} blur radius
      * @return {Object} mask: {Uint8Array} data, {int} width, {int} height, {Object} bounds
      */
    lib.gaussBlur = function (mask, radius) {

        var i,
            k,
            k1,
            x,
            y,
            val,
            start,
            end,
            n = radius * 2 + 1,
            // size of the pattern for radius-neighbors (from -r to +r with the center point)
        s2 = radius * radius,
            wg = new Float32Array(n),
            // weights
        total = 0,
            // sum of weights(used for normalization)
        w = mask.width,
            h = mask.height,
            data = mask.data,
            minX = mask.bounds.minX,
            maxX = mask.bounds.maxX,
            minY = mask.bounds.minY,
            maxY = mask.bounds.maxY;

        // calc gauss weights
        for (i = 0; i < radius; i++) {
            var dsq = (radius - i) * (radius - i);
            var ww = Math.exp(-dsq / (2.0 * s2)) / (2 * Math.PI * s2);
            wg[radius + i] = wg[radius - i] = ww;
            total += 2 * ww;
        }
        // normalization weights
        for (i = 0; i < n; i++) {
            wg[i] /= total;
        }

        var result = new Uint8Array(w * h),
            // result mask
        endX = radius + w,
            endY = radius + h;

        //walk through all source points for blur
        for (y = minY; y < maxY + 1; y++) {
            for (x = minX; x < maxX + 1; x++) {
                val = 0;
                k = y * w + x; // index of the point
                start = radius - x > 0 ? radius - x : 0;
                end = endX - x < n ? endX - x : n; // Math.min((((w - 1) - x) + radius) + 1, n);
                k1 = k - radius;
                // walk through x-neighbors
                for (i = start; i < end; i++) {
                    val += data[k1 + i] * wg[i];
                }
                start = radius - y > 0 ? radius - y : 0;
                end = endY - y < n ? endY - y : n; // Math.min((((h - 1) - y) + radius) + 1, n);
                k1 = k - radius * w;
                // walk through y-neighbors
                for (i = start; i < end; i++) {
                    val += data[k1 + i * w] * wg[i];
                }
                result[k] = val > 0.5 ? 1 : 0;
            }
        }return {
            data: result,
            width: w,
            height: h,
            bounds: {
                minX: minX,
                minY: minY,
                maxX: maxX,
                maxY: maxY
            }
        };
    };

    /** Create a border index array of boundary points of the mask with radius-neighbors
      * @param {Object} mask: {Uint8Array} data, {int} width, {int} height, {Object} bounds
      * @param {int} blur radius
      * @param {Uint8Array} visited: mask of visited points (optional)
      * @return {Array} border index array of boundary points with radius-neighbors (only points need for blur)
      */
    function createBorderForBlur(mask, radius, visited) {

        var x,
            i,
            j,
            y,
            k,
            k1,
            k2,
            w = mask.width,
            h = mask.height,
            data = mask.data,
            visitedData = new Uint8Array(data),
            minX = mask.bounds.minX,
            maxX = mask.bounds.maxX,
            minY = mask.bounds.minY,
            maxY = mask.bounds.maxY,
            len = w * h,
            temp = new Uint8Array(len),
            // auxiliary array to check uniqueness
        border = [],
            // only border points
        x0 = Math.max(minX, 1),
            x1 = Math.min(maxX, w - 2),
            y0 = Math.max(minY, 1),
            y1 = Math.min(maxY, h - 2);

        if (visited && visited.length > 0) {
            // copy visited points (only "black")
            for (k = 0; k < len; k++) {
                if (visited[k] === 1) visitedData[k] = 1;
            }
        }

        // walk through inner values except points on the boundary of the image
        for (y = y0; y < y1 + 1; y++) {
            for (x = x0; x < x1 + 1; x++) {
                k = y * w + x;
                if (data[k] === 0) continue; // "white" point isn't the border
                k1 = k + w; // y + 1
                k2 = k - w; // y - 1
                // check if any neighbor with a "white" color
                if (visitedData[k + 1] === 0 || visitedData[k - 1] === 0 || visitedData[k1] === 0 || visitedData[k1 + 1] === 0 || visitedData[k1 - 1] === 0 || visitedData[k2] === 0 || visitedData[k2 + 1] === 0 || visitedData[k2 - 1] === 0) {
                    //if (visitedData[k + 1] + visitedData[k - 1] +
                    //    visitedData[k1] + visitedData[k1 + 1] + visitedData[k1 - 1] +
                    //    visitedData[k2] + visitedData[k2 + 1] + visitedData[k2 - 1] == 8) continue;
                    border.push(k);
                }
            }
        } // walk through points on the boundary of the image if necessary
        // if the "black" point is adjacent to the boundary of the image, it is a border point
        if (minX == 0) for (y = minY; y < maxY + 1; y++) {
            if (data[y * w] === 1) border.push(y * w);
        }if (maxX == w - 1) for (y = minY; y < maxY + 1; y++) {
            if (data[y * w + maxX] === 1) border.push(y * w + maxX);
        }if (minY == 0) for (x = minX; x < maxX + 1; x++) {
            if (data[x] === 1) border.push(x);
        }if (maxY == h - 1) for (x = minX; x < maxX + 1; x++) {
            if (data[maxY * w + x] === 1) border.push(maxY * w + x);
        }var result = [],
            // border points with radius-neighbors
        start,
            end,
            endX = radius + w,
            endY = radius + h,
            n = radius * 2 + 1; // size of the pattern for radius-neighbors (from -r to +r with the center point)

        len = border.length;
        // walk through radius-neighbors of border points and add them to the result array
        for (j = 0; j < len; j++) {
            k = border[j]; // index of the border point
            temp[k] = 1; // mark border point
            result.push(k); // save the border point
            x = k % w; // calc x by index
            y = (k - x) / w; // calc y by index
            start = radius - x > 0 ? radius - x : 0;
            end = endX - x < n ? endX - x : n; // Math.min((((w - 1) - x) + radius) + 1, n);
            k1 = k - radius;
            // walk through x-neighbors
            for (i = start; i < end; i++) {
                k2 = k1 + i;
                if (temp[k2] === 0) {
                    // check the uniqueness
                    temp[k2] = 1;
                    result.push(k2);
                }
            }
            start = radius - y > 0 ? radius - y : 0;
            end = endY - y < n ? endY - y : n; // Math.min((((h - 1) - y) + radius) + 1, n);
            k1 = k - radius * w;
            // walk through y-neighbors
            for (i = start; i < end; i++) {
                k2 = k1 + i * w;
                if (temp[k2] === 0) {
                    // check the uniqueness
                    temp[k2] = 1;
                    result.push(k2);
                }
            }
        }

        return result;
    }
    /** Apply the gauss-blur filter ONLY to border points with radius-neighbors
      * Algorithms: http://blog.ivank.net/fastest-gaussian-blur.html
      * http://www.librow.com/articles/article-9
      * http://elynxsdk.free.fr/ext-docs/Blur/Fast_box_blur.pdf
      * @param {Object} mask: {Uint8Array} data, {int} width, {int} height, {Object} bounds
      * @param {int} blur radius
      * @param {Uint8Array} visited: mask of visited points (optional)
      * @return {Object} mask: {Uint8Array} data, {int} width, {int} height, {Object} bounds
      */
    lib.gaussBlurOnlyBorder = function (mask, radius, visited) {

        var border = createBorderForBlur(mask, radius, visited),
            // get border points with radius-neighbors
        ww,
            dsq,
            i,
            j,
            k,
            k1,
            x,
            y,
            val,
            start,
            end,
            n = radius * 2 + 1,
            // size of the pattern for radius-neighbors (from -r to +r with center point)
        s2 = 2 * radius * radius,
            wg = new Float32Array(n),
            // weights
        total = 0,
            // sum of weights(used for normalization)
        w = mask.width,
            h = mask.height,
            data = mask.data,
            minX = mask.bounds.minX,
            maxX = mask.bounds.maxX,
            minY = mask.bounds.minY,
            maxY = mask.bounds.maxY,
            len = border.length;

        // calc gauss weights
        for (i = 0; i < radius; i++) {
            dsq = (radius - i) * (radius - i);
            ww = Math.exp(-dsq / s2) / Math.PI;
            wg[radius + i] = wg[radius - i] = ww;
            total += 2 * ww;
        }
        // normalization weights
        for (i = 0; i < n; i++) {
            wg[i] /= total;
        }

        var result = new Uint8Array(data),
            // copy the source mask
        endX = radius + w,
            endY = radius + h;

        //walk through all border points for blur
        for (i = 0; i < len; i++) {
            k = border[i]; // index of the border point
            val = 0;
            x = k % w; // calc x by index
            y = (k - x) / w; // calc y by index
            start = radius - x > 0 ? radius - x : 0;
            end = endX - x < n ? endX - x : n; // Math.min((((w - 1) - x) + radius) + 1, n);
            k1 = k - radius;
            // walk through x-neighbors
            for (j = start; j < end; j++) {
                val += data[k1 + j] * wg[j];
            }
            if (val > 0.5) {
                result[k] = 1;
                // check minmax
                if (x < minX) minX = x;
                if (x > maxX) maxX = x;
                if (y < minY) minY = y;
                if (y > maxY) maxY = y;
                continue;
            }
            start = radius - y > 0 ? radius - y : 0;
            end = endY - y < n ? endY - y : n; // Math.min((((h - 1) - y) + radius) + 1, n);
            k1 = k - radius * w;
            // walk through y-neighbors
            for (j = start; j < end; j++) {
                val += data[k1 + j * w] * wg[j];
            }
            if (val > 0.5) {
                result[k] = 1;
                // check minmax
                if (x < minX) minX = x;
                if (x > maxX) maxX = x;
                if (y < minY) minY = y;
                if (y > maxY) maxY = y;
            } else {
                result[k] = 0;
            }
        }

        return {
            data: result,
            width: w,
            height: h,
            bounds: {
                minX: minX,
                minY: minY,
                maxX: maxX,
                maxY: maxY
            }
        };
    };

    /** Create a border mask (only boundary points)
      * @param {Object} mask: {Uint8Array} data, {int} width, {int} height, {Object} bounds
      * @return {Object} border mask: {Uint8Array} data, {int} width, {int} height, {Object} offset
      */
    lib.createBorderMask = function (mask) {

        var x,
            y,
            k,
            k1,
            k2,
            w = mask.width,
            h = mask.height,
            data = mask.data,
            minX = mask.bounds.minX,
            maxX = mask.bounds.maxX,
            minY = mask.bounds.minY,
            maxY = mask.bounds.maxY,
            rw = maxX - minX + 1,
            // bounds size
        rh = maxY - minY + 1,
            result = new Uint8Array(rw * rh),
            // reduced mask (bounds size)
        x0 = Math.max(minX, 1),
            x1 = Math.min(maxX, w - 2),
            y0 = Math.max(minY, 1),
            y1 = Math.min(maxY, h - 2);

        // walk through inner values except points on the boundary of the image
        for (y = y0; y < y1 + 1; y++) {
            for (x = x0; x < x1 + 1; x++) {
                k = y * w + x;
                if (data[k] === 0) continue; // "white" point isn't the border
                k1 = k + w; // y + 1
                k2 = k - w; // y - 1
                // check if any neighbor with a "white" color
                if (data[k + 1] === 0 || data[k - 1] === 0 || data[k1] === 0 || data[k1 + 1] === 0 || data[k1 - 1] === 0 || data[k2] === 0 || data[k2 + 1] === 0 || data[k2 - 1] === 0) {
                    //if (data[k + 1] + data[k - 1] +
                    //    data[k1] + data[k1 + 1] + data[k1 - 1] +
                    //    data[k2] + data[k2 + 1] + data[k2 - 1] == 8) continue;
                    result[(y - minY) * rw + (x - minX)] = 1;
                }
            }
        } // walk through points on the boundary of the image if necessary
        // if the "black" point is adjacent to the boundary of the image, it is a border point
        if (minX == 0) for (y = minY; y < maxY + 1; y++) {
            if (data[y * w] === 1) result[(y - minY) * rw] = 1;
        }if (maxX == w - 1) for (y = minY; y < maxY + 1; y++) {
            if (data[y * w + maxX] === 1) result[(y - minY) * rw + (maxX - minX)] = 1;
        }if (minY == 0) for (x = minX; x < maxX + 1; x++) {
            if (data[x] === 1) result[x - minX] = 1;
        }if (maxY == h - 1) for (x = minX; x < maxX + 1; x++) {
            if (data[maxY * w + x] === 1) result[(maxY - minY) * rw + (x - minX)] = 1;
        }return {
            data: result,
            width: rw,
            height: rh,
            offset: { x: minX, y: minY }
        };
    };

    /** Create a border index array of boundary points of the mask
      * @param {Object} mask: {Uint8Array} data, {int} width, {int} height
      * @return {Array} border index array boundary points of the mask
      */
    lib.getBorderIndices = function (mask) {

        var x,
            y,
            k,
            k1,
            k2,
            w = mask.width,
            h = mask.height,
            data = mask.data,
            border = [],
            // only border points
        x1 = w - 1,
            y1 = h - 1;

        // walk through inner values except points on the boundary of the image
        for (y = 1; y < y1; y++) {
            for (x = 1; x < x1; x++) {
                k = y * w + x;
                if (data[k] === 0) continue; // "white" point isn't the border
                k1 = k + w; // y + 1
                k2 = k - w; // y - 1
                // check if any neighbor with a "white" color
                if (data[k + 1] === 0 || data[k - 1] === 0 || data[k1] === 0 || data[k1 + 1] === 0 || data[k1 - 1] === 0 || data[k2] === 0 || data[k2 + 1] === 0 || data[k2 - 1] === 0) {
                    //if (data[k + 1] + data[k - 1] +
                    //    data[k1] + data[k1 + 1] + data[k1 - 1] +
                    //    data[k2] + data[k2 + 1] + data[k2 - 1] == 8) continue;
                    border.push(k);
                }
            }
        } // walk through points on the boundary of the image if necessary
        // if the "black" point is adjacent to the boundary of the image, it is a border point
        for (y = 0; y < h; y++) {
            if (data[y * w] === 1) border.push(y * w);
        }for (x = 0; x < w; x++) {
            if (data[x] === 1) border.push(x);
        }k = w - 1;
        for (y = 0; y < h; y++) {
            if (data[y * w + k] === 1) border.push(y * w + k);
        }k = (h - 1) * w;
        for (x = 0; x < w; x++) {
            if (data[k + x] === 1) border.push(k + x);
        }return border;
    };

    /** Create a compressed mask with a "white" border (1px border with zero values) for the contour tracing
      * @param {Object} mask: {Uint8Array} data, {int} width, {int} height, {Object} bounds
      * @return {Object} border mask: {Uint8Array} data, {int} width, {int} height, {Object} offset
      */
    function prepareMask(mask) {
        var x,
            y,
            w = mask.width,
            data = mask.data,
            minX = mask.bounds.minX,
            maxX = mask.bounds.maxX,
            minY = mask.bounds.minY,
            maxY = mask.bounds.maxY,
            rw = maxX - minX + 3,
            // bounds size +1 px on each side (a "white" border)
        rh = maxY - minY + 3,
            result = new Uint8Array(rw * rh); // reduced mask (bounds size)

        // walk through inner values and copy only "black" points to the result mask
        for (y = minY; y < maxY + 1; y++) {
            for (x = minX; x < maxX + 1; x++) {
                if (data[y * w + x] === 1) result[(y - minY + 1) * rw + (x - minX + 1)] = 1;
            }
        }return {
            data: result,
            width: rw,
            height: rh,
            offset: { x: minX - 1, y: minY - 1 }
        };
    }
    /** Create a contour array for the binary mask
      * Algorithm: http://www.sciencedirect.com/science/article/pii/S1077314203001401
      * @param {Object} mask: {Uint8Array} data, {int} width, {int} height, {Object} bounds
      * @return {Array} contours: {Array} points, {bool} inner, {int} label
      */
    lib.traceContours = function (mask) {
        var m = prepareMask(mask),
            contours = [],
            label = 0,
            w = m.width,
            w2 = w * 2,
            h = m.height,
            src = m.data,
            dx = m.offset.x,
            dy = m.offset.y,
            dest = new Uint8Array(src),
            // label matrix
        i,
            j,
            x,
            y,
            k,
            k1,
            c,
            inner,
            dir,
            first,
            second,
            current,
            previous,
            next,
            d;

        // all [dx,dy] pairs (array index is the direction)
        // 5 6 7
        // 4 X 0
        // 3 2 1
        var directions = [[1, 0], [1, 1], [0, 1], [-1, 1], [-1, 0], [-1, -1], [0, -1], [1, -1]];

        for (y = 1; y < h - 1; y++) {
            for (x = 1; x < w - 1; x++) {
                k = y * w + x;
                if (src[k] === 1) {
                    for (i = -w; i < w2; i += w2) {
                        // k - w: outer tracing (y - 1), k + w: inner tracing (y + 1)
                        if (src[k + i] === 0 && dest[k + i] === 0) {
                            // need contour tracing
                            inner = i === w; // is inner contour tracing ?
                            label++; // label for the next contour

                            c = [];
                            dir = inner ? 2 : 6; // start direction
                            current = previous = first = { x: x, y: y };
                            second = null;
                            while (true) {
                                dest[current.y * w + current.x] = label; // mark label for the current point
                                // bypass all the neighbors around the current point in a clockwise
                                for (j = 0; j < 8; j++) {
                                    dir = (dir + 1) % 8;

                                    // get the next point by new direction
                                    d = directions[dir]; // index as direction
                                    next = { x: current.x + d[0], y: current.y + d[1] };

                                    k1 = next.y * w + next.x;
                                    if (src[k1] === 1) // black boundary pixel
                                        {
                                            dest[k1] = label; // mark a label
                                            break;
                                        }
                                    dest[k1] = -1; // mark a white boundary pixel
                                    next = null;
                                }
                                if (next === null) break; // no neighbours (one-point contour)
                                current = next;
                                if (second) {
                                    if (previous.x === first.x && previous.y === first.y && current.x === second.x && current.y === second.y) {
                                        break; // creating the contour completed when returned to original position
                                    }
                                } else {
                                    second = next;
                                }
                                c.push({ x: previous.x + dx, y: previous.y + dy });
                                previous = current;
                                dir = (dir + 4) % 8; // next dir (symmetrically to the current direction)
                            }

                            if (next != null) {
                                c.push({ x: first.x + dx, y: first.y + dy }); // close the contour
                                contours.push({ inner: inner, label: label, points: c }); // add contour to the list
                            }
                        }
                    }
                }
            }
        }return contours;
    };

    /** Simplify contours
      * Algorithms: http://psimpl.sourceforge.net/douglas-peucker.html
      * http://neerc.ifmo.ru/wiki/index.php?title=%D0%A3%D0%BF%D1%80%D0%BE%D1%89%D0%B5%D0%BD%D0%B8%D0%B5_%D0%BF%D0%BE%D0%BB%D0%B8%D0%B3%D0%BE%D0%BD%D0%B0%D0%BB%D1%8C%D0%BD%D0%BE%D0%B9_%D1%86%D0%B5%D0%BF%D0%B8
      * @param {Array} contours: {Array} points, {bool} inner, {int} label
      * @param {float} simplify tolerant
      * @param {int} simplify count: min number of points when the contour is simplified
      * @return {Array} contours: {Array} points, {bool} inner, {int} label, {int} initialCount
      */
    lib.simplifyContours = function (contours, simplifyTolerant, simplifyCount) {
        var lenContours = contours.length,
            result = [],
            i,
            j,
            k,
            c,
            points,
            len,
            resPoints,
            lst,
            stack,
            ids,
            maxd,
            maxi,
            dist,
            r1,
            r2,
            r12,
            dx,
            dy,
            pi,
            pf,
            pl;

        // walk through all contours
        for (j = 0; j < lenContours; j++) {
            c = contours[j];
            points = c.points;
            len = c.points.length;

            if (len < simplifyCount) {
                // contour isn't simplified
                resPoints = [];
                for (k = 0; k < len; k++) {
                    resPoints.push({ x: points[k].x, y: points[k].y });
                }
                result.push({ inner: c.inner, label: c.label, points: resPoints, initialCount: len });
                continue;
            }

            lst = [0, len - 1]; // always add first and last points
            stack = [{ first: 0, last: len - 1 }]; // first processed edge

            do {
                ids = stack.shift();
                if (ids.last <= ids.first + 1) // no intermediate points
                    {
                        continue;
                    }

                maxd = -1.0; // max distance from point to current edge
                maxi = ids.first; // index of maximally distant point

                for (i = ids.first + 1; i < ids.last; i++) // bypass intermediate points in edge
                {
                    // calc the distance from current point to edge
                    pi = points[i];
                    pf = points[ids.first];
                    pl = points[ids.last];
                    dx = pi.x - pf.x;
                    dy = pi.y - pf.y;
                    r1 = Math.sqrt(dx * dx + dy * dy);
                    dx = pi.x - pl.x;
                    dy = pi.y - pl.y;
                    r2 = Math.sqrt(dx * dx + dy * dy);
                    dx = pf.x - pl.x;
                    dy = pf.y - pl.y;
                    r12 = Math.sqrt(dx * dx + dy * dy);
                    if (r1 >= Math.sqrt(r2 * r2 + r12 * r12)) dist = r2;else if (r2 >= Math.sqrt(r1 * r1 + r12 * r12)) dist = r1;else dist = Math.abs((dy * pi.x - dx * pi.y + pf.x * pl.y - pl.x * pf.y) / r12);

                    if (dist > maxd) {
                        maxi = i; // save the index of maximally distant point
                        maxd = dist;
                    }
                }

                if (maxd > simplifyTolerant) // if the max "deviation" is larger than allowed then...
                    {
                        lst.push(maxi); // add index to the simplified list
                        stack.push({ first: ids.first, last: maxi }); // add the left part for processing
                        stack.push({ first: maxi, last: ids.last }); // add the right part for processing
                    }
            } while (stack.length > 0);

            resPoints = [];
            len = lst.length;
            lst.sort(function (a, b) {
                return a - b;
            }); // restore index order
            for (k = 0; k < len; k++) {
                resPoints.push({ x: points[lst[k]].x, y: points[lst[k]].y }); // add result points to the correct order
            }
            result.push({ inner: c.inner, label: c.label, points: resPoints, initialCount: c.points.length });
        }

        return result;
    };

    return lib;
}();

var isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints;

var layerCategoryTypes = {
  opening: ['RWDoor', 'RWWindow', 'RWPath'],
  foreground: ['RWForeground'],
  surface: ['RWRegion', 'RWObject']
};

var layerTypeCategories = Object.keys(layerCategoryTypes).reduce(function (acc, category) {
  layerCategoryTypes[category].forEach(function (objectType) {
    acc[objectType] = category;
  });
  return acc;
}, {});

var defaults = {
  gutter: 0.1,
  panBounds: 0.85,
  zoomLimits: {
    min: 0.3,
    max: 15
  },

  loadRasterOnly: false,
  loadVectorOnly: false,
  preferRaster: false,
  dontPreserveAspectRatio: false,
  useMasterMask: false,

  layers: {
    globalMaskColor: undefined,
    globalMaskColorAccent: undefined,
    globalMaskStrokeColor: undefined,
    foregroundColor: '#e52222',

    polygonAttrs: {
      'fill-opacity': 0.8,
      'stroke-opacity': 1,
      relative: {
        'stroke-width': 1.2
      }
    },
    handleAttrs: {
      cursor: 'pointer',
      'fill-opacity': 1,
      'stroke-width': 0,
      fill: 'yellow',
      relative: {
        r: isTouchDevice ? 15 : 6
      }
    },
    editableAttrs: {
      polygon: {
        'fill-opacity': 0.3,
        relative: {
          'stroke-width': 2
        }
      },
      hole: {
        fill: 'white',
        relative: {
          r: isTouchDevice ? 15 : 3
        }
      },
      midpoint: {
        fill: 'white',
        relative: {
          r: isTouchDevice ? 15 : 4
        }
      }
    }
  },

  view: {
    zoomIncrement: 0.2,
    arrowKeyPan: 0.03,

    selectedOpacity: 0.7,
    highlightedOpacity: 0.8,
    nonHighlightedOpacity: 0.4,

    eraseColor: 'tomato',

    layerHoverType: 'group' // || 'layer'
  },

  tools: {
    polygon: {
      progressive: false
    },
    opening: {
      handle: {
        fill: 'white',
        relative: {
          r: isTouchDevice ? 15 : 5
        }
      },
      polygon: {
        fill: '#4bb94b',
        'fill-opacity': 0.4,
        'stroke-width': 0
      },
      edge: {
        stroke: 'black',
        relative: {
          'stroke-width': 4.5
        }
      },
      edgeHighlight: {
        stroke: 'red',
        relative: {
          'stroke-width': 8
        }
      }
    },
    setscale: {
      polygon: {
        stroke: 'white',
        'stroke-opacity': 0.8,
        relative: {
          'stroke-width': 5
        }
      },
      polygonHighlight: {
        stroke: 'red',
        'stroke-opacity': 0.5,
        relative: {
          'stroke-width': 8
        }
      },
      handle: {
        'fill-opacity': 0.7,
        fill: 'white'
      },
      handleHighlight: {
        fill: 'blue',
        'fill-opacity': 0.55
      }
    }
  },

  widgets: {
    magnifier: {
      size: 125
    }
  }
};

var Settings = {
  set: function set() {
    if (arguments.length === 1) {
      $.extend(true, Settings, arguments[0]);
    } else if (arguments.length === 2) {
      assign(Settings, arguments[0], arguments[1]);
    }
  },


  defaults: defaults,
  layerCategoryTypes: layerCategoryTypes,
  layerTypeCategories: layerTypeCategories
};

function assign(obj, prop, value) {
  if (typeof prop === 'string') {
    prop = prop.split('.');
  }

  if (prop.length > 1) {
    var e = prop.shift();
    assign(obj[e] = Object.prototype.toString.call(obj[e]) === '[object Object]' ? obj[e] : {}, prop, value);
  } else if ($.isPlainObject(obj[prop[0]])) {
    $.extend(obj[prop[0]], value);
  } else {
    obj[prop[0]] = value;
  }
}

var Settings$1 = $.extend(true, Settings, defaults);

var tinyqueue = TinyQueue;

function TinyQueue(data, compare) {
    if (!(this instanceof TinyQueue)) return new TinyQueue(data, compare);

    this.data = data || [];
    this.length = this.data.length;
    this.compare = compare || defaultCompare;

    if (data) for (var i = Math.floor(this.length / 2); i >= 0; i--) this._down(i);
}

function defaultCompare(a, b) {
    return a < b ? -1 : a > b ? 1 : 0;
}

TinyQueue.prototype = {

    push: function (item) {
        this.data.push(item);
        this.length++;
        this._up(this.length - 1);
    },

    pop: function () {
        var top = this.data[0];
        this.data[0] = this.data[this.length - 1];
        this.length--;
        this.data.pop();
        this._down(0);
        return top;
    },

    peek: function () {
        return this.data[0];
    },

    _up: function (pos) {
        var data = this.data,
            compare = this.compare;

        while (pos > 0) {
            var parent = Math.floor((pos - 1) / 2);
            if (compare(data[pos], data[parent]) < 0) {
                swap(data, parent, pos);
                pos = parent;

            } else break;
        }
    },

    _down: function (pos) {
        var data = this.data,
            compare = this.compare,
            len = this.length;

        while (true) {
            var left = 2 * pos + 1,
                right = left + 1,
                min = pos;

            if (left < len && compare(data[left], data[min]) < 0) min = left;
            if (right < len && compare(data[right], data[min]) < 0) min = right;

            if (min === pos) return;

            swap(data, min, pos);
            pos = min;
        }
    }
};

function swap(data, i, j) {
    var tmp = data[i];
    data[i] = data[j];
    data[j] = tmp;
}

var rbtree = createRBTree;

var RED   = 0;
var BLACK = 1;

function RBNode(color, key, value, left, right, count) {
  this._color = color;
  this.key = key;
  this.value = value;
  this.left = left;
  this.right = right;
  this._count = count;
}

function cloneNode(node) {
  return new RBNode(node._color, node.key, node.value, node.left, node.right, node._count)
}

function repaint(color, node) {
  return new RBNode(color, node.key, node.value, node.left, node.right, node._count)
}

function recount(node) {
  node._count = 1 + (node.left ? node.left._count : 0) + (node.right ? node.right._count : 0);
}

function RedBlackTree(compare, root) {
  this._compare = compare;
  this.root = root;
}

var proto = RedBlackTree.prototype;

Object.defineProperty(proto, "keys", {
  get: function() {
    var result = [];
    this.forEach(function(k,v) {
      result.push(k);
    });
    return result
  }
});

Object.defineProperty(proto, "values", {
  get: function() {
    var result = [];
    this.forEach(function(k,v) {
      result.push(v);
    });
    return result
  }
});

//Returns the number of nodes in the tree
Object.defineProperty(proto, "length", {
  get: function() {
    if(this.root) {
      return this.root._count
    }
    return 0
  }
});

//Insert a new item into the tree
proto.insert = function(key, value) {
  var cmp = this._compare;
  //Find point to insert new node at
  var n = this.root;
  var n_stack = [];
  var d_stack = [];
  while(n) {
    var d = cmp(key, n.key);
    n_stack.push(n);
    d_stack.push(d);
    if(d <= 0) {
      n = n.left;
    } else {
      n = n.right;
    }
  }
  //Rebuild path to leaf node
  n_stack.push(new RBNode(RED, key, value, null, null, 1));
  for(var s=n_stack.length-2; s>=0; --s) {
    var n = n_stack[s];
    if(d_stack[s] <= 0) {
      n_stack[s] = new RBNode(n._color, n.key, n.value, n_stack[s+1], n.right, n._count+1);
    } else {
      n_stack[s] = new RBNode(n._color, n.key, n.value, n.left, n_stack[s+1], n._count+1);
    }
  }
  //Rebalance tree using rotations
  //console.log("start insert", key, d_stack)
  for(var s=n_stack.length-1; s>1; --s) {
    var p = n_stack[s-1];
    var n = n_stack[s];
    if(p._color === BLACK || n._color === BLACK) {
      break
    }
    var pp = n_stack[s-2];
    if(pp.left === p) {
      if(p.left === n) {
        var y = pp.right;
        if(y && y._color === RED) {
          //console.log("LLr")
          p._color = BLACK;
          pp.right = repaint(BLACK, y);
          pp._color = RED;
          s -= 1;
        } else {
          //console.log("LLb")
          pp._color = RED;
          pp.left = p.right;
          p._color = BLACK;
          p.right = pp;
          n_stack[s-2] = p;
          n_stack[s-1] = n;
          recount(pp);
          recount(p);
          if(s >= 3) {
            var ppp = n_stack[s-3];
            if(ppp.left === pp) {
              ppp.left = p;
            } else {
              ppp.right = p;
            }
          }
          break
        }
      } else {
        var y = pp.right;
        if(y && y._color === RED) {
          //console.log("LRr")
          p._color = BLACK;
          pp.right = repaint(BLACK, y);
          pp._color = RED;
          s -= 1;
        } else {
          //console.log("LRb")
          p.right = n.left;
          pp._color = RED;
          pp.left = n.right;
          n._color = BLACK;
          n.left = p;
          n.right = pp;
          n_stack[s-2] = n;
          n_stack[s-1] = p;
          recount(pp);
          recount(p);
          recount(n);
          if(s >= 3) {
            var ppp = n_stack[s-3];
            if(ppp.left === pp) {
              ppp.left = n;
            } else {
              ppp.right = n;
            }
          }
          break
        }
      }
    } else {
      if(p.right === n) {
        var y = pp.left;
        if(y && y._color === RED) {
          //console.log("RRr", y.key)
          p._color = BLACK;
          pp.left = repaint(BLACK, y);
          pp._color = RED;
          s -= 1;
        } else {
          //console.log("RRb")
          pp._color = RED;
          pp.right = p.left;
          p._color = BLACK;
          p.left = pp;
          n_stack[s-2] = p;
          n_stack[s-1] = n;
          recount(pp);
          recount(p);
          if(s >= 3) {
            var ppp = n_stack[s-3];
            if(ppp.right === pp) {
              ppp.right = p;
            } else {
              ppp.left = p;
            }
          }
          break
        }
      } else {
        var y = pp.left;
        if(y && y._color === RED) {
          //console.log("RLr")
          p._color = BLACK;
          pp.left = repaint(BLACK, y);
          pp._color = RED;
          s -= 1;
        } else {
          //console.log("RLb")
          p.left = n.right;
          pp._color = RED;
          pp.right = n.left;
          n._color = BLACK;
          n.right = p;
          n.left = pp;
          n_stack[s-2] = n;
          n_stack[s-1] = p;
          recount(pp);
          recount(p);
          recount(n);
          if(s >= 3) {
            var ppp = n_stack[s-3];
            if(ppp.right === pp) {
              ppp.right = n;
            } else {
              ppp.left = n;
            }
          }
          break
        }
      }
    }
  }
  //Return new tree
  n_stack[0]._color = BLACK;
  return new RedBlackTree(cmp, n_stack[0])
};


//Visit all nodes inorder
function doVisitFull(visit, node) {
  if(node.left) {
    var v = doVisitFull(visit, node.left);
    if(v) { return v }
  }
  var v = visit(node.key, node.value);
  if(v) { return v }
  if(node.right) {
    return doVisitFull(visit, node.right)
  }
}

//Visit half nodes in order
function doVisitHalf(lo, compare, visit, node) {
  var l = compare(lo, node.key);
  if(l <= 0) {
    if(node.left) {
      var v = doVisitHalf(lo, compare, visit, node.left);
      if(v) { return v }
    }
    var v = visit(node.key, node.value);
    if(v) { return v }
  }
  if(node.right) {
    return doVisitHalf(lo, compare, visit, node.right)
  }
}

//Visit all nodes within a range
function doVisit(lo, hi, compare, visit, node) {
  var l = compare(lo, node.key);
  var h = compare(hi, node.key);
  var v;
  if(l <= 0) {
    if(node.left) {
      v = doVisit(lo, hi, compare, visit, node.left);
      if(v) { return v }
    }
    if(h > 0) {
      v = visit(node.key, node.value);
      if(v) { return v }
    }
  }
  if(h > 0 && node.right) {
    return doVisit(lo, hi, compare, visit, node.right)
  }
}


proto.forEach = function rbTreeForEach(visit, lo, hi) {
  if(!this.root) {
    return
  }
  switch(arguments.length) {
    case 1:
      return doVisitFull(visit, this.root)
    break

    case 2:
      return doVisitHalf(lo, this._compare, visit, this.root)
    break

    case 3:
      if(this._compare(lo, hi) >= 0) {
        return
      }
      return doVisit(lo, hi, this._compare, visit, this.root)
    break
  }
};

//First item in list
Object.defineProperty(proto, "begin", {
  get: function() {
    var stack = [];
    var n = this.root;
    while(n) {
      stack.push(n);
      n = n.left;
    }
    return new RedBlackTreeIterator(this, stack)
  }
});

//Last item in list
Object.defineProperty(proto, "end", {
  get: function() {
    var stack = [];
    var n = this.root;
    while(n) {
      stack.push(n);
      n = n.right;
    }
    return new RedBlackTreeIterator(this, stack)
  }
});

//Find the ith item in the tree
proto.at = function(idx) {
  if(idx < 0) {
    return new RedBlackTreeIterator(this, [])
  }
  var n = this.root;
  var stack = [];
  while(true) {
    stack.push(n);
    if(n.left) {
      if(idx < n.left._count) {
        n = n.left;
        continue
      }
      idx -= n.left._count;
    }
    if(!idx) {
      return new RedBlackTreeIterator(this, stack)
    }
    idx -= 1;
    if(n.right) {
      if(idx >= n.right._count) {
        break
      }
      n = n.right;
    } else {
      break
    }
  }
  return new RedBlackTreeIterator(this, [])
};

proto.ge = function(key) {
  var cmp = this._compare;
  var n = this.root;
  var stack = [];
  var last_ptr = 0;
  while(n) {
    var d = cmp(key, n.key);
    stack.push(n);
    if(d <= 0) {
      last_ptr = stack.length;
    }
    if(d <= 0) {
      n = n.left;
    } else {
      n = n.right;
    }
  }
  stack.length = last_ptr;
  return new RedBlackTreeIterator(this, stack)
};

proto.gt = function(key) {
  var cmp = this._compare;
  var n = this.root;
  var stack = [];
  var last_ptr = 0;
  while(n) {
    var d = cmp(key, n.key);
    stack.push(n);
    if(d < 0) {
      last_ptr = stack.length;
    }
    if(d < 0) {
      n = n.left;
    } else {
      n = n.right;
    }
  }
  stack.length = last_ptr;
  return new RedBlackTreeIterator(this, stack)
};

proto.lt = function(key) {
  var cmp = this._compare;
  var n = this.root;
  var stack = [];
  var last_ptr = 0;
  while(n) {
    var d = cmp(key, n.key);
    stack.push(n);
    if(d > 0) {
      last_ptr = stack.length;
    }
    if(d <= 0) {
      n = n.left;
    } else {
      n = n.right;
    }
  }
  stack.length = last_ptr;
  return new RedBlackTreeIterator(this, stack)
};

proto.le = function(key) {
  var cmp = this._compare;
  var n = this.root;
  var stack = [];
  var last_ptr = 0;
  while(n) {
    var d = cmp(key, n.key);
    stack.push(n);
    if(d >= 0) {
      last_ptr = stack.length;
    }
    if(d < 0) {
      n = n.left;
    } else {
      n = n.right;
    }
  }
  stack.length = last_ptr;
  return new RedBlackTreeIterator(this, stack)
};

//Finds the item with key if it exists
proto.find = function(key) {
  var cmp = this._compare;
  var n = this.root;
  var stack = [];
  while(n) {
    var d = cmp(key, n.key);
    stack.push(n);
    if(d === 0) {
      return new RedBlackTreeIterator(this, stack)
    }
    if(d <= 0) {
      n = n.left;
    } else {
      n = n.right;
    }
  }
  return new RedBlackTreeIterator(this, [])
};

//Removes item with key from tree
proto.remove = function(key) {
  var iter = this.find(key);
  if(iter) {
    return iter.remove()
  }
  return this
};

//Returns the item at `key`
proto.get = function(key) {
  var cmp = this._compare;
  var n = this.root;
  while(n) {
    var d = cmp(key, n.key);
    if(d === 0) {
      return n.value
    }
    if(d <= 0) {
      n = n.left;
    } else {
      n = n.right;
    }
  }
  return
};

//Iterator for red black tree
function RedBlackTreeIterator(tree, stack) {
  this.tree = tree;
  this._stack = stack;
}

var iproto = RedBlackTreeIterator.prototype;

//Test if iterator is valid
Object.defineProperty(iproto, "valid", {
  get: function() {
    return this._stack.length > 0
  }
});

//Node of the iterator
Object.defineProperty(iproto, "node", {
  get: function() {
    if(this._stack.length > 0) {
      return this._stack[this._stack.length-1]
    }
    return null
  },
  enumerable: true
});

//Makes a copy of an iterator
iproto.clone = function() {
  return new RedBlackTreeIterator(this.tree, this._stack.slice())
};

//Swaps two nodes
function swapNode(n, v) {
  n.key = v.key;
  n.value = v.value;
  n.left = v.left;
  n.right = v.right;
  n._color = v._color;
  n._count = v._count;
}

//Fix up a double black node in a tree
function fixDoubleBlack(stack) {
  var n, p, s, z;;;;
  for(var i=stack.length-1; i>=0; --i) {
    n = stack[i];
    if(i === 0) {
      n._color = BLACK;
      return
    }
    //console.log("visit node:", n.key, i, stack[i].key, stack[i-1].key)
    p = stack[i-1];
    if(p.left === n) {
      //console.log("left child")
      s = p.right;
      if(s.right && s.right._color === RED) {
        //console.log("case 1: right sibling child red")
        s = p.right = cloneNode(s);
        z = s.right = cloneNode(s.right);
        p.right = s.left;
        s.left = p;
        s.right = z;
        s._color = p._color;
        n._color = BLACK;
        p._color = BLACK;
        z._color = BLACK;
        recount(p);
        recount(s);
        if(i > 1) {
          var pp = stack[i-2];
          if(pp.left === p) {
            pp.left = s;
          } else {
            pp.right = s;
          }
        }
        stack[i-1] = s;
        return
      } else if(s.left && s.left._color === RED) {
        //console.log("case 1: left sibling child red")
        s = p.right = cloneNode(s);
        z = s.left = cloneNode(s.left);
        p.right = z.left;
        s.left = z.right;
        z.left = p;
        z.right = s;
        z._color = p._color;
        p._color = BLACK;
        s._color = BLACK;
        n._color = BLACK;
        recount(p);
        recount(s);
        recount(z);
        if(i > 1) {
          var pp = stack[i-2];
          if(pp.left === p) {
            pp.left = z;
          } else {
            pp.right = z;
          }
        }
        stack[i-1] = z;
        return
      }
      if(s._color === BLACK) {
        if(p._color === RED) {
          //console.log("case 2: black sibling, red parent", p.right.value)
          p._color = BLACK;
          p.right = repaint(RED, s);
          return
        } else {
          //console.log("case 2: black sibling, black parent", p.right.value)
          p.right = repaint(RED, s);
          continue  
        }
      } else {
        //console.log("case 3: red sibling")
        s = cloneNode(s);
        p.right = s.left;
        s.left = p;
        s._color = p._color;
        p._color = RED;
        recount(p);
        recount(s);
        if(i > 1) {
          var pp = stack[i-2];
          if(pp.left === p) {
            pp.left = s;
          } else {
            pp.right = s;
          }
        }
        stack[i-1] = s;
        stack[i] = p;
        if(i+1 < stack.length) {
          stack[i+1] = n;
        } else {
          stack.push(n);
        }
        i = i+2;
      }
    } else {
      //console.log("right child")
      s = p.left;
      if(s.left && s.left._color === RED) {
        //console.log("case 1: left sibling child red", p.value, p._color)
        s = p.left = cloneNode(s);
        z = s.left = cloneNode(s.left);
        p.left = s.right;
        s.right = p;
        s.left = z;
        s._color = p._color;
        n._color = BLACK;
        p._color = BLACK;
        z._color = BLACK;
        recount(p);
        recount(s);
        if(i > 1) {
          var pp = stack[i-2];
          if(pp.right === p) {
            pp.right = s;
          } else {
            pp.left = s;
          }
        }
        stack[i-1] = s;
        return
      } else if(s.right && s.right._color === RED) {
        //console.log("case 1: right sibling child red")
        s = p.left = cloneNode(s);
        z = s.right = cloneNode(s.right);
        p.left = z.right;
        s.right = z.left;
        z.right = p;
        z.left = s;
        z._color = p._color;
        p._color = BLACK;
        s._color = BLACK;
        n._color = BLACK;
        recount(p);
        recount(s);
        recount(z);
        if(i > 1) {
          var pp = stack[i-2];
          if(pp.right === p) {
            pp.right = z;
          } else {
            pp.left = z;
          }
        }
        stack[i-1] = z;
        return
      }
      if(s._color === BLACK) {
        if(p._color === RED) {
          //console.log("case 2: black sibling, red parent")
          p._color = BLACK;
          p.left = repaint(RED, s);
          return
        } else {
          //console.log("case 2: black sibling, black parent")
          p.left = repaint(RED, s);
          continue  
        }
      } else {
        //console.log("case 3: red sibling")
        s = cloneNode(s);
        p.left = s.right;
        s.right = p;
        s._color = p._color;
        p._color = RED;
        recount(p);
        recount(s);
        if(i > 1) {
          var pp = stack[i-2];
          if(pp.right === p) {
            pp.right = s;
          } else {
            pp.left = s;
          }
        }
        stack[i-1] = s;
        stack[i] = p;
        if(i+1 < stack.length) {
          stack[i+1] = n;
        } else {
          stack.push(n);
        }
        i = i+2;
      }
    }
  }
}

//Removes item at iterator from tree
iproto.remove = function() {
  var stack = this._stack;
  if(stack.length === 0) {
    return this.tree
  }
  //First copy path to node
  var cstack = new Array(stack.length);
  var n = stack[stack.length-1];
  cstack[cstack.length-1] = new RBNode(n._color, n.key, n.value, n.left, n.right, n._count);
  for(var i=stack.length-2; i>=0; --i) {
    var n = stack[i];
    if(n.left === stack[i+1]) {
      cstack[i] = new RBNode(n._color, n.key, n.value, cstack[i+1], n.right, n._count);
    } else {
      cstack[i] = new RBNode(n._color, n.key, n.value, n.left, cstack[i+1], n._count);
    }
  }

  //Get node
  n = cstack[cstack.length-1];
  //console.log("start remove: ", n.value)

  //If not leaf, then swap with previous node
  if(n.left && n.right) {
    //console.log("moving to leaf")

    //First walk to previous leaf
    var split = cstack.length;
    n = n.left;
    while(n.right) {
      cstack.push(n);
      n = n.right;
    }
    //Copy path to leaf
    var v = cstack[split-1];
    cstack.push(new RBNode(n._color, v.key, v.value, n.left, n.right, n._count));
    cstack[split-1].key = n.key;
    cstack[split-1].value = n.value;

    //Fix up stack
    for(var i=cstack.length-2; i>=split; --i) {
      n = cstack[i];
      cstack[i] = new RBNode(n._color, n.key, n.value, n.left, cstack[i+1], n._count);
    }
    cstack[split-1].left = cstack[split];
  }
  //console.log("stack=", cstack.map(function(v) { return v.value }))

  //Remove leaf node
  n = cstack[cstack.length-1];
  if(n._color === RED) {
    //Easy case: removing red leaf
    //console.log("RED leaf")
    var p = cstack[cstack.length-2];
    if(p.left === n) {
      p.left = null;
    } else if(p.right === n) {
      p.right = null;
    }
    cstack.pop();
    for(var i=0; i<cstack.length; ++i) {
      cstack[i]._count--;
    }
    return new RedBlackTree(this.tree._compare, cstack[0])
  } else {
    if(n.left || n.right) {
      //Second easy case:  Single child black parent
      //console.log("BLACK single child")
      if(n.left) {
        swapNode(n, n.left);
      } else if(n.right) {
        swapNode(n, n.right);
      }
      //Child must be red, so repaint it black to balance color
      n._color = BLACK;
      for(var i=0; i<cstack.length-1; ++i) {
        cstack[i]._count--;
      }
      return new RedBlackTree(this.tree._compare, cstack[0])
    } else if(cstack.length === 1) {
      //Third easy case: root
      //console.log("ROOT")
      return new RedBlackTree(this.tree._compare, null)
    } else {
      //Hard case: Repaint n, and then do some nasty stuff
      //console.log("BLACK leaf no children")
      for(var i=0; i<cstack.length; ++i) {
        cstack[i]._count--;
      }
      var parent = cstack[cstack.length-2];
      fixDoubleBlack(cstack);
      //Fix up links
      if(parent.left === n) {
        parent.left = null;
      } else {
        parent.right = null;
      }
    }
  }
  return new RedBlackTree(this.tree._compare, cstack[0])
};

//Returns key
Object.defineProperty(iproto, "key", {
  get: function() {
    if(this._stack.length > 0) {
      return this._stack[this._stack.length-1].key
    }
    return
  },
  enumerable: true
});

//Returns value
Object.defineProperty(iproto, "value", {
  get: function() {
    if(this._stack.length > 0) {
      return this._stack[this._stack.length-1].value
    }
    return
  },
  enumerable: true
});


//Returns the position of this iterator in the sorted list
Object.defineProperty(iproto, "index", {
  get: function() {
    var idx = 0;
    var stack = this._stack;
    if(stack.length === 0) {
      var r = this.tree.root;
      if(r) {
        return r._count
      }
      return 0
    } else if(stack[stack.length-1].left) {
      idx = stack[stack.length-1].left._count;
    }
    for(var s=stack.length-2; s>=0; --s) {
      if(stack[s+1] === stack[s].right) {
        ++idx;
        if(stack[s].left) {
          idx += stack[s].left._count;
        }
      }
    }
    return idx
  },
  enumerable: true
});

//Advances iterator to next element in list
iproto.next = function() {
  var stack = this._stack;
  if(stack.length === 0) {
    return
  }
  var n = stack[stack.length-1];
  if(n.right) {
    n = n.right;
    while(n) {
      stack.push(n);
      n = n.left;
    }
  } else {
    stack.pop();
    while(stack.length > 0 && stack[stack.length-1].right === n) {
      n = stack[stack.length-1];
      stack.pop();
    }
  }
};

//Checks if iterator is at end of tree
Object.defineProperty(iproto, "hasNext", {
  get: function() {
    var stack = this._stack;
    if(stack.length === 0) {
      return false
    }
    if(stack[stack.length-1].right) {
      return true
    }
    for(var s=stack.length-1; s>0; --s) {
      if(stack[s-1].left === stack[s]) {
        return true
      }
    }
    return false
  }
});

//Update value
iproto.update = function(value) {
  var stack = this._stack;
  if(stack.length === 0) {
    throw new Error("Can't update empty node!")
  }
  var cstack = new Array(stack.length);
  var n = stack[stack.length-1];
  cstack[cstack.length-1] = new RBNode(n._color, n.key, value, n.left, n.right, n._count);
  for(var i=stack.length-2; i>=0; --i) {
    n = stack[i];
    if(n.left === stack[i+1]) {
      cstack[i] = new RBNode(n._color, n.key, n.value, cstack[i+1], n.right, n._count);
    } else {
      cstack[i] = new RBNode(n._color, n.key, n.value, n.left, cstack[i+1], n._count);
    }
  }
  return new RedBlackTree(this.tree._compare, cstack[0])
};

//Moves iterator backward one element
iproto.prev = function() {
  var stack = this._stack;
  if(stack.length === 0) {
    return
  }
  var n = stack[stack.length-1];
  if(n.left) {
    n = n.left;
    while(n) {
      stack.push(n);
      n = n.right;
    }
  } else {
    stack.pop();
    while(stack.length > 0 && stack[stack.length-1].left === n) {
      n = stack[stack.length-1];
      stack.pop();
    }
  }
};

//Checks if iterator is at start of tree
Object.defineProperty(iproto, "hasPrev", {
  get: function() {
    var stack = this._stack;
    if(stack.length === 0) {
      return false
    }
    if(stack[stack.length-1].left) {
      return true
    }
    for(var s=stack.length-1; s>0; --s) {
      if(stack[s-1].right === stack[s]) {
        return true
      }
    }
    return false
  }
});

//Default comparison function
function defaultCompare$1(a, b) {
  if(a < b) {
    return -1
  }
  if(a > b) {
    return 1
  }
  return 0
}

//Build a tree
function createRBTree(compare) {
  return new RedBlackTree(compare || defaultCompare$1, null)
}

var edge_type = {
  NORMAL:               0,
  NON_CONTRIBUTING:     1,
  SAME_TRANSITION:      2,
  DIFFERENT_TRANSITION: 3
};

/**
 * Signed area of the triangle (p0, p1, p2)
 * @param  {Array.<Number>} p0
 * @param  {Array.<Number>} p1
 * @param  {Array.<Number>} p2
 * @return {Number}
 */
var signed_area = function signedArea(p0, p1, p2) {
  return (p0[0] - p2[0]) * (p1[1] - p2[1]) - (p1[0] - p2[0]) * (p0[1] - p2[1]);
};

/**
 * Sweepline event
 *
 * @param {Array.<Number>}  point
 * @param {Boolean}         left
 * @param {SweepEvent=}     otherEvent
 * @param {Boolean}         isSubject
 * @param {Number}          edgeType
 */
function SweepEvent(point, left, otherEvent, isSubject, edgeType) {

  /**
   * Is left endpoint?
   * @type {Boolean}
   */
  this.left = left;

  /**
   * @type {Array.<Number>}
   */
  this.point = point;

  /**
   * Other edge reference
   * @type {SweepEvent}
   */
  this.otherEvent = otherEvent;

  /**
   * Belongs to source or clipping polygon
   * @type {Boolean}
   */
  this.isSubject = isSubject;

  /**
   * Edge contribution type
   * @type {Number}
   */
  this.type = edgeType || edge_type.NORMAL;


  /**
   * In-out transition for the sweepline crossing polygon
   * @type {Boolean}
   */
  this.inOut = false;


  /**
   * @type {Boolean}
   */
  this.otherInOut = false;

  /**
   * Previous event in result?
   * @type {SweepEvent}
   */
  this.prevInResult = null;

  /**
   * Does event belong to result?
   * @type {Boolean}
   */
  this.inResult = false;


  // connection step

  /**
   * @type {Boolean}
   */
  this.resultInOut = false;

  this.isExteriorRing = true;
}


SweepEvent.prototype = {

  /**
   * @param  {Array.<Number>}  p
   * @return {Boolean}
   */
  isBelow: function (p) {
    return this.left ?
      signed_area(this.point, this.otherEvent.point, p) > 0 :
      signed_area(this.otherEvent.point, this.point, p) > 0;
  },


  /**
   * @param  {Array.<Number>}  p
   * @return {Boolean}
   */
  isAbove: function (p) {
    return !this.isBelow(p);
  },


  /**
   * @return {Boolean}
   */
  isVertical: function () {
    return this.point[0] === this.otherEvent.point[0];
  }
};

var sweep_event = SweepEvent;

// var equals = require('./equals');

/**
 * @param  {SweepEvent} e1
 * @param  {SweepEvent} e2
 * @return {Number}
 */
var compare_events = function sweepEventsComp(e1, e2) {
  var p1 = e1.point;
  var p2 = e2.point;

  // Different x-coordinate
  if (p1[0] > p2[0]) return 1;
  if (p1[0] < p2[0]) return -1;

  // Different points, but same x-coordinate
  // Event with lower y-coordinate is processed first
  if (p1[1] !== p2[1]) return p1[1] > p2[1] ? 1 : -1;

  return specialCases(e1, e2, p1, p2);
};

/* eslint-disable no-unused-vars */
function specialCases(e1, e2, p1, p2) {
  // Same coordinates, but one is a left endpoint and the other is
  // a right endpoint. The right endpoint is processed first
  if (e1.left !== e2.left)
    return e1.left ? 1 : -1;

  // Same coordinates, both events
  // are left endpoints or right endpoints.
  // not collinear
  if (signed_area(p1, e1.otherEvent.point, e2.otherEvent.point) !== 0) {
    // the event associate to the bottom segment is processed first
    return (!e1.isBelow(e2.otherEvent.point)) ? 1 : -1;
  }

  // uncomment this if you want to play with multipolygons
  // if (e1.isSubject === e2.isSubject) {
  //   if(equals(e1.point, e2.point) && e1.contourId === e2.contourId) {
  //     return 0;
  //   } else {
  //     return e1.contourId > e2.contourId ? 1 : -1;
  //   }
  // }

  return (!e1.isSubject && e2.isSubject) ? 1 : -1;
}

// var EPSILON = 1e-9;
// var abs = Math.abs;

var equals = function equals(p1, p2) {
  return p1[0] === p2[0] && p1[1] === p2[1];
};

/**
 * @param  {SweepEvent} le1
 * @param  {SweepEvent} le2
 * @return {Number}
 */
var compare_segments = function compareSegments(le1, le2) {
  if (le1 === le2) return 0;

  // Segments are not collinear
  if (signed_area(le1.point, le1.otherEvent.point, le2.point) !== 0 ||
    signed_area(le1.point, le1.otherEvent.point, le2.otherEvent.point) !== 0) {

    // If they share their left endpoint use the right endpoint to sort
    if (equals(le1.point, le2.point)) return le1.isBelow(le2.otherEvent.point) ? -1 : 1;

    // Different left endpoint: use the left endpoint to sort
    if (le1.point[0] === le2.point[0]) return le1.point[1] < le2.point[1] ? -1 : 1;

    // has the line segment associated to e1 been inserted
    // into S after the line segment associated to e2 ?
    if (compare_events(le1, le2) === 1) return le2.isAbove(le1.point) ? -1 : 1;

    // The line segment associated to e2 has been inserted
    // into S after the line segment associated to e1
    return le1.isBelow(le2.point) ? -1 : 1;
  }

  if (le1.isSubject === le2.isSubject) { // same polygon
    if (equals(le1.point, le2.point)) {
      if (equals(le1.otherEvent.point, le2.otherEvent.point)) {
        return 0;
      } else {
        return le1.contourId > le2.contourId ? 1 : -1;
      }
    }
  } else { // Segments are collinear, but belong to separate polygons
    return le1.isSubject ? -1 : 1;
  }

  return compare_events(le1, le2) === 1 ? 1 : -1;
};

var EPSILON = 1e-9;

/**
 * Finds the magnitude of the cross product of two vectors (if we pretend
 * they're in three dimensions)
 *
 * @param {Object} a First vector
 * @param {Object} b Second vector
 * @private
 * @returns {Number} The magnitude of the cross product
 */
function crossProduct(a, b) {
  return a[0] * b[1] - a[1] * b[0];
}

/**
 * Finds the dot product of two vectors.
 *
 * @param {Object} a First vector
 * @param {Object} b Second vector
 * @private
 * @returns {Number} The dot product
 */
function dotProduct(a, b) {
  return a[0] * b[0] + a[1] * b[1];
}

/**
 * Finds the intersection (if any) between two line segments a and b, given the
 * line segments' end points a1, a2 and b1, b2.
 *
 * This algorithm is based on Schneider and Eberly.
 * http://www.cimec.org.ar/~ncalvo/Schneider_Eberly.pdf
 * Page 244.
 *
 * @param {Array.<Number>} a1 point of first line
 * @param {Array.<Number>} a2 point of first line
 * @param {Array.<Number>} b1 point of second line
 * @param {Array.<Number>} b2 point of second line
 * @param {Boolean=}       noEndpointTouch whether to skip single touchpoints
 *                                         (meaning connected segments) as
 *                                         intersections
 * @returns {Array.<Array.<Number>>|Null} If the lines intersect, the point of
 * intersection. If they overlap, the two end points of the overlapping segment.
 * Otherwise, null.
 */
var segment_intersection = function (a1, a2, b1, b2, noEndpointTouch) {
  // The algorithm expects our lines in the form P + sd, where P is a point,
  // s is on the interval [0, 1], and d is a vector.
  // We are passed two points. P can be the first point of each pair. The
  // vector, then, could be thought of as the distance (in x and y components)
  // from the first point to the second point.
  // So first, let's make our vectors:
  var va = [a2[0] - a1[0], a2[1] - a1[1]];
  var vb = [b2[0] - b1[0], b2[1] - b1[1]];
  // We also define a function to convert back to regular point form:

  /* eslint-disable arrow-body-style */

  function toPoint(p, s, d) {
    return [
      p[0] + s * d[0],
      p[1] + s * d[1]
    ];
  }

  /* eslint-enable arrow-body-style */

  // The rest is pretty much a straight port of the algorithm.
  var e = [b1[0] - a1[0], b1[1] - a1[1]];
  var kross    = crossProduct(va, vb);
  var sqrKross = kross * kross;
  var sqrLenA  = dotProduct(va, va);
  var sqrLenB  = dotProduct(vb, vb);

  // Check for line intersection. This works because of the properties of the
  // cross product -- specifically, two vectors are parallel if and only if the
  // cross product is the 0 vector. The full calculation involves relative error
  // to account for possible very small line segments. See Schneider & Eberly
  // for details.
  if (sqrKross > EPSILON * sqrLenA * sqrLenB) {
    // If they're not parallel, then (because these are line segments) they
    // still might not actually intersect. This code checks that the
    // intersection point of the lines is actually on both line segments.
    var s = crossProduct(e, vb) / kross;
    if (s < 0 || s > 1) {
      // not on line segment a
      return null;
    }
    var t = crossProduct(e, va) / kross;
    if (t < 0 || t > 1) {
      // not on line segment b
      return null;
    }
    return noEndpointTouch ? null : [toPoint(a1, s, va)];
  }

  // If we've reached this point, then the lines are either parallel or the
  // same, but the segments could overlap partially or fully, or not at all.
  // So we need to find the overlap, if any. To do that, we can use e, which is
  // the (vector) difference between the two initial points. If this is parallel
  // with the line itself, then the two lines are the same line, and there will
  // be overlap.
  var sqrLenE = dotProduct(e, e);
  kross = crossProduct(e, va);
  sqrKross = kross * kross;

  if (sqrKross > EPSILON * sqrLenA * sqrLenE) {
    // Lines are just parallel, not the same. No overlap.
    return null;
  }

  var sa = dotProduct(va, e) / sqrLenA;
  var sb = sa + dotProduct(va, vb) / sqrLenA;
  var smin = Math.min(sa, sb);
  var smax = Math.max(sa, sb);

  // this is, essentially, the FindIntersection acting on floats from
  // Schneider & Eberly, just inlined into this function.
  if (smin <= 1 && smax >= 0) {

    // overlap on an end point
    if (smin === 1) {
      return noEndpointTouch ? null : [toPoint(a1, smin > 0 ? smin : 0, va)];
    }

    if (smax === 0) {
      return noEndpointTouch ? null : [toPoint(a1, smax < 1 ? smax : 1, va)];
    }

    if (noEndpointTouch && smin === 0 && smax === 1) return null;

    // There's overlap on a segment -- two points of intersection. Return both.
    return [
      toPoint(a1, smin > 0 ? smin : 0, va),
      toPoint(a1, smax < 1 ? smax : 1, va),
    ];
  }

  return null;
};

var INTERSECTION = 0;
var UNION = 1;
var DIFFERENCE = 2;
var XOR = 3;
var EMPTY = [];

var max = Math.max;
var min = Math.min;

/**
 * @param  {Array<Number>} s1
 * @param  {Array<Number>} s2
 * @param  {Boolean}         isSubject
 * @param  {Queue}           eventQueue
 * @param  {Array<Number>}  bbox
 */
function processSegment(s1, s2, isSubject, depth, eventQueue, bbox, isExteriorRing) {
  // Possible degenerate condition.
  // if (equals(s1, s2)) return;

  var e1 = new sweep_event(s1, false, undefined, isSubject);
  var e2 = new sweep_event(s2, false, e1,        isSubject);
  e1.otherEvent = e2;

  e1.contourId = e2.contourId = depth;
  if (!isExteriorRing) {
    e1.isExteriorRing = false;
    e2.isExteriorRing = false;
  }
  if (compare_events(e1, e2) > 0) {
    e2.left = true;
  } else {
    e1.left = true;
  }

  bbox[0] = min(bbox[0], s1[0]);
  bbox[1] = min(bbox[1], s1[1]);
  bbox[2] = max(bbox[2], s1[0]);
  bbox[3] = max(bbox[3], s1[1]);

  // Pushing it so the queue is sorted from left to right,
  // with object on the left having the highest priority.
  eventQueue.push(e1);
  eventQueue.push(e2);
}

var contourId = 0;

function processPolygon(contourOrHole, isSubject, depth, queue, bbox, isExteriorRing) {
  var i, len;
  for (i = 0, len = contourOrHole.length - 1; i < len; i++) {
    processSegment(contourOrHole[i], contourOrHole[i + 1], isSubject, depth + 1, queue, bbox, isExteriorRing);
  }
}

function fillQueue(subject, clipping, sbbox, cbbox) {
  var eventQueue = new tinyqueue(null, compare_events);
  var polygonSet, isExteriorRing, i, ii, j, jj;

  for (i = 0, ii = subject.length; i < ii; i++) {
    polygonSet = subject[i];
    for (j = 0, jj = polygonSet.length; j < jj; j++) {
      isExteriorRing = j === 0;
      if (isExteriorRing) contourId++;
      processPolygon(polygonSet[j], true, contourId, eventQueue, sbbox, isExteriorRing);
    }
  }

  for (i = 0, ii = clipping.length; i < ii; i++) {
    polygonSet = clipping[i];
    for (j = 0, jj = polygonSet.length; j < jj; j++) {
      isExteriorRing = j === 0;
      if (isExteriorRing) contourId++;
      processPolygon(polygonSet[j], false, contourId, eventQueue, cbbox, isExteriorRing);
    }
  }

  return eventQueue;
}


/**
 * @param  {SweepEvent} event
 * @param  {SweepEvent} prev
 * @param  {Tree} sweepLine
 * @param  {Operation} operation
 * @return {[type]}
 */
function computeFields(event, prev, operation) {
  // compute inOut and otherInOut fields
  if (prev === null) {
    event.inOut      = false;
    event.otherInOut = true;

  // previous line segment in sweepline belongs to the same polygon
  } else {
    if (event.isSubject === prev.isSubject) {
      event.inOut      = !prev.inOut;
      event.otherInOut = prev.otherInOut;

    // previous line segment in sweepline belongs to the clipping polygon
    } else {
      event.inOut      = !prev.otherInOut;
      event.otherInOut = prev.isVertical() ? !prev.inOut : prev.inOut;
    }

    // compute prevInResult field
    if (prev) {
      event.prevInResult = (!inResult(prev, operation) || prev.isVertical()) ?
         prev.prevInResult : prev;
    }
  }

  // check if the line segment belongs to the Boolean operation
  event.inResult = inResult(event, operation);
}


function inResult(event, operation) {
  switch (event.type) {
  case edge_type.NORMAL:
    switch (operation) {
    case INTERSECTION:
      return !event.otherInOut;
    case UNION:
      return event.otherInOut;
    case DIFFERENCE:
      return (event.isSubject && event.otherInOut) ||
              (!event.isSubject && !event.otherInOut);
    case XOR:
      return true;
    }
    break;
  case edge_type.SAME_TRANSITION:
    return operation === INTERSECTION || operation === UNION;
  case edge_type.DIFFERENT_TRANSITION:
    return operation === DIFFERENCE;
  case edge_type.NON_CONTRIBUTING:
    return false;
  }
  return false;
}


/**
 * @param  {SweepEvent} se1
 * @param  {SweepEvent} se2
 * @param  {Queue}      queue
 * @return {Number}
 */
function possibleIntersection(se1, se2, queue) {
  // that disallows self-intersecting polygons,
  // did cost us half a day, so I'll leave it
  // out of respect
  // if (se1.isSubject === se2.isSubject) return;
  var inter = segment_intersection(
    se1.point, se1.otherEvent.point,
    se2.point, se2.otherEvent.point
  );

  var nintersections = inter ? inter.length : 0;
  if (nintersections === 0) return 0; // no intersection

  // the line segments intersect at an endpoint of both line segments
  if ((nintersections === 1) &&
      (equals(se1.point, se2.point) ||
       equals(se1.otherEvent.point, se2.otherEvent.point))) {
    return 0;
  }

  if (nintersections === 2 && se1.isSubject === se2.isSubject) {
    // if(se1.contourId === se2.contourId){
    // console.warn('Edges of the same polygon overlap',
    //   se1.point, se1.otherEvent.point, se2.point, se2.otherEvent.point);
    // }
    //throw new Error('Edges of the same polygon overlap');
    return 0;
  }

  // The line segments associated to se1 and se2 intersect
  if (nintersections === 1) {

    // if the intersection point is not an endpoint of se1
    if (!equals(se1.point, inter[0]) && !equals(se1.otherEvent.point, inter[0])) {
      divideSegment(se1, inter[0], queue);
    }

    // if the intersection point is not an endpoint of se2
    if (!equals(se2.point, inter[0]) && !equals(se2.otherEvent.point, inter[0])) {
      divideSegment(se2, inter[0], queue);
    }
    return 1;
  }

  // The line segments associated to se1 and se2 overlap
  var events        = [];
  var leftCoincide  = false;
  var rightCoincide = false;

  if (equals(se1.point, se2.point)) {
    leftCoincide = true; // linked
  } else if (compare_events(se1, se2) === 1) {
    events.push(se2, se1);
  } else {
    events.push(se1, se2);
  }

  if (equals(se1.otherEvent.point, se2.otherEvent.point)) {
    rightCoincide = true;
  } else if (compare_events(se1.otherEvent, se2.otherEvent) === 1) {
    events.push(se2.otherEvent, se1.otherEvent);
  } else {
    events.push(se1.otherEvent, se2.otherEvent);
  }

  if ((leftCoincide && rightCoincide) || leftCoincide) {
    // both line segments are equal or share the left endpoint
    se1.type = edge_type.NON_CONTRIBUTING;
    se2.type = (se1.inOut === se2.inOut) ?
      edge_type.SAME_TRANSITION :
      edge_type.DIFFERENT_TRANSITION;

    if (leftCoincide && !rightCoincide) {
      // honestly no idea, but changing events selection from [2, 1]
      // to [0, 1] fixes the overlapping self-intersecting polygons issue
      divideSegment(events[1].otherEvent, events[0].point, queue);
    }
    return 2;
  }

  // the line segments share the right endpoint
  if (rightCoincide) {
    divideSegment(events[0], events[1].point, queue);
    return 3;
  }

  // no line segment includes totally the other one
  if (events[0] !== events[3].otherEvent) {
    divideSegment(events[0], events[1].point, queue);
    divideSegment(events[1], events[2].point, queue);
    return 3;
  }

  // one line segment includes the other one
  divideSegment(events[0], events[1].point, queue);
  divideSegment(events[3].otherEvent, events[2].point, queue);

  return 3;
}


/**
 * @param  {SweepEvent} se
 * @param  {Array.<Number>} p
 * @param  {Queue} queue
 * @return {Queue}
 */
function divideSegment(se, p, queue)  {
  var r = new sweep_event(p, false, se,            se.isSubject);
  var l = new sweep_event(p, true,  se.otherEvent, se.isSubject);

  if (equals(se.point, se.otherEvent.point)) {
    console.warn('what is that?', se);
  }

  r.contourId = l.contourId = se.contourId;

  // avoid a rounding error. The left event would be processed after the right event
  if (compare_events(l, se.otherEvent) > 0) {
    se.otherEvent.left = true;
    l.left = false;
  }

  // avoid a rounding error. The left event would be processed after the right event
  // if (compareEvents(se, r) > 0) {}

  se.otherEvent.otherEvent = l;
  se.otherEvent = r;

  queue.push(l);
  queue.push(r);

  return queue;
}
/* eslint-enable no-unused-vars, no-debugger, no-undef */


function subdivideSegments(eventQueue, subject, clipping, sbbox, cbbox, operation) {
  var sweepLine = new rbtree(compare_segments);
  var sortedEvents = [];

  var rightbound = min(sbbox[2], cbbox[2]);

  var prev, next;

  while (eventQueue.length) {
    var event = eventQueue.pop();
    sortedEvents.push(event);

    // optimization by bboxes for intersection and difference goes here
    if ((operation === INTERSECTION && event.point[0] > rightbound) ||
        (operation === DIFFERENCE   && event.point[0] > sbbox[2])) {
      break;
    }

    if (event.left) {
      sweepLine = sweepLine.insert(event);
      //_renderSweepLine(sweepLine, event.point, event);

      next = sweepLine.find(event);
      prev = sweepLine.find(event);
      event.iterator = sweepLine.find(event);

      if (prev.node !== sweepLine.begin) {
        prev.prev();
      } else {
        prev = sweepLine.begin;
        prev.prev();
        prev.next();
      }
      next.next();

      var prevEvent = (prev.key || null), prevprevEvent;
      computeFields(event, prevEvent, operation);
      if (next.node) {
        if (possibleIntersection(event, next.key, eventQueue) === 2) {
          computeFields(event, prevEvent, operation);
          computeFields(event, next.key, operation);
        }
      }

      if (prev.node) {
        if (possibleIntersection(prev.key, event, eventQueue) === 2) {
          var prevprev = sweepLine.find(prev.key);
          if (prevprev.node !== sweepLine.begin) {
            prevprev.prev();
          } else {
            prevprev = sweepLine.find(sweepLine.end);
            prevprev.next();
          }
          prevprevEvent = prevprev.key || null;
          computeFields(prevEvent, prevprevEvent, operation);
          computeFields(event, prevEvent, operation);
        }
      }
    } else {
      event = event.otherEvent;
      next = sweepLine.find(event);
      prev = sweepLine.find(event);

      // _renderSweepLine(sweepLine, event.otherEvent.point, event);

      if (!(prev && next)) continue;

      if (prev.node !== sweepLine.begin) {
        prev.prev();
      } else {
        prev = sweepLine.begin;
        prev.prev();
        prev.next();
      }
      next.next();
      sweepLine = sweepLine.remove(event);

      // _renderSweepLine(sweepLine, event.otherEvent.point, event);

      if (next.node && prev.node) {
        if (typeof prev.node.value !== 'undefined' && typeof next.node.value !== 'undefined') {
          possibleIntersection(prev.key, next.key, eventQueue);
        }
      }
    }
  }
  return sortedEvents;
}


/**
 * @param  {Array.<SweepEvent>} sortedEvents
 * @return {Array.<SweepEvent>}
 */
function orderEvents(sortedEvents) {
  var event, i, len, tmp;
  var resultEvents = [];
  for (i = 0, len = sortedEvents.length; i < len; i++) {
    event = sortedEvents[i];
    if ((event.left && event.inResult) ||
      (!event.left && event.otherEvent.inResult)) {
      resultEvents.push(event);
    }
  }

  // Due to overlapping edges the resultEvents array can be not wholly sorted
  var sorted = false;
  while (!sorted) {
    sorted = true;
    for (i = 0, len = resultEvents.length; i < len; i++) {
      if ((i + 1) < len &&
        compare_events(resultEvents[i], resultEvents[i + 1]) === 1) {
        tmp = resultEvents[i];
        resultEvents[i] = resultEvents[i + 1];
        resultEvents[i + 1] = tmp;
        sorted = false;
      }
    }
  }

  for (i = 0, len = resultEvents.length; i < len; i++) {
    resultEvents[i].pos = i;
  }

  for (i = 0, len = resultEvents.length; i < len; i++) {
    if (!resultEvents[i].left) {
      var temp = resultEvents[i].pos;
      resultEvents[i].pos = resultEvents[i].otherEvent.pos;
      resultEvents[i].otherEvent.pos = temp;
    }
  }

  return resultEvents;
}


/**
 * @param  {Array.<SweepEvent>} sortedEvents
 * @return {Array.<*>} polygons
 */
function connectEdges(sortedEvents) {
  var i, len;
  var resultEvents = orderEvents(sortedEvents);

  // "false"-filled array
  var processed = new Array(resultEvents.length);
  var result = [];

  for (i = 0, len = resultEvents.length; i < len; i++) {
    if (processed[i]) continue;
    var contour = [[]];

    if (!resultEvents[i].isExteriorRing) {
      result[result.length - 1].push([contour]);
    } else {
      result.push(contour);
    }

    var ringId = result.length - 1;
    var pos = i;

    var initial = resultEvents[i].point;
    // initial.push(resultEvents[i].isExteriorRing);
    contour[0].push(initial);

    while (pos >= i) {
      processed[pos] = true;

      if (resultEvents[pos].left) {
        resultEvents[pos].resultInOut = false;
        resultEvents[pos].contourId   = ringId;
      } else {
        resultEvents[pos].otherEvent.resultInOut = true;
        resultEvents[pos].otherEvent.contourId   = ringId;
      }

      pos = resultEvents[pos].pos;
      processed[pos] = true;
      // resultEvents[pos].point.push(resultEvents[pos].isExteriorRing);

      contour[0].push(resultEvents[pos].point);
      pos = nextPos(pos, resultEvents, processed);
    }

    pos = pos === -1 ? i : pos;

    processed[pos] = processed[resultEvents[pos].pos] = true;
    resultEvents[pos].otherEvent.resultInOut = true;
    resultEvents[pos].otherEvent.contourId   = ringId;
  }

  for (i = 0, len = result.length; i < len; i++) {
    var polygon = result[i];
    for (var j = 0, jj = polygon.length; j < jj; j++) {
      var polygonContour = polygon[j];
      for (var k = 0, kk = polygonContour.length; k < kk; k++) {
        var coords = polygonContour[k];
        if (typeof coords[0] !== 'number') {
          polygon.push(coords[0]);
          polygon.splice(j, 1);
        }
      }
    }
  }

  return result;
}


/**
 * @param  {Number} pos
 * @param  {Array.<SweepEvent>} resultEvents
 * @param  {Array.<Boolean>}    processed
 * @return {Number}
 */
function nextPos(pos, resultEvents, processed) {
  var newPos = pos + 1;
  var length = resultEvents.length;
  while (newPos < length &&
         equals(resultEvents[newPos].point, resultEvents[pos].point)) {
    if (!processed[newPos]) {
      return newPos;
    } else {
      newPos = newPos + 1;
    }
  }

  newPos = pos - 1;

  while (processed[newPos]) {
    newPos = newPos - 1;
  }
  return newPos;
}


function trivialOperation(subject, clipping, operation) {
  var result = null;
  if (subject.length * clipping.length === 0) {
    if (operation === INTERSECTION) {
      result = EMPTY;
    } else if (operation === DIFFERENCE) {
      result = subject;
    } else if (operation === UNION || operation === XOR) {
      result = (subject.length === 0) ? clipping : subject;
    }
  }
  return result;
}


function compareBBoxes(subject, clipping, sbbox, cbbox, operation) {
  var result = null;
  if (sbbox[0] > cbbox[2] ||
      cbbox[0] > sbbox[2] ||
      sbbox[1] > cbbox[3] ||
      cbbox[1] > sbbox[3]) {
    if (operation === INTERSECTION) {
      result = EMPTY;
    } else if (operation === DIFFERENCE) {
      result = subject;
    } else if (operation === UNION || operation === XOR) {
      result = subject.concat(clipping);
    }
  }
  return result;
}


function boolean(subject, clipping, operation) {
  if (typeof subject[0][0][0] === 'number') {
    subject = [subject];
  }
  if (typeof clipping[0][0][0] === 'number') {
    clipping = [clipping];
  }
  var trivial = trivialOperation(subject, clipping, operation);
  if (trivial) {
    return trivial === EMPTY ? null : trivial;
  }
  var sbbox = [Infinity, Infinity, -Infinity, -Infinity];
  var cbbox = [Infinity, Infinity, -Infinity, -Infinity];

  var eventQueue = fillQueue(subject, clipping, sbbox, cbbox);

  trivial = compareBBoxes(subject, clipping, sbbox, cbbox, operation);
  if (trivial) {
    return trivial === EMPTY ? null : trivial;
  }
  var sortedEvents = subdivideSegments(eventQueue, subject, clipping, sbbox, cbbox, operation);
  return connectEdges(sortedEvents);
}


var src = boolean;


var union = function (subject, clipping) {
  return boolean(subject, clipping, UNION);
};


var diff = function (subject, clipping) {
  return boolean(subject, clipping, DIFFERENCE);
};


var xor = function (subject, clipping) {
  return boolean(subject, clipping, XOR);
};


var intersection_1 = function (subject, clipping) {
  return boolean(subject, clipping, INTERSECTION);
};


/**
 * @enum {Number}
 */
var operations = {
  INTERSECTION: INTERSECTION,
  DIFFERENCE: DIFFERENCE,
  UNION: UNION,
  XOR: XOR
};


// for testing
var fillQueue_1            = fillQueue;
var computeFields_1        = computeFields;
var subdivideSegments_1    = subdivideSegments;
var divideSegment_1        = divideSegment;
var possibleIntersection_1 = possibleIntersection;
src.union = union;
src.diff = diff;
src.xor = xor;
src.intersection = intersection_1;
src.operations = operations;
src.fillQueue = fillQueue_1;
src.computeFields = computeFields_1;
src.subdivideSegments = subdivideSegments_1;
src.divideSegment = divideSegment_1;
src.possibleIntersection = possibleIntersection_1;

var martinezPolygonClipping = {
  union: src.union,
  diff: src.diff,
  xor: src.xor,
  intersection: src.intersection
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

/**
 * Options for static view of layers. A {@link LayerHoverOption} takes
 * priority over a view option.
 *
 * @name LayerViewOption
 * @global
 * @namespace
 * @readonly
 */
var LayerViewOption = {
  /**
   * View all layers compositing together.
   * @memberOf LayerViewOption
   * @since 0.2.0
   */
  all: 'all',

  /**
   * View current layer only.
   * @memberOf LayerViewOption
   * @since 0.2.0
   */
  current: 'current',

  /**
   * Highlight layer in front of others.
   * @memberOf LayerViewOption
   * @since 0.2.0
   */
  highlight: 'highlight',

  /**
   * View no layers.
   * @memberOf LayerViewOption
   * @since 0.2.0
   */
  none: 'none'
};

/**
 * Options for dynamic view of layers - mouse events change the highlighted layer
 *
 * @name LayerHoverOption
 * @global
 * @namespace
 * @readonly
 */
var LayerHoverOption = {
  /**
   * View single layer under cursor.
   * @memberOf LayerHoverOption
   * @since 0.2.0
   */
  single: 'single',

  /**
   * View layer under cursor as highlighted.
   * @memberOf LayerHoverOption
   * @since 0.2.0
   */
  highlight: 'highlight',

  /**
   * Don't hover, instead use {@link LayerViewOption}.
   * @memberOf LayerHoverOption
   * @since 0.2.0
   */
  none: 'none'
};

function Point() {
  if (arguments.length === 0) {
    this.x = 0;
    this.y = 0;
  } else if (arguments.length === 1) {
    if (arguments[0].hasOwnProperty('x') && arguments[0].hasOwnProperty('y')) {
      this.x = arguments[0].x;
      this.y = arguments[0].y;
    } else {
      this.x = arguments[0];
      this.y = arguments[0];
    }
  } else if (arguments.length === 2) {
    this.x = arguments[0];
    this.y = arguments[1];
  } else {
    throw new Error('invalid constructor');
  }
}

Point.prototype.minus = function (p) {
  var point = p instanceof Point ? p : new Point(p);
  return new Point(this.x - point.x, this.y - point.y);
};

Point.prototype.add = function (p) {
  var point = p instanceof Point ? p : new Point(p);
  return new Point(this.x + point.x, this.y + point.y);
};

Point.prototype.multiply = function (p) {
  var point = p instanceof Point ? p : new Point(p);
  return new Point(this.x * point.x, this.y * point.y);
};

Point.prototype.divide = function (p) {
  var point = p instanceof Point ? p : new Point(p);
  return new Point(this.x / point.x, this.y / point.y);
};

Point.prototype.shift = function () {
  if (arguments.length === 1) {
    if (arguments[0].hasOwnProperty('x') && arguments[0].hasOwnProperty('y')) {
      this.x += arguments[0].x;
      this.y += arguments[0].y;
    } else {
      this.x += arguments[0];
      this.y += arguments[0];
    }
  } else if (arguments.length === 2) {
    this.x += arguments[0];
    this.y += arguments[1];
  }

  return this;
};

Point.prototype.scale = function () {
  if (arguments.length === 1) {
    this.x *= arguments[0];
    this.y *= arguments[0];
  } else if (arguments.length === 2) {
    this.x *= arguments[0];
    this.y *= arguments[1];
  }

  return this;
};

Point.prototype.moveTo = function () {
  if (arguments.length === 1) {
    this.x = arguments[0].x;
    this.y = arguments[0].y;
  } else if (arguments.length === 2) {
    this.x = arguments[0];
    this.y = arguments[1];
  }

  return this;
};

Point.prototype.equals = function (point) {
  return this.x == point.x && this.y == point.y;
};

Point.prototype.clone = function () {
  return new Point(this.x, this.y);
};

Point.prototype.getRaw = function () {
  return { x: this.x, y: this.y };
};

function Polygon() {
  if (arguments.length === 0) {
    this.points = [];
    this.holes = [];
  } else if (arguments.length === 1) {
    if (Array.isArray(arguments[0])) {
      // Polygon([points])
      this.points = arguments[0].map(clonePoint);
      this.holes = [];
    } else if (Array.isArray(arguments[0].points) && Array.isArray(arguments[0].holes)) {
      // Polygon({points:[], holes:[]})
      this.points = arguments[0].points.map(clonePoint);
      this.holes = arguments[0].holes.map(clonePolygon);
    } else {
      throw new Error('invalid constructor');
    }
  } else if (arguments.length === 2) {
    // Polygon([points], [holes])
    this.points = arguments[0].map(clonePoint);
    this.holes = arguments[1].map(clonePolygon);
  } else {
    throw new Error('invalid constructor');
  }

  // meant to imply that polygon should not "close" when being shown (svg Z command)
  // almost always, don't touch this
  this.closePath = true;
  // used to flag polygons that have a curve under some conditions
  this.isCurve = false;
}

Polygon.prototype.minus = function (p) {
  p = p instanceof Point ? p : new Point(p);
  var polygon = new Polygon();

  polygon.points = this.points.map(function (point) {
    return point.minus(p);
  });

  polygon.holes = this.holes.map(function (hole) {
    return hole.minus(p);
  });

  return polygon;
};

Polygon.prototype.add = function (p) {
  p = p instanceof Point ? p : new Point(p);
  var polygon = new Polygon();

  polygon.points = this.points.map(function (point) {
    return point.add(p);
  });

  polygon.holes = this.holes.map(function (hole) {
    return hole.add(p);
  });

  return polygon;
};

Polygon.prototype.multiply = function (p) {
  p = p instanceof Point ? p : new Point(p);
  var polygon = new Polygon();

  polygon.points = this.points.map(function (point) {
    return point.multiply(p);
  });

  polygon.holes = this.holes.map(function (hole) {
    return hole.multiply(p);
  });

  return polygon;
};

Polygon.prototype.divide = function (p) {
  p = p instanceof Point ? p : new Point(p);
  var polygon = new Polygon();

  polygon.points = this.points.map(function (point) {
    return point.divide(p);
  });

  polygon.holes = this.holes.map(function (hole) {
    return hole.divide(p);
  });

  return polygon;
};

Polygon.prototype.shift = function () {
  var args = arguments;

  this.points.forEach(function (point) {
    point.shift.apply(point, toConsumableArray(args));
  });

  this.holes.forEach(function (hole) {
    hole.shift.apply(hole, toConsumableArray(args));
  });

  return this;
};

Polygon.prototype.scale = function () {
  var args = arguments;

  this.points.forEach(function (point) {
    point.scale.apply(point, toConsumableArray(args));
  });

  this.holes.forEach(function (hole) {
    hole.scale.apply(hole, toConsumableArray(args));
  });

  return this;
};

Polygon.prototype.isClockwise = function () {
  var x1 = void 0,
      y1 = void 0,
      x2 = void 0,
      y2 = void 0,
      area = 0;
  for (var i = 0; i < this.points.length; i++) {
    x1 = this.points[i].x;
    y1 = this.points[i].y;
    if (i < this.points.length - 1) {
      x2 = this.points[i + 1].x;
      y2 = this.points[i + 1].y;
    } else {
      x2 = this.points[0].x;
      y2 = this.points[0].y;
    }
    area += x1 * y2 - x2 * y1;
  }

  return area >= 0;
};

Polygon.prototype.setCurve = function (isCurve) {
  if (isCurve) {
    this.isCurve = isCurve;
  } else {
    this.isCurve = false;
  }

  return this;
};

Polygon.prototype.bbox = function () {
  var left = -1,
      right = -1,
      top = -1,
      bottom = -1;

  (function bbox(polygon) {
    polygon.points.forEach(function (point) {
      left = left == -1 ? point.x : Math.min(left, point.x);
      right = right == -1 ? point.x : Math.max(right, point.x);
      top = top == -1 ? point.y : Math.min(top, point.y);
      bottom = bottom == -1 ? point.y : Math.max(bottom, point.y);
    });

    polygon.holes.forEach(bbox);
  })(this);

  return {
    x: left,
    y: top,
    width: right - left,
    height: bottom - top
  };
};

Polygon.prototype.centroid = function () {
  var bbox = this.bbox();
  return new Point(bbox.x + bbox.width / 2, bbox.y + bbox.height / 2);
};

Polygon.prototype.overlaps = function (polygon) {
  var intersect = martinezPolygonClipping.intersection(toMartinezCoords(this), toMartinezCoords(polygon));
  return intersect ? intersect.length > 0 : false;
};

Polygon.prototype.merge = function (polygon) {
  var union = martinezPolygonClipping.union(toMartinezCoords(this), toMartinezCoords(polygon));
  var result = fromMartinezCoords(union[0]);
  for (var i = 1; i < union.length; i++) {
    if (union[i].length > 1) {
      for (var x = 0; x < union[i].length; x++) {
        result.holes.push(fromMartinezCoords([union[i][x]]));
      }
    } else {
      result.holes.push(fromMartinezCoords(union[i]));
    }
  }

  return result;
};

Polygon.prototype.clip = function (clip) {
  var diff = martinezPolygonClipping.diff(toMartinezCoords(this), toMartinezCoords(clip));

  if (diff.length > 0 && polygonIsInside(clip.points, this.points)) {
    var polygon = fromMartinezCoords(diff[0]);
    for (var i = 1; i < diff.length; i++) {
      if (diff[i].length > 1) {
        // multiple holes like [[polygon], [[hole], [hole]]]
        for (var x = 0; x < diff[i].length; x++) {
          polygon.holes.push(fromMartinezCoords([diff[i][x]]));
        }
      } else {
        // normal holes like [[polygon], [hole], [hole]]
        polygon.holes.push(fromMartinezCoords(diff[i]));
      }
    }

    return [polygon];
  }
  var polygons = [];

  for (var y = 0; y < diff.length; y++) {
    polygons.push(fromMartinezCoords(diff[y]));
  }

  return polygons;
};

Polygon.prototype.pathString = function () {
  function pointsToPathString(polygon, isClockwise) {
    var isCurve = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var points = polygon.points;
    var pathString = 'M';

    if (isCurve && points.length === 3) {
      // 3 point segment in an opening that has a curve and control point
      pathString += ' ' + points[0].x + ' ' + points[0].y + ' Q';
      // control point is the last point in the array (allows fast switching)
      pathString += ' ' + points[points.length - 1].x + ' ' + points[points.length - 1].y;
      for (var i = 1; i < points.length - 1; i++) {
        pathString += ' ' + points[i].x + ' ' + points[i].y;
      }
      // curves are not closed polygons
    } else if (isCurve && points.length === 5) {
      // 5 point shaped opening that has a curve and control point over top line
      pathString += ' ' + points[0].x + ' ' + points[0].y + ' Q';
      // control point is the last point in the array (allows fast switching)
      pathString += ' ' + points[points.length - 1].x + ' ' + points[points.length - 1].y;
      pathString += ' ' + points[1].x + ' ' + points[1].y + ' L';
      for (var _i = 2; _i < points.length - 1; _i++) {
        pathString += ' ' + points[_i].x + ' ' + points[_i].y + ' L';
      }
      // curved shapes are closed polygons
      if (polygon.closePath && points.length) {
        pathString += ' ' + points[0].x + ' ' + points[0].y + ' z';
      }
    } else if (isClockwise) {
      for (var _i2 = 0; _i2 < points.length; _i2++) {
        pathString += ' ' + points[_i2].x + ' ' + points[_i2].y + ' L';
      }

      if (polygon.closePath && points.length) {
        pathString += ' ' + points[0].x + ' ' + points[0].y + ' z';
      }
    } else {
      for (var x = points.length - 1; x >= 0; x--) {
        pathString += ' ' + points[x].x + ' ' + points[x].y + ' L';
      }

      if (polygon.closePath && points.length) {
        pathString += ' ' + points[points.length - 1].x + ' ' + points[points.length - 1].y + ' z';
      }
    }

    return pathString;
  }

  var pathString = pointsToPathString(this, this.isClockwise(), this.isCurve);

  for (var i = 0; i < this.holes.length; i++) {
    var hole = this.holes[i];
    pathString += pointsToPathString(hole, /* reverse points */!hole.isClockwise());
  }

  return pathString;
};

Polygon.prototype.equals = function (polygon) {
  if (polygon.points.length !== this.points.length) {
    return false;
  } else if (polygon.holes.length !== this.holes.length) {
    return false;
  }

  for (var i = 0; i < this.points.length; i++) {
    if (!this.points[i].equals(polygon.points[i])) {
      return false;
    }
  }

  for (var h = 0; h < this.holes.length; h++) {
    if (!this.holes[h].equals(polygon.holes[h])) {
      return false;
    }
  }

  return true;
};

Polygon.prototype.clone = function () {
  return new Polygon(this.points, this.holes);
};

Polygon.prototype.getRaw = function () {
  var getRawPoint = function getRawPoint(point) {
    return point.getRaw();
  };
  return {
    points: this.points.map(getRawPoint),
    holes: this.holes.map(function (holes) {
      return holes.points.map(getRawPoint);
    })
  };
};

// http://stackoverflow.com/a/15182022/1165996
// https://gist.github.com/Joncom/e8e8d18ebe7fe55c3894
Polygon.lineIntersect = function (p0_x, p0_y, p1_x, p1_y, p2_x, p2_y, p3_x, p3_y) {
  var s1_x = void 0,
      s1_y = void 0,
      s2_x = void 0,
      s2_y = void 0;
  s1_x = p1_x - p0_x;
  s1_y = p1_y - p0_y;
  s2_x = p3_x - p2_x;
  s2_y = p3_y - p2_y;

  var s = void 0,
      t = void 0;
  s = (-s1_y * (p0_x - p2_x) + s1_x * (p0_y - p2_y)) / (-s2_x * s1_y + s1_x * s2_y);
  t = (s2_x * (p0_y - p2_y) - s2_y * (p0_x - p2_x)) / (-s2_x * s1_y + s1_x * s2_y);

  if (s >= 0 && s <= 1 && t >= 0 && t <= 1) {
    // Collision detected
    return {
      x: p0_x + t * s1_x,
      y: p0_y + t * s1_y
    };
  }

  return 0; // No collision
};

function Perspective() {
  if (arguments.length === 0) {
    this.contour = new Polygon();
  } else if (arguments.length === 1) {
    if (arguments[0] instanceof Polygon) {
      this.contour = new Polygon(arguments[0]);
    } else if (arguments[0].hasOwnProperty('width') && arguments[0].hasOwnProperty('height')) {
      var layer = arguments[0];
      // add reasonable clockwise 4 point perspective for the passed in project
      // TODO: better initial mask sizing - see CF initFromProjectDimensions()
      this.contour = new Polygon([new Point(layer.width * 0.35, layer.height * 0.35), new Point(layer.width * 0.75, layer.height * 0.35), new Point(layer.width * 0.75, layer.height * 0.70), new Point(layer.width * 0.35, layer.height * 0.70)]);
    } else if (Array.isArray(arguments[0])) {
      this.contour = new Polygon(arguments[0]);
    } else {
      throw new Error('invalid constructor');
    }
  } else {
    throw new Error('invalid constructor');
  }
}

Perspective.prototype.getContour = function () {
  return this.contour.clone();
};

Perspective.getPointsFromTopLeftCorner = function (points) {
  // sweep line partitioning algorithm
  var minY1 = Infinity;
  var minY1Point = void 0;
  var minY2 = Infinity;
  var minY2Point = void 0;
  var maxY1 = 0;
  var maxY1Point = void 0;
  var maxY2 = 0;
  var maxY2Point = void 0;

  // check all points but the last of a 5 point perspective, it is a control point
  var maxIndex = points.length === 6 ? 6 : 4;
  // shortcut scanline sort by y algoithm
  for (var i = 0; i < maxIndex; i++) {
    // get the two point indexes closest to 0,0 in y direction (upper points)
    if (points[i].y < minY1) {
      minY2 = minY1;
      minY2Point = minY1Point;
      minY1 = points[i].y;
      minY1Point = i;
    } else if (points[i].y < minY2) {
      minY2 = points[i].y;
      minY2Point = i;
    }
    // get the two point indexes farthest from 0,0 in y direction (lower points)
    if (points[i].y > maxY1) {
      maxY2 = maxY1;
      maxY2Point = maxY1Point;
      maxY1 = points[i].y;
      maxY1Point = i;
    } else if (points[i].y > maxY2) {
      maxY2 = points[i].y;
      maxY2Point = i;
    }
  }

  // midYs will contain the indexes of the two middle Y value points (lower points)
  var midYs = [0, 1, 2, 3, 4, 5];
  if (points.length === 6) {
    delete midYs[minY1Point];
    delete midYs[minY2Point];
    delete midYs[maxY1Point];
    delete midYs[maxY2Point];
    midYs = midYs.filter(function (item) {
      return !Number.isNaN(item);
    }); // compresses the sparse array
    // sort by x value, only 2 remaining
    midYs.sort(function (ind1, ind2) {
      return points[ind1].x - points[ind2].x;
    });
  } else {
    midYs = []; // no middle elements in 4 and 5 point perspectives
  }

  var ordered = [];
  // push the indexes of the two upper points
  // first the closest to the origin in the X direction, then the other
  if (points[minY1Point].x < points[minY2Point].x) {
    ordered.push(minY1Point);
    ordered.push(minY2Point);
  } else {
    ordered.push(minY2Point);
    ordered.push(minY1Point);
  }

  // middle right point
  if (midYs.length === 2) {
    ordered.push(midYs[1]);
  }

  // push the indexes of the two lower points
  // first the farthest from the origin in the X direction, then the other
  if (points[maxY1Point].x < points[maxY2Point].x) {
    ordered.push(maxY2Point);
    ordered.push(maxY1Point);
  } else {
    ordered.push(maxY1Point);
    ordered.push(maxY2Point);
  }

  // middle left point
  if (midYs.length === 2) {
    ordered.push(midYs[0]);
  }

  // 5 point perpective openings use the 5th as a bezier control
  // 0-4 are now ordered, so put the 5th last
  if (points.length === 5) {
    ordered.push(4);
  }

  return ordered;
};

function fromCSVPoints(csvPoints) {
  var points = csvPoints ? csvPoints.split(',') : [];
  var floatPoints = points.map(function (point) {
    return parseFloat(point.trim());
  }).filter(function (point) {
    return !isNaN(point);
  });
  if (floatPoints.length === 2) {
    return new (Function.prototype.bind.apply(Point, [null].concat(toConsumableArray(floatPoints))))();
  }
  return null;
}

function clonePoint(obj) {
  return new Point(obj);
}

function clonePolygon(obj) {
  return new Polygon(obj);
}

function toMartinezCoords(polygon) {
  var coords = [[]];

  if (polygon.points.length == 0) {
    return coords;
  }

  coords[0] = polygon.points.map(function (point) {
    return [point.x, point.y];
  });

  // close path (renoworks polygons don't repeat origin point)
  coords[0].push([polygon.points[0].x, polygon.points[0].y]);

  polygon.holes.forEach(function (hole) {
    coords.push(toMartinezCoords(hole)[0]);
  });

  return coords;
}

function fromMartinezCoords(coords) {
  if (coords.length === 1 && coords[0].length === 1) {
    // recurse into a root polygon
    return fromMartinezCoords(coords[0]);
  }

  var points = coords[0].map(function (point) {
    return new Point(point[0], point[1]);
  });

  // Polygon does not need repeated origin point
  points.pop();

  var polygon = new Polygon(points);

  for (var i = 1; i < coords.length; i++) {
    if (coords[i].length === 1) {
      polygon.holes.push(fromMartinezCoords(coords[i]));
    } else {
      polygon.holes.push(fromMartinezCoords([coords[i]]));
    }
  }

  return polygon;
}

function polygonIsInside(points, inside) {
  for (var x = 0; x < points.length; x++) {
    for (var y = 0; y < inside.length; y++) {
      var p1 = points[x];
      var p2 = x < points.length - 1 ? points[x + 1] : 0;
      var p3 = inside[y];
      var p4 = y < inside.length - 1 ? inside[y + 1] : 0;
      if (Polygon.lineIntersect(p1.x, p1.y, p2.x, p2.y, p3.x, p3.y, p4.x, p4.y)) {
        return false;
      }
    }
  }

  return true;
}

function MasterMask(width, height) {
  this.width = width;
  this.height = height;
  this.img_size = height * width;
  this.data = {};
}

MasterMask.prototype.getLayerIDs = function () {
  return Object.keys(this.data);
};

MasterMask.prototype.size = function () {
  return Object.keys(this.data).length;
};

MasterMask.prototype.addMask = function (n, ctx) {
  if (n in this.data) {
    var oldMask = this.getMask(n, '#FFF');
    oldMask.drawImage(ctx.canvas, 0, 0);
    ctx = oldMask;
  }

  this.setMask(n, ctx);
};

MasterMask.prototype.setMask = function (n, ctx) {
  // resize if needed
  this.enlarge(n);

  var mask_data = [];
  var rawData = ctx.getImageData(0, 0, this.width, this.height).data;
  var maskRep = 0;

  function getAlpha(i) {
    if (rawData[i + 0] == rawData[i + 1] && rawData[i + 1] == rawData[i + 2]) {
      // hack for gray scale images
      return rawData[i + 1];
    }
    return rawData[i + 3];
  }
  var currentStrike = getAlpha(0);

  for (var pixel = 0, i = 0; pixel < this.img_size; pixel++, i += 4) {
    if (getAlpha(i) == currentStrike) {
      maskRep++;
    } else {
      mask_data.push({
        rep: maskRep,
        pixel: currentStrike
      });
      maskRep = 1;
      currentStrike = getAlpha(i);
    }
  }

  // leftover
  if (maskRep > 0) {
    mask_data.push({
      rep: maskRep,
      pixel: currentStrike
    });
  }
  this.data[n] = mask_data;
};

MasterMask.prototype.getMaskToData = function (n, rgb_str, data) {
  if (!this.data || n >= this.data.length) {
    return null;
  }

  var rgb = rgb_from(rgb_str || '#FFF');
  var buf32 = new Uint32Array(data.data.buffer);

  // first repetition is always nomask
  var mask = this.data[n];

  for (var m = 0, i = 0; m < mask.length; m++) {
    var rgb32 = mask[m].pixel << 24 | rgb[0] << 0 | rgb[1] << 8 | rgb[2] << 16;

    for (var x = 0; x < mask[m].rep; x++, i++) {
      buf32[i] = rgb32;
    }
  }

  data.data.set(buf32.buffer);
};

MasterMask.prototype.saveString = function () {
  var saveData = '';

  saveData += 'ver:0.3\n';
  saveData += 'w:' + this.width + '\n';
  saveData += 'h:' + this.height + '\n';

  for (var k in this.data) {
    saveData += '\nmask:' + k + '\n';
    for (var mask = this.data[k], m = 0; m < mask.length; m++) {
      saveData += base64(mask[m].rep);
      if (mask[m].pixel != 0) {
        saveData += '@';
        saveData += base64(mask[m].pixel);
      }
      // base64 can't guarantee length, and padding would make it bigger anyway
      if (m < mask.length - 1) {
        saveData += ' ';
      }
    }
  }

  return saveData;
};

MasterMask.prototype.loadString = function (str) {
  if (str.length == 0) {
    throw 'string not valid';
  }

  var properties = {};
  var tmp_data = [];
  str = str.replace(/\r/g, '');
  str.split('\n').forEach(function (line, ind, arr) {
    if (line.indexOf(':') != -1) {
      // setting line
      var key = line.substr(0, line.indexOf(':'));
      var val = line.substr(line.indexOf(':') + 1);

      properties[key] = val;
      // file starts at 'ver:' line
    } else if (line.length > 0 && properties.ver == '0.3') {
      tmp_data.push([properties.mask, line]);
    }
  });

  if (properties.ver != '0.3') {
    console.log('incompatible data format');
    return false;
  }

  this.width = parseInt(properties.w);
  this.height = parseInt(properties.h);
  this.img_size = this.width * this.height;

  var total = 0;
  for (var i = 0; i < tmp_data.length; i++) {
    var maskName = parseInt(tmp_data[i][0]);
    var contents = tmp_data[i][1].split(' ');
    this.data[maskName] = [];
    for (var x = 0; x < contents.length; x++) {
      var parts = contents[x].split('@');
      this.data[maskName].push({
        rep: frombase64(parts[0]),
        pixel: parts[1] ? frombase64(parts[1]) : 0
      });
      total += this.data[maskName][x].rep;
    }
  }

  if (total != this.img_size * this.size()) {
    console.log('loaded data inconsistent recieved : ', total, this.img_size, this.size());
    return false;
  }

  return true;
};

MasterMask.prototype.enlarge = function (i) {
  while (this.data.length < i) {
    this.data.push(this.img_size);
  }
};

var base64chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_';

function base64(num, res) {
  res = res || '';
  var mod = num % 64,
      remaining = Math.floor(num / 64),
      chars = base64chars.charAt(mod) + res;

  if (remaining <= 0) {
    return chars;
  }
  return base64(remaining, chars);
}

function frombase64(chars, count, acc) {
  count = count || 0;
  acc = acc || 0;
  if (chars.length == 0) {
    return acc;
  }
  if (typeof chars === 'string') {
    return frombase64(chars.split(''), count, acc);
  }

  var cur = Math.pow(64, count) * base64chars.indexOf(chars.pop());
  return frombase64(chars, count + 1, acc + cur);
}

function rgb_from(rgb_str) {
  if (!rgb_str.startsWith('#')) {
    console.log('color must be #rgb instead is defined as: ', rgb_str, ' setting to default color');
    rgb_str = '#e58422';
  }
  return [parseInt(rgb_str.substring(1, 3), 16), parseInt(rgb_str.substring(3, 5), 16), parseInt(rgb_str.substring(5, 7), 16)];
}

/**
 * Vector element that is to be added to a layer. This is a generic object
 * that could represent any type of element, but more specific subtypes
 * exist as well with common functionality.
 *
 * @param {string} type - node type
 * @param {object} attrs - attributes of element
 * @constructor Element
 * @since 0.4.0
 */
function Element(type, attrs) {
  this.type = type;
  this.layer = null;
  this.id = null;
  this.inFront = false;
  this.attrs = {};
  this._attrs = {};
  this._events = [];
  this._removedEvents = [];
  this._animations = [];

  this.setAttrs(attrs);
}

Element.prototype.clone = function (clone) {
  clone = clone || new Element(this.type);
  clone.setAttrs(this.attrs);
  clone.inFront = this.inFront;
  clone.layer = this.layer;
  clone.id = this.id;

  return clone;
};

/**
 * Convenience method for `layer.addElement(element)`. Useful for chaining
 * element function calls.
 *
 * @param {Layer} layer - layer to add element to
 * @returns {Element}
 * @memberOf Element
 * @since 0.4.0
 */
Element.prototype.addToLayer = function (layer) {
  layer.addElement(this);
  return this;
};

/**
 * Convenience method for `layer.removeElement(element)`. Useful for chaining
 * element function calls.
 *
 * @param {Layer} layer - layer to remove element from
 * @returns {Element}
 * @memberOf Element
 * @since 0.4.0
 */
Element.prototype.removeFromLayer = function () {
  if (this.layer) {
    this.layer.removeElement(this);
  }

  return this;
};

/**
 * Sets the element to use a layer internally when needed. This function is
 * called when adding to a layer, so that the layer can do layer-specific
 * behaviour when added.
 *
 * Subtypes of element are encouraged to override this function.
 *
 * @param {Layer} layer - layer to add element to
 * @param {string} elementID - element ID in layer
 * @returns {Element}
 * @memberOf Element
 * @since 0.4.0
 */
Element.prototype.setLayer = function (layer, elementID) {
  if (this.layer) {
    this.removeLayer();
  }

  this.layer = layer;
  this.id = elementID;

  MaskingModule.update.vector({
    layers: [layer.id],
    elements: [elementID]
  });

  return this;
};

/**
 * Called when element is removed from a layer.
 *
 * Subtypes of element are encouraged to override this function when they
 * have children elements.
 *
 * @returns {Element}
 * @memberOf Element
 * @since 0.4.0
 */
Element.prototype.removeLayer = function () {
  MaskingModule.update.vector({
    layers: [this.layer.id],
    elements: []
  });

  this.layer = null;
  this.id = null;

  return this;
};

/**
 * Assigns new attributes.
 *
 * @param {object} attrs - properties to set on the element
 * @param {object} attrs.relative - numeric properties that must be scaled to the view size
 * @returns {Element}
 * @memberOf Element
 * @since 0.4.0
 */
Element.prototype.setAttrs = function (attrs) {
  extendAttrs(this._attrs, attrs);
  extendAttrs(this.attrs, attrs);

  // only exists in this.attrs (as permanent values)
  delete this._attrs.relative;

  if (this.id) {
    MaskingModule.update.vector({
      layers: [this.layer.id],
      elements: [this.id]
    });
  }

  return this;
};

/**
 * Shortcut for {@link Element#setAttrs setAttrs} for one property only.
 *
 * @param {string} name - properties name
 * @param value - value of property
 * @returns {Element}
 * @memberOf Element
 * @since 0.4.0
 */
Element.prototype.setAttr = function (name, value) {
  var attrs = {};
  attrs[name] = value;
  return this.setAttrs(attrs);
};

/**
 * Returns all attributes that were set since last calling this function.
 *
 * @returns {object}
 * @memberOf Element
 * @since 0.4.0
 */
Element.prototype.getAttrs = function () {
  var attrs = this._attrs;
  this._attrs = {};
  return attrs;
};

/**
 * Adds a listener event to the element.
 *
 * @param {string} name - event name
 * @param {function} callback - callback function for the event
 * @returns {Element}
 * @memberOf Element
 * @since 0.4.0
 */
Element.prototype.addEvent = function (name, callback) {
  this._events.push({
    name: name,
    callback: callback
  });

  if (this.id) {
    MaskingModule.update.vector({
      layers: [this.layer.id],
      elements: [this.id]
    });
  }

  return this;
};

/**
 * Removes an event listener of the element by name. Note that the listener
 * is only removed inside of the actual draw, so don't add an event by the
 * same name right after removing it.
 *
 * @param {string} name - event name
 * @returns {Element}
 * @memberOf Element
 * @since 0.4.0
 */
Element.prototype.removeEvent = function (name) {
  this._removedEvents.push(name);

  if (this.id) {
    MaskingModule.update.vector({
      layers: [this.layer.id],
      elements: [this.id]
    });
  }

  return this;
};

/**
 * Adds a special listener event for dragging.
 *
 * @param {function} drag - callback while dragging
 * @param {function} dragstart - callback on start of drag
 * @param {function} dragend - callback on end of drag
 * @returns {Element}
 * @memberOf Element
 * @since 0.4.0
 */
Element.prototype.addDrag = function (drag, dragstart, dragend) {
  this.addEvent('drag', function (e, type) {
    if (type === 'drag' && drag) {
      drag(e);
    } else if (type === 'dragstart' && dragstart) {
      dragstart(e);
    } else if (type === 'dragend' && dragend) {
      dragend(e);
    }
  });

  this.inFront = true;

  return this;
};

/**
 * Removes the listener added in {@link Element#addDrag addDrag}.
 *
 * @memberOf Element
 * @returns {Element}
 * @since 0.4.0
 */
Element.prototype.removeDrag = function () {
  return this.removeEvent('drag');
};

/**
 * Returns all events that were bound since last calling this function.
 *
 * @returns {object[]}
 * @memberOf Element
 * @since 0.4.0
 */
Element.prototype.getEvents = function () {
  var events = this._events;
  this._events = [];
  return events;
};

/**
 * Returns all events that were removed since last calling this function.
 *
 * @returns {string[]}
 * @memberOf Element
 * @since 0.4.0
 */
Element.prototype.getRemovedEvents = function () {
  var events = this._removedEvents;
  this._removedEvents = [];
  return events;
};

/**
 * Adds an animation event to be shown.
 *
 * @param {object} attrs - attributes of element to animate
 * @param {number} ms - milliseconds to run
 * @param {string} easing - easing type
 * @returns {promise} a promise for when animation is done
 * @memberOf Element
 * @since 0.4.0
 */
Element.prototype.animate = function (attrs, ms, easing) {
  var _this = this;

  return new Promise(function (resolve) {
    _this._animations.push({
      attrs: attrs,
      ms: ms,
      easing: easing || 'linear',
      callback: function callback() {
        resolve();
      }
    });

    if (_this.id) {
      MaskingModule.update.vector({
        layers: [_this.layer.id],
        elements: [_this.id]
      });
    }
  });
};

/**
 * Returns all animations that were added since last calling this function.
 *
 * @returns {object[]}
 * @memberOf Element
 * @since 0.4.0
 */
Element.prototype.getAnimations = function () {
  var animations = this._animations;
  this._animations = [];
  return animations;
};

function extendAttrs(original, update) {
  if (!update) {
    return;
  }

  if (original.relative) {
    for (var attr in update) {
      if (original.relative[attr]) {
        delete original.relative[attr];
      }
    }
  }

  if (update.relative) {
    for (var relativeAttr in update.relative) {
      if (original[relativeAttr]) {
        delete original[relativeAttr];
      }
    }
  }

  $.extend(true, original, update);
}

/**
 * Circle shape vector element, used for a click-and-drag handle.
 *
 * @param {Point} point - position of handle
 * @constructor HandleElement
 * @since 0.4.0
 */
function HandleElement(point) {
  Element.call(this, 'circle', Settings$1.layers.handleAttrs);
  this.point = new Point(point);
  this.inFront = true;
  this.moveTo(point);
}

HandleElement.prototype = Object.create(Element.prototype);

/**
 * Updates the position of the point.
 *
 * @param {Point} point - new position
 * @returns {HandleElement}
 * @memberOf HandleElement
 * @since 0.4.0
 */
HandleElement.prototype.moveTo = function (point) {
  this.point.moveTo(point);
  return this.setAttrs({
    cx: this.point.x,
    cy: this.point.y
  });
};

/**
 * Shifts the position of the point.
 *
 * @param {number} deltaX - x distance to shift
 * @param {number} deltaY - y distance to shift
 * @returns {HandleElement}
 * @memberOf HandleElement
 * @since 0.4.0
 */
HandleElement.prototype.shift = function (deltaX, deltaY) {
  return this.moveTo(this.point.shift(deltaX, deltaY));
};

/**
 * Makes the point draggable up/down/left/right.
 *
 * @param {function?} drag - called while dragging
 * @param {function?} dragstart - called when dragging starts
 * @param {function?} dragend - called when dragging ends
 * @returns {HandleElement}
 * @memberOf HandleElement
 * @since 0.4.0
 */
HandleElement.prototype.makeDraggable = function (drag, dragstart, dragend) {
  this.setAttrs({
    cursor: 'pointer'
  });

  var _this = this;
  this.addDrag(function (e) {
    _this.moveTo(e.relative);

    if (drag) {
      drag(_this.point);
    }

    MaskingModule.draw();
  }, function () {
    if (dragstart) {
      dragstart(_this.point);
    }
  }, function () {
    if (dragend) {
      dragend(_this.point);
    }
  });

  return this;
};

/**
 * Polygon shape vector element.
 *
 * @param {Polygon} polygon - shape of element
 * @param {bool} asLayerPolygon - adds the polygon to the layer as a real shape
 * @constructor PolygonElement
 * @since 0.4.0
 */
function PolygonElement(polygon, asLayerPolygon, layerType) {
  Element.call(this, 'path', Settings$1.layers.polygonAttrs);
  var category = layerType && Settings$1.layerTypeCategories[layerType] || layerType;
  var mayCurve = category === 'opening';
  this.polygon = new Polygon(polygon).setCurve(mayCurve);
  this.updatePolygon();

  this.handles = [];
  this.holePoints = [];
  this.midlines = [];
  this.asLayerPolygon = asLayerPolygon;
}

PolygonElement.prototype = Object.create(Element.prototype);

/* override */PolygonElement.prototype.setLayer = function (layer, id) {
  Element.prototype.setLayer.call(this, layer, id);

  this.setAttrs({
    fill: layer.maskColor,
    stroke: Settings$1.layers.globalMaskStrokeColor || layer.maskColor
  });

  if (this.asLayerPolygon) {
    layer.addPolygon(this.id, this.polygon);
  }

  return this;
};

/* override */PolygonElement.prototype.removeLayer = function () {
  if (this.asLayerPolygon) {
    this.layer.removePolygon(this.id);
  }

  this.removeHandles().removeMidlines().removeHoleHandles();

  return Element.prototype.removeLayer.call(this);
};

/* override */PolygonElement.prototype.clone = function () {
  return Element.prototype.clone.call(this, new PolygonElement(this.polygon, this.asLayerPolygon));
};

/**
 * Updates the position of the polygon shape. To do most polygon updates,
 * you'll want to update the polygon object itself and call this function
 * without arguments.
 *
 * @param {Polygon?} polygon - new shape - changing this could break midline or handles if references are old
 * @returns {PolygonElement}
 * @memberOf PolygonElement
 * @since 0.4.0
 */
PolygonElement.prototype.updatePolygon = function (polygon) {
  if (polygon) {
    this.polygon = polygon;

    if (this.asLayerPolygon && this.layer) {
      this.layer.polygons[this.id] = polygon;
    }
  }

  return this.setAttr('path', this.polygon.pathString());
};

/**
 * Shifts polygon up/down/left/right.
 *
 * @param {number} deltaX - x distance to shift
 * @param {number} deltaY - y distance to shift
 * @returns {PolygonElement}
 * @memberOf PolygonElement
 * @since 0.4.0
 */
PolygonElement.prototype.shift = function (deltaX, deltaY) {
  this.polygon.shift(deltaX, deltaY);
  this.updatePolygon();

  for (var i = 0; i < this.handles.length; i++) {
    this.handles[i].shift(deltaX, deltaY);
  }
  for (var h = 0; h < this.holePoints.length; h++) {
    this.holePoints[h].shift(deltaX, deltaY);
  }
  for (var m = 0; m < this.midlines.length; m++) {
    if (this.midlines[m]) {
      this.midlines[m].shift(deltaX, deltaY);
    }
  }

  return this;
};

/**
 * Makes the polygon draggable up/down/left/right, automatically shifts all
 * handles/midlines if they exist.
 *
 * @param {function?} drag - called while dragging
 * @param {function?} dragstart - called when dragging starts
 * @param {function?} dragend - called when dragging ends
 * @returns {PolygonElement}
 * @memberOf PolygonElement
 * @since 0.4.0
 */
PolygonElement.prototype.makeDraggable = function (drag, dragstart, dragend) {
  this.setAttr('cursor', 'move');

  var lastDrag = void 0;
  var _this = this;
  this.addDrag(function (e) {
    _this.shift(e.relative.x - lastDrag.x, e.relative.y - lastDrag.y);

    if (drag) {
      drag(_this.polygon);
    }

    lastDrag = e.relative;
    MaskingModule.draw();
  }, function (e) {
    if (dragstart) {
      dragstart(_this.polygon);
    }

    lastDrag = e.relative;
  }, function () {
    if (dragend) {
      dragend(_this.polygon);
    }
  });

  return this;
};

/**
 * Disables draggable events if they were bound.
 *
 * @returns {PolygonElement}
 * @memberOf PolygonElement
 * @since 0.4.0
 */
PolygonElement.prototype.disableDrag = function () {
  return this.removeDrag().setAttr('cursor', 'inherit');
};

/**
 * Adds "handles" on corners of the polygon for dragging to change the shape.
 *
 * @param {object?} attrs - any attributes to set for all handles
 * @param {function?} drag - called while dragging handle
 * @param {function?} dragstart - called when dragging handle starts
 * @param {function?} dragend - called when dragging handle ends
 * @returns {PolygonElement}
 * @memberOf PolygonElement
 * @since 0.4.0
 */
PolygonElement.prototype.addHandles = function (attrs, drag, dragstart, dragend) {
  var _this = this;

  this.handles = this.polygon.points.map(function (point, i) {
    return new HandleElement(point).addToLayer(_this.layer).setAttr('fill', _this.layer.maskColorAccent).setAttrs(attrs).makeDraggable(function (position) {
      point.moveTo(position);
      _this.updatePolygon();

      var nextMidline = _this.midlines[i];
      if (nextMidline) {
        nextMidline.updatePosition();
      }

      var lastMidline = _this.midlines[i > 0 ? i - 1 : _this.midlines.length - 1];
      if (lastMidline) {
        lastMidline.updatePosition();
      }

      if (drag) {
        drag(_this.polygon);
      }

      MaskingModule.draw();
    }, function () {
      if (dragstart) {
        dragstart(_this.polygon);
      }
    }, function (position) {
      if (dragend) {
        dragend(_this.polygon);
      }

      MaskingModule.draw();
    });
  });

  return this;
};

/**
 * Removes handles added with {@link PolygonElement#addHandles addHandles}
 *
 * @returns {PolygonElement}
 * @memberOf PolygonElement
 * @since 0.4.0
 */
PolygonElement.prototype.removeHandles = function () {
  for (var i = 0; i < this.handles.length; i++) {
    this.handles[i].removeFromLayer();
  }

  this.handles = [];

  return this;
};

/**
 * Adds "handles" on holes of the polygon for dragging to change the shape.
 *
 * @param {object?} attrs - any attributes to set for all handles
 * @param {function?} drag - called while dragging handle
 * @param {function?} dragstart - called when dragging handle starts
 * @param {function?} dragend - called when dragging handle ends
 * @returns {PolygonElement}
 * @memberOf PolygonElement
 * @since 0.4.0
 */
PolygonElement.prototype.addHoleHandles = function (attrs, drag, dragstart, dragend) {
  var _this = this;

  this.holePoints = this.polygon.holes.reduce(function (acc, hole) {
    return acc.concat(hole.points);
  }, []).map(function (point) {
    var handle = new HandleElement(point).addToLayer(_this.layer).setAttrs(Settings$1.layers.editableAttrs.hole).setAttrs(attrs).makeDraggable(function (position) {
      point.moveTo(position);
      _this.updatePolygon();

      if (drag) {
        drag(_this.polygon);
      }

      MaskingModule.draw();
    }, function () {
      if (dragstart) {
        dragstart(_this.polygon);
      }
    }, function (position) {
      if (dragend) {
        dragend(_this.polygon);
      }

      MaskingModule.draw();
    });

    // default to being small, enlarges on hover
    handle.addEvent('mouseover', function () {
      handle.setAttrs({
        relative: {
          r: 12
        }
      });

      MaskingModule.draw();
    }).addEvent('mouseout', function () {
      handle.setAttrs(Settings$1.layers.editableAttrs.hole);
      MaskingModule.draw();
    });

    return handle;
  });

  return this;
};

/**
 * Removes handles added with {@link PolygonElement#addHoleHandles addHoleHandles}
 *
 * @returns {PolygonElement}
 * @memberOf PolygonElement
 * @since 0.4.0
 */
PolygonElement.prototype.removeHoleHandles = function () {
  for (var i = 0; i < this.holePoints.length; i++) {
    this.holePoints[i].removeFromLayer();
  }

  this.holePoints = [];

  return this;
};

/**
 * Adds "midlines" which are temporary points that allow user to create new
 * points on a polygon.
 *
 * @param {object?} attrs - any attributes to set for all midlines
 * @param {function?} drag - called while dragging midline
 * @param {function?} dragstart - called when dragging midline starts
 * @param {function?} dragend - called when dragging midline ends
 * @returns {PolygonElement}
 * @memberOf PolygonElement
 * @since 0.4.0
 */
PolygonElement.prototype.addMidlines = function (attrs, drag, dragstart, dragend) {
  var _this = this;
  var indexMap = this.polygon.points.map(function (_, i) {
    return i;
  });

  function getMidlinePoint(i) {
    var points = _this.polygon.points;
    var nextPoint = indexMap[i + 1] < points.length ? points[indexMap[i + 1]] : points[0];
    return points[indexMap[i]].add(nextPoint).divide(2);
  }

  this.midlines = this.polygon.points.map(function (_, i) {
    var midline = new HandleElement(getMidlinePoint(i)).setAttrs(Settings$1.layers.editableAttrs.midpoint).setAttrs(attrs);

    // custom function called when dragging corners to ensure midline position is in sync
    midline.updatePosition = function () {
      midline.moveTo(getMidlinePoint(i));
    };

    midline.isAddedToPolygon = false;

    midline.makeDraggable(function (position) {
      _this.polygon.points[indexMap[i] + 1].moveTo(position);
      _this.updatePolygon();

      if (drag) {
        drag(_this.polygon);
      }

      MaskingModule.draw();
    }, function (position) {
      if (_this.midlines[i]) {
        _this.midlines[i].setAttrs(Settings$1.layers.handleAttrs).setAttr('fill', _this.layer.maskColorAccent);

        _this.handles.splice(indexMap[i] + 1, 0, _this.midlines[i]);
        _this.polygon.points.splice(indexMap[i] + 1, 0, new Point(position));
        _this.updatePolygon();
        _this.midlines[i].isAddedToPolygon = true;
        _this.midlines[i].removeEvent('mouseover');
        delete _this.midlines[i];

        for (var x = i + 1; x < indexMap.length; x++) {
          indexMap[x]++;
        }

        if (dragstart) {
          dragstart(_this.polygon);
        }

        MaskingModule.draw();
      }
    }, function () {
      if (dragend) {
        dragend(_this.polygon);
      }
    });

    // hovering on one midline hides the others
    midline.addEvent('mouseover', function () {
      for (var x = 0; x < _this.midlines.length; x++) {
        if (_this.midlines[x] && x != i) {
          _this.midlines[x].animate({
            'fill-opacity': 0
          }, 100, 'linear');
        }
      }

      // enlarges the midline on hover
      midline.setAttrs({
        relative: {
          r: 9
        }
      });

      MaskingModule.draw();
    });

    midline.addEvent('mouseout', function () {
      if (midline.isAddedToPolygon) {
        midline.removeEvent('mouseout');
      }

      for (var x = 0; x < _this.midlines.length; x++) {
        if (_this.midlines[x] && x != i) {
          _this.midlines[x].animate({
            'fill-opacity': 1
          }, 100, 'linear');
        }
      }

      if (_this.midlines[i]) {
        _this.midlines[i].setAttrs({
          relative: {
            r: Settings$1.layers.editableAttrs.midpoint.relative.r
          }
        });
      }

      MaskingModule.draw();
    });

    _this.layer.addElement(midline);

    return midline;
  });

  return this;
};

/**
 * Removes midlines added with {@link PolygonElement#addMidlines addMidlines}
 *
 * @returns {PolygonElement}
 * @memberOf PolygonElement
 * @since 0.4.0
 */
PolygonElement.prototype.removeMidlines = function () {
  for (var i = 0; i < this.midlines.length; i++) {
    if (this.midlines[i]) {
      this.midlines[i].removeFromLayer();
    }
  }

  this.midlines = [];

  return this;
};

/**
 * Changes the polygon to/from a curve
 *
 * @returns {PolygonElement}
 * @memberOf PolygonElement
 * @since 0.4.4
 */
PolygonElement.prototype.setCurve = function (isCurve) {
  this.polygon.setCurve(isCurve);

  return this;
};

/**
 * A masking layer contains a region in the project, that is meant to be
 * a certain "type" of region (door, roof, siding, foreground, etc.)
 *
 * @param {string} id - an instance-unique ID string of the layer
 * @param {number} width - owning project's width
 * @param {number} height - owning project's height
 * @param {object} gutter - size of display "gutter" around project that isn't saved (see {@link MaskingState#gutterX gutterX} / {@link MaskingState#gutterY gutterY})
 * @param {number} gutter.x - pixel padding on left/right
 * @param {number} gutter.y - pixel padding on top/bottom
 * @param {object} [properties]
 * @param {object} [properties.maskColor] - css color to display layer as
 * @param {object} [properties.maskColorAccent] - css color to contrast maskColor
 * @constructor MaskingLayer
 * @since 0.2.0
 */
function MaskingLayer(id, width, height, gutter, properties) {
  properties = properties || {};

  if (!id) {
    throw new Error('Masks require an ID');
  }

  /**
   * An instance-unique ID string of the layer.
   *
   * @name MaskingLayer#id
   * @type {string}
   * @readonly
   * @since 0.2.0
   */
  this.id = id.toString();

  /**
   * The layer grouping's name (eg. "Siding Main" or "Trim")
   *
   * @name MaskingLayer#group
   * @type {?string}
   * @since 0.2.0
   */
  this.group = properties.group;

  var nextColor = getNextMaskColor();
  if (properties.type === 'Foreground') {
    this.maskColor = properties.maskColor || Settings$1.layers.foregroundColor || nextColor[0];
    this.maskColorAccent = properties.maskColorAccent || Settings$1.layers.foregroundColor || nextColor[1];
  } else {
    this.maskColor = properties.maskColor || Settings$1.layers.globalMaskColor || nextColor[0];
    this.maskColorAccent = properties.maskColorAccent || Settings$1.layers.globalMaskColorAccent || Settings$1.layers.globalMaskColor || nextColor[1];
  }

  /**
   * Mask rectangle as it was when loading from save.
   *
   * @name MaskingLayer#loadedPosition
   * @type {?object}
   * @since 0.2.0
   */
  this.loadedPosition = null;

  /**
   * Mask width (almost always project width).
   *
   * @name MaskingLayer#width
   * @type number
   * @readonly
   * @since 0.2.0
   */
  this.width = width;

  /**
   * Mask height (almost always project height).
   *
   * @name MaskingLayer#height
   * @type {number}
   * @readonly
   * @since 0.2.0
   */
  this.height = height;

  /**
   * Size of display "gutter" around project that isn't saved (see {@link MaskingState#gutterX gutterX} / {@link MaskingState#gutterY gutterY}).
   *
   * @name MaskingLayer#gutter
   * @type {{x: number, y: number}}
   * @readonly
   * @since 0.2.0
   */
  this.gutter = gutter;

  // starts as non-raster (empty canvas)
  this.hasNoRasterComponent = true;
  this.drawingCanvasInitialized = false;
  this.drawingCanvas = document.createElement('canvas');
  this.drawingContext = this.drawingCanvas.getContext('2d');

  /**
   * @typedef Perspective
   * @property {Polygon} contour - perspective's contour
   * @since 0.2.0
   */

  /**
   * Layer's perspective - for an opening, this is it's contour. For a
   * surface, this is the perspective plane.
   *
   * @name MaskingLayer#perspective
   * @type {Perspective}
   * @since 0.2.0
   */
  this.perspective = new Perspective(this);

  this.elements = {};
  this.polygons = {};
}

MaskingLayer.prototype._initRaster = function (canvas) {
  if (!this.drawingCanvasInitialized) {
    this.drawingCanvas.width = this.width + this.gutter.x * 2;
    this.drawingCanvas.height = this.height + this.gutter.y * 2;
    this.drawingCanvasInitialized = true;
    this.hasNoRasterComponent = false;
  }
};

/**
 * Synchronous raster drawing function. Essentially, you can draw on this
 * layer by borrowing the drawing context.
 *
 * @example
 * MaskingModule.getSelectedLayer().drawRaster({ x:40, y:0, width:30, height:50 }, function(ctx) {
 *   ctx.fillStyle = 'red';
 *   ctx.fillRect(40, 0, 30, 50);
 * });
 *
 * @param {{ x:number, y:number, width:number, height:number }} [region] - redrawing region
 * @param {function} callback - `function(ctx)` that will draw on layer
 * @memberOf MaskingLayer
 * @see {@link MaskingLayer#useRasterContext useRasterContext}
 * @since 0.2.0
 */
MaskingLayer.prototype.drawRaster = function (region, callback) {
  if (typeof region === 'function') {
    callback = region;
    region = null;
  }

  this._initRaster();

  callback(this.drawingContext);
  MaskingModule.update.raster({
    layers: [this.id],
    region: region
  });
};

/**
 * The asynchronous version of {@link MaskingLayer#drawRaster drawRaster},
 * to do raster drawing on the layer.
 *
 * @example
 * let dfr = $.Deferred();
 * let ctx = MaskingModule.getSelectedLayer().useRasterContext(dfr.promise());
 * ctx.fillStyle = 'red';
 * ctx.fillRect(40, 0, 30, 50);
 *
 * // resolve whenever you are done drawing
 * dfr.resolve({ x:40, y:0, width:30, height:50 });
 *
 * @param {promise} promise - promise that should be resolved with an optional redraw region
 * @memberOf MaskingLayer
 * @see {@link MaskingLayer#drawRaster drawRaster}
 * @since 0.2.0
 */
MaskingLayer.prototype.useRasterContext = function (promise) {
  if (!promise || !promise.then) {
    throw new Error('invalid promise passed');
  }

  var id = this.id;
  promise.then(function (region) {
    MaskingModule.update.raster({
      layers: [id],
      region: region
    });
  });

  this._initRaster();

  return this.drawingContext;
};

/**
 * Clears the raster layer and draws an image on top.
 *
 * note: does not apply padding, expects an image the size of the layer
 *
 * @param {CanvasImageSource|MaskingLayer} img - image to draw on layer
 * @param {number} [x] - x offset
 * @param {number} [y] - y offset
 * @memberOf MaskingLayer
 * @since 0.2.0
 */
MaskingLayer.prototype.setImage = function (img, x, y) {
  if (img instanceof MaskingLayer) {
    img = img.drawingCanvas;
  }

  x = x || 0;
  y = y || 0;

  if (img instanceof ImageData) {
    this.drawRaster(function (ctx) {
      ctx.putImageData(img, x, y);
    });
  } else {
    this.drawRaster(function (ctx) {
      ctx.clearRect(x, y, img.width, img.height);
      ctx.drawImage(img, x, y);
    });
  }
};

/**
 * Loads one of the Renowork's black and white mask images.
 *
 * @param {CanvasImageSource} img - image to set as layer
 * @param {{ x:number, y:number, width:number, height:number }} [pos] - mask position in project
 * @memberOf MaskingLayer
 * @since 0.2.0
 */
MaskingLayer.prototype.loadMaskImage = function (img, pos) {
  if (pos && pos.width && pos.height) {
    this.loadedPosition = pos;
  }

  pos = pos || {
    x: 0,
    y: 0
  };

  var width = pos.width || img.width;
  var height = pos.height || img.height;

  // draw mask to virtual canvas before writing to layer
  var canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  var tmp = canvas.getContext('2d');
  tmp.drawImage(img, 0, 0);
  var imageData = tmp.getImageData(0, 0, width, height);
  var data = imageData.data;

  // white to mask
  for (var i = 0; i < data.length; i += 4) {
    if (!data[i]) {
      data[i + 3] = 0;
    }
  }

  // change mask color
  tmp.putImageData(imageData, 0, 0);
  data = null;
  tmp.fillStyle = this.maskColor;
  tmp.globalCompositeOperation = 'source-in';
  tmp.fillRect(0, 0, width, height);
  imageData = tmp.getImageData(0, 0, width, height);
  tmp = null;

  // draw to layer canvas
  this._initRaster();

  this.drawingContext.putImageData(imageData, pos.x, pos.y);
};

/**
 * @typedef ExportedMaskImage
 * @property {HTMLCanvasElement} canvas - mask image
 * @property {Rect} position - where cropped mask image is in project
 * @property {Polygon[]} polygons
 */

/**
 * Creates a Renoworks black and white mask image.
 *
 * @param {bool} fullMask - if exported image should be full project size
 * @returns {ExportedMaskImage}
 * @memberOf MaskingLayer
 * @since 0.2.0
 */
MaskingLayer.prototype.exportMask = function (fullMask) {
  // draw mask to virtual canvas without gutter
  var canvas = document.createElement('canvas');
  canvas.width = this.width;
  canvas.height = this.height;

  var ctx = canvas.getContext('2d');
  ctx.drawImage(this.drawingCanvas, this.gutter.x, this.gutter.y, this.width, this.height, 0, 0, this.width, this.height);

  var imageData = ctx.getImageData(0, 0, this.width, this.height);
  var data = imageData.data;

  var bounds = {
    top: null,
    left: null,
    right: null,
    bottom: null
  };

  // mask to black or white
  for (var i = 0; i < data.length; i += 4) {
    if (data[i + 3] === 0) {
      data[i] = 0;
      data[i + 1] = 0;
      data[i + 2] = 0;
      data[i + 3] = 255;
    } else {
      data[i] = 255;
      data[i + 1] = 255;
      data[i + 2] = 255;

      var x = i / 4 % this.width;
      var y = Math.floor(i / 4 / this.width);

      if (bounds.top === null) {
        bounds.top = y;
      }

      if (bounds.left === null || x < bounds.left) {
        bounds.left = x;
      }

      if (bounds.right === null || bounds.right < x) {
        bounds.right = x;
      }

      if (bounds.bottom === null || bounds.bottom < y) {
        bounds.bottom = y;
      }
    }
  }

  ctx.putImageData(imageData, 0, 0);

  if (fullMask) {
    return {
      canvas: canvas,
      polygons: this.getPolygons(),
      position: {
        x: 0,
        y: 0,
        width: canvas.width,
        height: canvas.height
      }
    };
  }

  var pos = {
    x: bounds.left,
    y: bounds.top,
    width: bounds.right - bounds.left + 1,
    height: bounds.bottom - bounds.top + 1
  };

  if (pos.x === null || pos.y === null) {
    pos = {
      x: 0,
      y: 0,
      width: canvas.width,
      height: canvas.height
    };
  }

  var cropped = ctx.getImageData(pos.x, pos.y, pos.width, pos.height);
  canvas.width = pos.width;
  canvas.height = pos.height;
  ctx.putImageData(cropped, 0, 0);

  return {
    canvas: canvas,
    polygons: this.getPolygons(),
    position: pos
  };
};

/**
 * Returns raster image data of the layer.
 *
 * @param {number?} x - optional top
 * @param {number?} y - optional left
 * @param {number?} width - optional size
 * @param {number?} height - optional size
 * @returns {ImageData}
 * @memberOf MaskingLayer
 * @since 0.4.0
 */
MaskingLayer.prototype.getImageData = function (x, y, width, height) {
  this._initRaster();
  return this.drawingContext.getImageData(x || 0, y || 0, width || this.drawingCanvas.width, height || this.drawingCanvas.height);
};

/**
 * Adds a vector {@link Element} to the layer.
 *
 * @returns {string} the unique string ID of the created element
 * @memberOf MaskingLayer
 * @since 0.4.0
 */
MaskingLayer.prototype.addElement = function (element) {
  var elementID = randomID();
  this.elements[elementID] = element.setLayer(this, elementID);

  return elementID;
};

/**
 * Removes a vector element.
 *
 * @param {string|Element} element - element, or its ID
 * @memberOf MaskingLayer
 * @since 0.4.0
 */
MaskingLayer.prototype.removeElement = function (element) {
  if (!element) {
    return;
  }
  var id = element instanceof Element ? element.id : element;
  if (this.elements[id]) {
    this.elements[id].removeLayer();
    delete this.elements[id];
  }
};

/**
 * Gets all elements.
 *
 * @memberOf MaskingLayer
 * @since 0.4.7
 */
MaskingLayer.prototype.getAllElements = function () {
  return Object.values(this.elements);
};

/**
 * @memberOf MaskingLayer
 * @since 0.4.0
 */
MaskingLayer.prototype.addPolygon = function (id, polygon) {
  if (arguments.length == 1) {
    polygon = id;
    id = randomID();
  }

  this.polygons[id] = polygon;

  MaskingModule.update.vector({
    layers: [this.id]
  });

  return id;
};

/**
 * @memberOf MaskingLayer
 * @since 0.4.0
 */
MaskingLayer.prototype.removePolygon = function (id) {
  delete this.polygons[id];
};

/**
 * @typedef PolygonResult
 * @property {string[]} added - new polygons constructed
 * @property {string[]} removed - polygons that were removed
 */

/**
 * Erases vector intersections of other polygons with the one provided.
 *
 * @param {Polygon} polygon - polygon that should be used for clipping others
 * @returns {PolygonResult}
 * @memberOf MaskingLayer
 * @since 0.4.0
 */
MaskingLayer.prototype.clipPolygon = function (polygon, asElement) {
  var result = {
    added: [],
    removed: []
  };

  if (!(polygon instanceof Polygon)) {
    polygon = new Polygon(polygon);
  }

  for (var id in this.polygons) {
    if (this.polygons[id] && polygon.overlaps(this.polygons[id])) {
      var clipped = this.polygons[id].clip(polygon);

      for (var i = 0; i < clipped.length; i++) {
        if (asElement) {
          result.added.push(this.addElement(new PolygonElement(clipped[i], true)));
        } else {
          result.added.push(this.addPolygon(clipped[i]));
        }
      }

      if (asElement) {
        this.removeElement(id);
      } else {
        this.removePolygon(id);
      }

      result.removed.push(id);
    }
  }

  return result;
};

/**
 * Merges polygon with others that overlap with it.
 *
 * @param {string|Polygon} polygonID - polygon to check overlap
 * @param {bool} asElement - if merging Elements or just polygon shapes
 * @returns {PolygonResult}
 * @memberOf MaskingLayer
 * @since 0.4.0
 */
MaskingLayer.prototype.mergePolygon = function (id, asElement) {
  if (id instanceof Polygon) {
    if (asElement) {
      id = this.addElement(new PolygonElement(id, true));
    } else {
      id = this.addPolygon(id);
    }
  }

  return function mergeAll(layer, mergeID, result) {
    var polygon = layer.polygons[mergeID];

    for (var _id in layer.polygons) {
      if (_id === mergeID) {
        continue;
      }

      var otherPolygon = layer.polygons[_id];
      if (polygon.overlaps(otherPolygon)) {
        var mergedID = void 0;
        if (asElement) {
          mergedID = layer.addElement(new PolygonElement(polygon.merge(otherPolygon), true));
          layer.removeElement(mergeID);
          layer.removeElement(_id);
        } else {
          mergedID = layer.addPolygon(polygon.merge(otherPolygon));
          layer.removePolygon(mergeID);
          layer.removePolygon(_id);
        }

        result.added.push(mergedID);
        result.removed.push(mergeID, _id);

        // recurse to overlap with others
        return mergeAll(layer, mergedID, result);
      }
    }

    // ensure that any merged polygons that were added, but removed right after are not returned
    result.added = result.added.filter(function (id) {
      return result.removed.indexOf(id) === -1;
    });

    return result;
  }(this, id, {
    added: [],
    removed: []
  });
};

/**
 * Returns a list of vector polygons as they are defined for the layer.
 *
 * @returns {Polygon[]}
 * @memberOf MaskingLayer
 * @since 0.2.0
 */
MaskingLayer.prototype.getPolygons = function () {
  var gutter = this.gutter;
  return Object.values(this.polygons).map(function (polygon) {
    return polygon.minus(new Point(gutter));
  });
};

/**
 * Draws a polygon to the raster portion of layer and removes the vector
 * polygon.
 *
 * @param {string} polygonID - id of polygon to draw
 * @memberOf MaskingLayer
 * @since 0.3.0
 */
MaskingLayer.prototype.drawPolygonToRaster = function (polygonID) {
  this.drawPolygon(this.polygons[polygonID]);
  this.removeElement(polygonID);
};

/**
 * Draws all vector polygons to raster portion of layer, and removes the
 * vector polygons.
 *
 * @memberOf MaskingLayer
 * @since 0.3.0
 */
MaskingLayer.prototype.drawAllToRaster = function () {
  for (var polygonID in this.polygons) {
    this.drawPolygonToRaster(polygonID);
  }
};

/**
 * @typedef DrawingPolygon
 * @property {Polygon|Polygon[]} draw
 * @property {Polygon|Polygon[]} erase
 */

/**
 * @param {Polygon|Polygon[]|DrawingPolygon} draw
 * @param {Polygon|Polygon[]} erase
 * @memberOf MaskingLayer
 * @since 0.2.0
 */
MaskingLayer.prototype.drawPolygon = function () {
  var draw = [],
      erase = [];

  if (arguments.length == 1) {
    if (!arguments[0].hasOwnProperty('draw') && !arguments[0].hasOwnProperty('erase')) {
      // drawPolygon(poly)
      draw = [arguments[0]];
    }

    if (arguments[0].hasOwnProperty('draw')) {
      if (Array.isArray(arguments[0].draw)) {
        // drawPolygon({ draw: [poly] })
        draw = arguments[0].draw;
      } else {
        // drawPolygon({ draw: poly })
        draw = [arguments[0].draw];
      }
    }

    if (arguments[0].hasOwnProperty('erase')) {
      if (Array.isArray(arguments[0].erase)) {
        // drawPolygon({ erase: [poly] })
        erase = arguments[0].erase;
      } else {
        // drawPolygon({ erase: poly })
        erase = [arguments[0].erase];
      }
    }
  } else if (arguments.length == 2) {
    if (Array.isArray(arguments[0])) {
      // drawPolygon([poly], erase)
      draw = arguments[0];
    } else {
      // drawPolygon(poly, erase)
      draw = [arguments[0]];
    }

    if (Array.isArray(arguments[1])) {
      // drawPolygon(draw, [poly])
      erase = arguments[1];
    } else {
      // drawPolygon(draw, poly)
      erase = [arguments[1]];
    }
  }

  this._initRaster();

  var color = this.maskColor;
  if (draw.length > 0) {
    var canvas = document.createElement('canvas');
    canvas.width = this.drawingCanvas.width;
    canvas.height = this.drawingCanvas.height;
    var tmp = canvas.getContext('2d');

    draw.forEach(function (polygon) {
      drawPolygonTo(polygon, tmp, false, color);
    });

    erase.forEach(function (polygon) {
      drawPolygonTo(polygon, tmp, true);
    });

    this.drawRaster(redrawRegion(draw, erase), function (ctx) {
      ctx.drawImage(canvas, 0, 0);
    });
  } else {
    // only erasing means that should draw directly on layer context
    this.drawRaster(redrawRegion(draw, erase), function (ctx) {
      draw.forEach(function (polygon) {
        drawPolygonTo(polygon, ctx, false, color);
      });

      erase.forEach(function (polygon) {
        drawPolygonTo(polygon, ctx, true);
      });
    });
  }
};

/**
 * @param {Polygon|Polygon[]} polygon
 * @memberOf MaskingLayer
 * @since 0.2.0
 */
MaskingLayer.prototype.erasePolygon = function (polygon) {
  return this.drawPolygon({
    erase: polygon
  });
};

/**
 * Adjusts mask color, trying to change all elements & raster layer.
 *
 * Be wary that this isn't guaranteed to work in every scenario.
 *
 * @param color - new css color for mask
 * @memberOf MaskingLayer
 * @since 0.2.0
 */
MaskingLayer.prototype.setMaskColor = function (color) {
  for (var elementID in this.elements) {
    var attrs = {};
    for (var attr in this.elements[elementID].attrs) {
      if (this.elements[elementID].attrs[attr] === this.maskColor) {
        attrs[attr] = color;
      }
    }

    this.changeElement(elementID, attrs);
  }

  this.drawRaster(function (ctx) {
    ctx.save();
    ctx.fillStyle = color;
    ctx.globalCompositeOperation = 'source-in';
    ctx.fillRect(0, 0, ctx.canvas.width, ctx.canvas.height);
    ctx.restore();
  });

  this.maskColor = color;
};

var mask_color_index = 0;
var mask_colors = [['#e58422', '#845500'], ['#e5e522', '#444444'], ['#22e522', '#165600'], ['#22e5e5', '#0c1919'], ['#2243e5', '#ffffff'], ['#8422e5', '#ffa9ff'], ['#e522a4', '#602265']];

function getNextMaskColor() {
  mask_color_index++;
  if (mask_color_index == mask_colors.length) {
    mask_color_index = 0;
  }

  return mask_colors[mask_color_index];
}

var allIDs = {};

function randomID() {
  var rnd = Math.random().toString(36).substr(2, 9);
  if (allIDs[rnd]) {
    return randomID();
  }
  allIDs[rnd] = true;
  return rnd;
}

function redrawRegion(draw, erase) {
  var left = -1,
      right = -1,
      top = -1,
      bottom = -1;

  function processPolygon(polygon) {
    var bbox = polygon.bbox();

    left = left == -1 ? bbox.x : Math.min(left, bbox.x);
    right = Math.max(right, bbox.x + bbox.width);
    top = top == -1 ? bbox.y : Math.min(top, bbox.y);
    bottom = Math.max(bottom, bbox.y + bbox.height);
  }

  draw.forEach(processPolygon);
  erase.forEach(processPolygon);

  return {
    left: left,
    right: right,
    top: top,
    bottom: bottom
  };
}

function drawPolygonTo(polygon, ctx, erase, color) {
  ctx.save();
  ctx.globalCompositeOperation = erase ? 'destination-out' : 'source-over';
  ctx.strokeStyle = color;
  ctx.beginPath();

  var points = polygon.points;

  if (polygon.isClockwise()) {
    ctx.moveTo(points[0].x, points[0].y);
    for (var i = 1; i < points.length; i++) {
      ctx.lineTo(points[i].x, points[i].y);
    }
  } else if (points.length > 0) {
    ctx.moveTo(points[points.length - 1].x, points[points.length - 1].y);
    for (var x = points.length - 1; x >= 0; x--) {
      ctx.lineTo(points[x].x, points[x].y);
    }
  }

  ctx.closePath();
  ctx.fillStyle = color;
  ctx.fill();

  for (var h = 0; h < polygon.holes.length; h++) {
    var hole = polygon.holes[h];
    ctx.globalCompositeOperation = 'destination-out';
    ctx.beginPath();

    if (hole.isClockwise()) {
      ctx.moveTo(hole.points[hole.points.length - 1].x, hole.points[hole.points.length - 1].y);
      for (var k = hole.points.length - 1; k >= 0; k--) {
        ctx.lineTo(hole.points[k].x, hole.points[k].y);
      }
    } else {
      ctx.moveTo(hole.points[0].x, hole.points[0].y);
      for (var e = 0; e < hole.points.length; e++) {
        ctx.lineTo(hole.points[e].x, hole.points[e].y);
      }
    }

    ctx.closePath();
    ctx.fill();
  }

  ctx.restore();
}

/**
 * @constructor StateUpdate
 * @since 0.2.0
 */
function StateUpdate() {
  $.extend(this, updateAllState);

  this.layersChanged = new Set();
}

/**
 * Ensures everything is redrawn.
 *
 * @returns {StateUpdate} the calling object
 * @memberOf StateUpdate
 * @since 0.2.0
 */
StateUpdate.prototype.all = function () {
  this._updateLayers('all');
  return $.extend(this, updateAllState);
};

/**
 * Ensures that nothing will be redrawn.
 *
 * @returns {StateUpdate} the calling object
 * @memberOf StateUpdate
 * @since 0.2.0
 */
StateUpdate.prototype.reset = function () {
  return $.extend(this, updateNoneState);
};

/**
 * Updates a generic parameter. Only useful for custom updates with
 * corresponding drawing.
 *
 * @param {string} name - object property
 * @param {?object} options - update object
 * @returns {StateUpdate} the calling object
 * @memberOf StateUpdate
 * @since 0.2.0
 */
StateUpdate.prototype.update = function (name, options) {
  if (!this[name]) {
    this[name] = {};
  }

  if (!options) {
    options = updateAllState[name];
  }

  $.extend(true, this[name], options);

  return this;
};

/**
 * Updates the displayImage redraw property. Ensures that background image
 * is updated.
 *
 * @param {?object} options - update object
 * @param {bool} options.url
 * @returns {StateUpdate} the calling object
 * @memberOf StateUpdate
 * @since 0.2.0
 */
StateUpdate.prototype.updateDisplayImage = function (options) {
  this.update('displayImage', options);
  this.updateMasks({ size: true });

  return this;
};

/**
 * Updates the project redraw property. Ensures that specified project
 * properties are updated.
 *
 * @param {?object} options - update object
 * @param {bool} options.size
 * @returns {StateUpdate} the calling object
 * @memberOf StateUpdate
 * @since 0.2.0
 */
StateUpdate.prototype.updateProject = function (options) {
  if (!options || options.size) {
    // project size requires a full redraw of raster/vector
    this.drawing();
  }

  return this.update('project', options);
};

/**
 * Generic method for updating masks redraw property.
 *
 * @param {?object} options - update object
 * @returns {StateUpdate} the calling object
 * @memberOf StateUpdate
 * @since 0.2.0
 */
StateUpdate.prototype.updateMasks = function (options) {
  return this.update('masks', options);
};

/**
 * Updates raster redraw property.
 *
 * @param {?object} options - update object
 * @param {all|string[]} options.layers
 * @param {full|object} options.region
 * @returns {StateUpdate} the calling object
 * @memberOf StateUpdate
 * @since 0.2.0
 */
StateUpdate.prototype.raster = function (options) {
  // an update of raster composite will need to be redrawn for hover
  this.updateMasks({
    hover: true
  });

  if (!options) {
    options = updateAllState.masks.raster;
  }

  options.layers = convertToSet(options.layers || updateAllState.masks.raster.layers);
  options.region = options.region || updateAllState.masks.raster.region;
  options.region = toXYRegion(options.region);

  // never include the GLOBAL layer in update, it's always drawn
  delete options.layers.GLOBAL;

  this._updateLayers(options.layers);

  function toXYRegion(region) {
    if (region === 'full') {
      return 'full';
    }

    if (region.hasOwnProperty('x') && region.hasOwnProperty('y')) {
      return region;
    }

    return {
      x: Math.floor(region.left),
      y: Math.floor(region.top),
      width: Math.ceil(region.right - region.left),
      height: Math.ceil(region.bottom - region.top)
    };
  }

  if (!this.masks) {
    this.masks = {
      raster: {
        layers: options.layers,
        region: options.region
      }
    };
  } else if (!this.masks.raster) {
    this.masks.raster = {
      layers: options.layers,
      region: options.region
    };
  } else {
    var old = this.masks.raster;

    if (options.region === 'full') {
      this.masks.raster.region = 'full';
    } else if (old.region !== 'full') {
      // combine old & new region
      var region = {};
      var newRegion = options.region;
      var oldRegion = toXYRegion(old.region);

      region.left = Math.min(newRegion.x, oldRegion.x);
      region.top = Math.min(newRegion.y, oldRegion.y);
      region.right = Math.max(newRegion.x + newRegion.width, oldRegion.x + oldRegion.width);
      region.bottom = Math.max(newRegion.y + newRegion.height, oldRegion.y + oldRegion.height);

      this.masks.raster.region = toXYRegion(region);
    }

    if (options.layers === 'all') {
      this.masks.raster.layers = 'all';
    } else if (old.layers !== 'all') {
      // combine old & new layers
      var layers = this.masks.raster.layers;
      options.layers.forEach(function (layerID) {
        layers.add(layerID);
      });
    }
  }

  return this;
};

/**
 * Updates raster redraw property.
 *
 * @param {?object} options
 * @param {all|string[]} options.layers
 * @param {all|string[]} options.elements
 * @returns {StateUpdate} the calling object
 * @memberOf StateUpdate
 * @since 0.2.0
 */
StateUpdate.prototype.vector = function (options) {
  if (!options) {
    options = updateAllState.masks.vector;
  }

  options.layers = convertToSet(options.layers || updateAllState.masks.vector.layers);
  options.elements = convertToSet(options.elements || updateAllState.masks.vector.elements);

  // never include the GLOBAL layer in update, it's always drawn
  if (options.layers.GLOBAL) {
    delete options.layers.GLOBAL;
  }

  this._updateLayers(options.layers);

  if (!this.masks) {
    this.masks = {
      vector: {
        layers: options.layers,
        elements: options.elements
      }
    };
  } else if (!this.masks.vector) {
    this.masks.vector = {
      layers: options.layers,
      elements: options.elements
    };
  } else {
    var old = this.masks.vector;

    if (options.layers === 'all') {
      this.masks.vector.layers = 'all';
    } else if (old.layers !== 'all') {
      // combine old & new layers
      var layers = this.masks.vector.layers;
      options.layers.forEach(function (layerID) {
        layers.add(layerID);
      });
    }

    if (options.elements === 'all') {
      this.masks.vector.elements = 'all';
    } else if (old.elements !== 'all') {
      var elements = this.masks.vector.elements;
      options.elements.forEach(function (elementID) {
        elements.add(elementID);
      });
    }
  }

  return this;
};

/**
 * Updates raster & vector properties. Is simply a shortcut for calling both
 * {@link StateUpdate#raster raster} and {@link StateUpdate#vector vector}.
 *
 * @param {string[]} [layers] - layers to pass to {@link StateUpdate#raster raster} and {@link StateUpdate#vector vector}
 * @returns {StateUpdate} the calling object
 * @memberOf StateUpdate
 * @since 0.2.0
 */
StateUpdate.prototype.drawing = function (layers) {
  this.raster({
    layers: layers
  });
  this.vector({
    layers: layers
  });

  return this;
};

StateUpdate.prototype.getLayersUpdated = function (reset) {
  var updated = [];
  this.layersChanged.forEach(function (id) {
    updated.push(id);
  });

  if (reset) {
    this.layersChanged.clear();
  }

  return updated;
};

StateUpdate.prototype._updateLayers = function (layers) {
  if (layers === 'all') {
    // TODO: this is a bit of a hack because this can be called before state is ready
    if (MaskingModule.state) {
      layers = MaskingModule.state.layerIDs;
    }
  }

  if (!layers) {
    return;
  }

  for (var i = 0; i < layers.length; i++) {
    if (layers[i] && layers[i] !== 'GLOBAL') {
      this.layersChanged.add(layers[i]);
    }
  }
};

var updateAllState = {
  displayImage: {
    url: true
  },
  project: {
    size: true
  },
  masks: {
    size: true,
    offset: true,
    hover: true,
    peek: true,

    raster: {
      layers: 'all',
      region: 'full'
    },
    vector: {
      layers: 'all',
      elements: 'all'
    }
  }
};

var updateNoneState = {
  displayImage: false,
  project: false,
  masks: false
};

function convertToSet(listOrAll) {
  if (listOrAll === 'all') {
    return 'all';
  }
  var set = new Set(listOrAll);
  set.delete(null);
  return set;
}

/**
 * Events bound to {@link MaskingModule}.
 *
 * These are for listening to important events only (for UI updates or other
 * functionality).
 *
 * @example
 * $(MaskingModule).on(MaskingModule.Events.Panning, function(event, enabled) {
 *   console.log("panning was " + (enabled ? "enabled" : "disabled"));
 * });
 *
 * @global
 * @readonly
 */
var Events = {
  /**
   * Clicking a hovered layer.
   *
   * @example
   * $(MaskingModule).bind(MaskingModule.Events.LayerClicked, function(event, id) {
   *   MaskingModule.selectLayer(id);
   * });
   *
   * @since 0.2.0
   */
  LayerClicked: 'LayerClicked',

  /**
   * {@link MaskingModule.selectLayer selectLayer} was called.
   *
   * @example
   * $(MaskingModule).bind(MaskingModule.Events.LayerSelected, function(event, id) {
   *   console.log("Layer selected:", id);
   * });
   *
   * @since 0.2.0
   */
  LayerSelected: 'LayerSelected',

  /**
   * Layer was added, removed or shifted.
   *
   * @since 0.3.0
   */
  LayerModified: 'LayerModified',

  LayerHovered: 'LayerHovered',

  /**
   * Layer polygons were updated
   *
   * @since 0.4.4
   */
  LayerVectorUpdated: 'LayerVectorUpdated',

  /**
   * Raster data was updated
   *
   * @since 0.4.4
   */
  LayerRastorUpdated: 'LayerRastorUpdated',

  /**
   * {@link MaskingModule.loadProjectXML} was called (and finished).
   *
   * @example
   * $(MaskingModule).bind(MaskingModule.Events.ProjectLoaded, function(event, state) {
   *   state.layerGroups.forEach(function(groupName) {
   *     addLayerGroupToUI(groupName, {
   *       layers: state.getGroupLayers(groupName)
   *     });
   *   });
   * });
   *
   * @since 0.2.0
   */
  ProjectLoaded: 'ProjectLoaded',

  /**
   * Points were set in the {@link SetScale} tool.
   *
   * @example
   * $(MaskingModule).bind(MaskingModule.Events.ScaleSet, function(event, scale) {
   *   console.log("Scale set:", scale.start, scale.end);
   * });
   *
   * @since 0.2.0
   */
  ScaleSet: 'ScaleSet',

  /**
   * Panning enabled / disabled.
   *
   * @example
   * $(MaskingModule).bind(MaskingModule.Events.Panning, function(event, enabled) {
   *   console.log("panning was " + (enabled ? "enabled" : "disabled"));
   * });
   *
   * @since 0.2.0
   */
  Panning: 'Panning',

  /**
   * Current tool was changed or removed.
   *
   * @example
   * $(MaskingModule).bind(MaskingModule.Events.ToolChanged, function(event, tool) {
   *   if (tool) {
   *     console.log("tool changed");
   *   } else {
   *     console.log("tool removed");
   *   }
   * });
   *
   * @since 0.2.0
   */
  ToolChanged: 'ToolChanged',

  /**
   * Undo step is available.
   *
   * @example
   * $(MaskingModule).bind(MaskingModule.Events.UndoAvailable, function(event) {
   *   console.log("Undo is available");
   * });
   *
   * @since 0.2.0
   */
  UndoAvailable: 'UndoAvailable',

  /**
   * Undo step is not available.
   *
   * @example
   * $(MaskingModule).bind(MaskingModule.Events.UndoUnavailable, function(event) {
   *   console.log("Undo is not available");
   * });
   *
   * @since 0.2.0
   */
  UndoUnavailable: 'UndoUnavailable',

  /**
   * Redo step is available.
   *
   * @example
   * $(MaskingModule).bind(MaskingModule.Events.RedoAvailable, function(event) {
   *   console.log("Redo is available");
   * });
   *
   * @since 0.2.0
   */
  RedoAvailable: 'RedoAvailable',

  /**
   * Redo step is not available.
   *
   * @example
   * $(MaskingModule).bind(MaskingModule.Events.RedoUnavailable, function(event) {
   *   console.log("Redo is not available");
   * });
   *
   * @since 0.2.0
   */
  RedoUnavailable: 'RedoUnavailable',

  /**
   * Layer perspective has changed.
   *
   * @example
   * $(MaskingModule).bind(MaskingModule.Events.LayerPerspectiveUpdated, function(event) {
   *   console.log("Layer Perspective Updated");
   * });
   *
   * @since 0.4.2
   */
  LayerPerspectiveUpdated: 'LayerPerspectiveUpdated'
};

// required object hierarchy for a State
var stateModel = {
  project: {
    image: {}
  },
  view: {
    container: {},
    offset: {}
  }
};

// defines a property with special behaviour / reaction to set()
var defineProperty$1 = function defineProperty$$1(parent, name, _ref) {
  var value = _ref.value,
      _ref$update = _ref.update,
      update = _ref$update === undefined ? function (val) {} : _ref$update;

  // true value of the property
  var privateValue = value;

  if (value !== undefined) {
    // call once up front
    update(value, undefined, parent);
  }

  Object.defineProperty(parent, name, {
    enumerable: true,
    set: function set$$1(newValue) {
      var previousValue = privateValue;
      privateValue = newValue;
      if (newValue !== previousValue) {
        update(newValue, previousValue, parent);
      }
    },
    get: function get$$1() {
      return privateValue;
    }
  });
};

var MaskingState = function () {
  function MaskingState() {
    var _this = this;

    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    classCallCheck(this, MaskingState);

    // ensures that `this` and `state` have object hierarchy
    $.extend(true, this, stateModel);
    $.extend(true, state, stateModel);

    var updateViewRatios = function updateViewRatios() {
      if (!_this.project.width || !_this.project.height || !_this.view.width || !_this.view.height) {
        return;
      }

      if (!Settings$1.dontPreserveAspectRatio) {
        var widthRatio = _this.view.width / _this.project.width;
        var heightRatio = _this.view.height / _this.project.height;
        var ratio = Math.min(widthRatio, heightRatio);
        _this.view.widthRatio = ratio;
        _this.view.heightRatio = ratio;
      }
    };

    Object.defineProperty(this, 'update', { value: new StateUpdate() });
    Object.defineProperty(this, 'layers', { value: state.layers || {}, enumerable: true });
    Object.defineProperty(this, 'layerGroups', { value: state.layerGroups || {}, enumerable: true });
    Object.defineProperty(this, 'layersOrder', { value: state.layersOrder || [], enumerable: true });

    defineProperty$1(this, 'currentTool', { value: state.currentTool || null });

    defineProperty$1(this, 'selectedLayer', {
      value: state.selectedLayer || null,
      update: function update(layer, previous) {
        return _this.update.drawing([layer, previous]);
      }
    });

    defineProperty$1(this.project, 'width', {
      value: state.project.width || 0,
      update: function update() {
        updateViewRatios();

        // project size changed, so global layer should get re-written
        _this.newLayer('GLOBAL');
        _this.update.updateProject({ size: true });
      }
    });
    defineProperty$1(this.project, 'height', {
      value: state.project.height || 0,
      update: function update() {
        updateViewRatios();

        // project size changed, so global layer should get re-written
        _this.newLayer('GLOBAL');
        _this.update.updateProject({ size: true });
      }
    });

    defineProperty$1(this.view, 'width', {
      value: state.view.width,
      update: function update(value) {
        _this.view.container.width = value;
        updateViewRatios();

        _this.update.updateMasks({ size: true });
      }
    });
    defineProperty$1(this.view, 'height', {
      value: state.view.height,
      update: function update(value) {
        _this.view.container.height = value;
        updateViewRatios();

        _this.update.updateMasks({ size: true });
      }
    });

    defineProperty$1(this.view, 'scale', {
      value: state.view.scale || 1.0,
      update: function update() {
        return _this.update.updateMasks({ size: true });
      }
    });

    defineProperty$1(this.view.offset, 'x', {
      value: state.view.offset.x || 0,
      update: function update() {
        return _this.update.updateMasks({ offset: true });
      }
    });
    defineProperty$1(this.view.offset, 'y', {
      value: state.view.offset.y || 0,
      update: function update() {
        return _this.update.updateMasks({ offset: true });
      }
    });

    defineProperty$1(this.view.container, 'width', {
      value: state.view.container.width || this.view.width,
      update: function update() {
        return _this.update.updateMasks({ size: true });
      }
    });
    defineProperty$1(this.view.container, 'height', {
      value: state.view.container.height || this.view.height,
      update: function update() {
        return _this.update.updateMasks({ size: true });
      }
    });

    defineProperty$1(this.view, 'displayImageURL', {
      value: state.view.displayImageURL || state.project.image.url || null,
      update: function update() {
        return _this.update.updateDisplayImage({ url: true });
      }
    });
    defineProperty$1(this.project.image, 'url', {
      value: state.project.image.url || null,
      update: function update(url, _, image) {
        _this.view.displayImageURL = url;

        // this.project.image is an object with the project image as a canvas
        image.canvas = document.createElement('canvas');
        image.canvas.width = _this.project.width;
        image.canvas.height = _this.project.height;
        image.context = image.canvas.getContext('2d');

        if (url && _this.project.width && _this.project.height) {
          var loading = new Image();

          image.load = new Promise(function (resolve, reject) {
            loading.onload = function () {
              // this looks funny, but here for a reason...
              // because the project master image could load quickly from
              // optimization, this handler is fired before other layers
              // start to load their contents
              //
              // which means that it delays the FMP of anything, and even
              // if it didnt, getImageData is slower when master image
              // hasnt been used yet
              //
              // in short, if this causes any problems, it's fine to
              // remove the timeout. but it's here for loading projects
              // just a bit faster.
              setTimeout(function () {
                // try catch to prevent IE11 SCRIPT5022 error
                // https://docs.microsoft.com/en-us/scripting/javascript/misc/exception-thrown-and-not-caught
                try {
                  image.context.drawImage(loading, 0, 0, image.canvas.width, image.canvas.height);
                  image.data = image.context.getImageData(0, 0, image.canvas.width, image.canvas.height).data;
                  resolve(image.canvas);
                } catch (err) {
                  console.warn(err);
                }
              }, 50);
            };

            loading.onerror = function () {
              reject(new Error('error: master not found - ' + url));
            };
          });

          loading.crossOrigin = 'anonymous';
          loading.src = url;
        } else {
          // empty try-catch to prevent devtools from breaking here every time
          try {
            image.load = Promise.reject(new Error('project image has not been set'));
            image.load.catch(function () {});
          } catch (err) {}
          image.data = null;
        }
      }
    });

    defineProperty$1(this.view, 'layerViewOption', {
      value: state.view.layerViewOption || LayerViewOption.current,
      update: function update() {
        return _this.update.drawing();
      }
    });
    defineProperty$1(this.view, 'layerHoverOption', {
      value: state.view.layerHoverOption || LayerHoverOption.none,
      update: function update() {
        return _this.update.drawing();
      }
    });
    defineProperty$1(this.view, 'showForeground', {
      value: state.view.showForeground === undefined ? true : state.view.showForeground,
      update: function update() {
        return _this.update.drawing();
      }
    });

    var globalLayer = this.layers.GLOBAL;
    if (!globalLayer || globalLayer.width !== this.project.width || globalLayer.height !== this.project.height) {
      this.newLayer('GLOBAL');
    }
  }

  createClass(MaskingState, [{
    key: 'export',
    value: function _export() {
      return $.extend(true, {}, this);
    }
  }, {
    key: 'newLayer',
    value: function newLayer(id, properties, order) {
      if (!id) {
        var max = 0;
        for (var layerID in this.layers) {
          if (!isNaN(parseInt(layerID))) {
            max = Math.max(max, parseInt(layerID));
          }
        }

        id = max + 1;
      }

      id = id.toString();

      var gutter = {
        x: this.gutterX,
        y: this.gutterY
      };

      this.layers[id] = new MaskingLayer(id, this.project.width, this.project.height, gutter, properties);
      this.layerGroups[id] = properties ? properties.group : undefined;

      if (id !== 'GLOBAL') {
        if (typeof order === 'undefined') {
          this.layersOrder.push(id);
        } else {
          this.layersOrder[order] = id;
        }
      }

      this.update.vector({
        layers: [id]
      });

      $(window.MaskingModule).trigger(Events.LayerModified, {
        type: 'added',
        layerID: id
      });

      return id;
    }
  }, {
    key: 'setLayerOrder',
    value: function setLayerOrder(ids) {
      var _this2 = this;

      if (Array.isArray(ids)) {
        ids.forEach(function (id, index) {
          _this2.layersOrder[index] = id;
        });
      }
    }
  }, {
    key: 'shiftLayer',
    value: function shiftLayer(id, amount) {
      id = id.toString();

      var order = this.layersOrder;
      var index = order.indexOf(id);
      var removed = void 0;

      if (amount === 'top') {
        amount = order.length - 1 - index;
      } else if (amount === 'bottom') {
        amount = -index;
      }

      if (amount === 0) {} else if (amount < 0) {
        amount = Math.abs(amount);
        index -= amount;

        // cannot shift below zero
        if (index < 0) {
          return;
        }

        removed = order.splice(index, amount + 1);
        removed.pop();

        order.splice(index, 0, id);

        removed.reverse().forEach(function (i) {
          order.splice(index + 1, 0, i);
        });
      } else {
        if (index + amount > order.length - 1) {
          amount = order.length - index;
        }

        removed = order.splice(index, amount);
        removed.shift();

        removed.reverse().forEach(function (i) {
          order.splice(index, 0, i);
        });

        order.splice(index + amount, 0, id);
      }
    }
  }, {
    key: 'mergeLayers',
    value: function mergeLayers(layerID, mergeLayerID) {
      if (arguments.length > 2) {
        for (var i = 1; i < arguments.length; i++) {
          this.mergeLayers(layerID, arguments[i]);
        }

        return;
      }

      var layer = this.layers[layerID.toString()];
      var mergeLayer = this.layers[mergeLayerID.toString()];

      if (!mergeLayer.hasNoRasterComponent) {
        layer.drawRaster(function (ctx) {
          ctx.save();
          ctx.drawImage(mergeLayer.drawingCanvas, 0, 0);
          ctx.fillStyle = layer.maskColor;
          ctx.globalCompositeOperation = 'source-in';
          ctx.fillRect(0, 0, ctx.canvas.width, ctx.canvas.height);
          ctx.restore();
        });
      }

      for (var polygonID in mergeLayer.polygons) {
        layer.mergePolygon(layer.addPolygon(mergeLayer.polygons[polygonID]));
      }

      MaskingModule.removeLayer(mergeLayerID);
    }
  }, {
    key: 'getLayerGroups',
    value: function getLayerGroups() {
      return Object.values(this.layerGroups).reduce(function (groups, group) {
        if (group && groups.indexOf(group) === -1) {
          groups.push(group);
        }

        return groups;
      }, []);
    }
  }, {
    key: 'getGroupLayers',
    value: function getGroupLayers(groupName) {
      var layerGroups = this.layerGroups;
      return Object.keys(layerGroups).filter(function (layerID) {
        return layerGroups[layerID] === groupName;
      });
    }
  }, {
    key: 'widthScale',
    get: function get$$1() {
      return this.view.scale * this.view.widthRatio;
    }
  }, {
    key: 'heightScale',
    get: function get$$1() {
      return this.view.scale * this.view.heightRatio;
    }
  }, {
    key: 'gutter',
    get: function get$$1() {
      return new Point(this.gutterX, this.gutterY);
    }
  }, {
    key: 'gutterX',
    get: function get$$1() {
      return this.project.width * Settings$1.gutter / 2;
    }
  }, {
    key: 'gutterY',
    get: function get$$1() {
      return this.project.height * Settings$1.gutter / 2;
    }
  }, {
    key: 'projectWidthWithGutter',
    get: function get$$1() {
      return this.project.width + 2 * this.gutterX;
    }
  }, {
    key: 'projectHeightWithGutter',
    get: function get$$1() {
      return this.project.height + 2 * this.gutterY;
    }
  }, {
    key: 'layerIDs',
    get: function get$$1() {
      return this.layersOrder;
    }
  }]);
  return MaskingState;
}();

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var hammer = createCommonjsModule(function (module) {
/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
(function(window, document, exportName, undefined) {

var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
var TEST_ELEMENT = document.createElement('div');

var TYPE_FUNCTION = 'function';

var round = Math.round;
var abs = Math.abs;
var now = Date.now;

/**
 * set a timeout with a given scope
 * @param {Function} fn
 * @param {Number} timeout
 * @param {Object} context
 * @returns {number}
 */
function setTimeoutContext(fn, timeout, context) {
    return setTimeout(bindFn(fn, context), timeout);
}

/**
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */
function invokeArrayArg(arg, fn, context) {
    if (Array.isArray(arg)) {
        each(arg, context[fn], context);
        return true;
    }
    return false;
}

/**
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */
function each(obj, iterator, context) {
    var i;

    if (!obj) {
        return;
    }

    if (obj.forEach) {
        obj.forEach(iterator, context);
    } else if (obj.length !== undefined) {
        i = 0;
        while (i < obj.length) {
            iterator.call(context, obj[i], i, obj);
            i++;
        }
    } else {
        for (i in obj) {
            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
        }
    }
}

/**
 * wrap a method with a deprecation warning and stack trace
 * @param {Function} method
 * @param {String} name
 * @param {String} message
 * @returns {Function} A new function wrapping the supplied method.
 */
function deprecate(method, name, message) {
    var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
    return function() {
        var e = new Error('get-stack-trace');
        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '')
            .replace(/^\s+at\s+/gm, '')
            .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';

        var log = window.console && (window.console.warn || window.console.log);
        if (log) {
            log.call(window.console, deprecationMessage, stack);
        }
        return method.apply(this, arguments);
    };
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} target
 * @param {...Object} objects_to_assign
 * @returns {Object} target
 */
var assign;
if (typeof Object.assign !== 'function') {
    assign = function assign(target) {
        if (target === undefined || target === null) {
            throw new TypeError('Cannot convert undefined or null to object');
        }

        var output = Object(target);
        for (var index = 1; index < arguments.length; index++) {
            var source = arguments[index];
            if (source !== undefined && source !== null) {
                for (var nextKey in source) {
                    if (source.hasOwnProperty(nextKey)) {
                        output[nextKey] = source[nextKey];
                    }
                }
            }
        }
        return output;
    };
} else {
    assign = Object.assign;
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge=false]
 * @returns {Object} dest
 */
var extend = deprecate(function extend(dest, src, merge) {
    var keys = Object.keys(src);
    var i = 0;
    while (i < keys.length) {
        if (!merge || (merge && dest[keys[i]] === undefined)) {
            dest[keys[i]] = src[keys[i]];
        }
        i++;
    }
    return dest;
}, 'extend', 'Use `assign`.');

/**
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */
var merge = deprecate(function merge(dest, src) {
    return extend(dest, src, true);
}, 'merge', 'Use `assign`.');

/**
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */
function inherit(child, base, properties) {
    var baseP = base.prototype,
        childP;

    childP = child.prototype = Object.create(baseP);
    childP.constructor = child;
    childP._super = baseP;

    if (properties) {
        assign(childP, properties);
    }
}

/**
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */
function bindFn(fn, context) {
    return function boundFn() {
        return fn.apply(context, arguments);
    };
}

/**
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */
function boolOrFn(val, args) {
    if (typeof val == TYPE_FUNCTION) {
        return val.apply(args ? args[0] || undefined : undefined, args);
    }
    return val;
}

/**
 * use the val2 when val1 is undefined
 * @param {*} val1
 * @param {*} val2
 * @returns {*}
 */
function ifUndefined(val1, val2) {
    return (val1 === undefined) ? val2 : val1;
}

/**
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function addEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.addEventListener(type, handler, false);
    });
}

/**
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function removeEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.removeEventListener(type, handler, false);
    });
}

/**
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */
function hasParent(node, parent) {
    while (node) {
        if (node == parent) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}

/**
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */
function inStr(str, find) {
    return str.indexOf(find) > -1;
}

/**
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */
function splitStr(str) {
    return str.trim().split(/\s+/g);
}

/**
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */
function inArray(src, find, findByKey) {
    if (src.indexOf && !findByKey) {
        return src.indexOf(find);
    } else {
        var i = 0;
        while (i < src.length) {
            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
                return i;
            }
            i++;
        }
        return -1;
    }
}

/**
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */
function toArray(obj) {
    return Array.prototype.slice.call(obj, 0);
}

/**
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */
function uniqueArray(src, key, sort) {
    var results = [];
    var values = [];
    var i = 0;

    while (i < src.length) {
        var val = key ? src[i][key] : src[i];
        if (inArray(values, val) < 0) {
            results.push(src[i]);
        }
        values[i] = val;
        i++;
    }

    if (sort) {
        if (!key) {
            results = results.sort();
        } else {
            results = results.sort(function sortUniqueArray(a, b) {
                return a[key] > b[key];
            });
        }
    }

    return results;
}

/**
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */
function prefixed(obj, property) {
    var prefix, prop;
    var camelProp = property[0].toUpperCase() + property.slice(1);

    var i = 0;
    while (i < VENDOR_PREFIXES.length) {
        prefix = VENDOR_PREFIXES[i];
        prop = (prefix) ? prefix + camelProp : property;

        if (prop in obj) {
            return prop;
        }
        i++;
    }
    return undefined;
}

/**
 * get a unique id
 * @returns {number} uniqueId
 */
var _uniqueId = 1;
function uniqueId() {
    return _uniqueId++;
}

/**
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */
function getWindowForElement(element) {
    var doc = element.ownerDocument || element;
    return (doc.defaultView || doc.parentWindow || window);
}

var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;

var SUPPORT_TOUCH = ('ontouchstart' in window);
var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);

var INPUT_TYPE_TOUCH = 'touch';
var INPUT_TYPE_PEN = 'pen';
var INPUT_TYPE_MOUSE = 'mouse';
var INPUT_TYPE_KINECT = 'kinect';

var COMPUTE_INTERVAL = 25;

var INPUT_START = 1;
var INPUT_MOVE = 2;
var INPUT_END = 4;
var INPUT_CANCEL = 8;

var DIRECTION_NONE = 1;
var DIRECTION_LEFT = 2;
var DIRECTION_RIGHT = 4;
var DIRECTION_UP = 8;
var DIRECTION_DOWN = 16;

var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;

var PROPS_XY = ['x', 'y'];
var PROPS_CLIENT_XY = ['clientX', 'clientY'];

/**
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */
function Input(manager, callback) {
    var self = this;
    this.manager = manager;
    this.callback = callback;
    this.element = manager.element;
    this.target = manager.options.inputTarget;

    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
    // so when disabled the input events are completely bypassed.
    this.domHandler = function(ev) {
        if (boolOrFn(manager.options.enable, [manager])) {
            self.handler(ev);
        }
    };

    this.init();

}

Input.prototype = {
    /**
     * should handle the inputEvent data and trigger the callback
     * @virtual
     */
    handler: function() { },

    /**
     * bind the events
     */
    init: function() {
        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    },

    /**
     * unbind the events
     */
    destroy: function() {
        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    }
};

/**
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */
function createInputInstance(manager) {
    var Type;
    var inputClass = manager.options.inputClass;

    if (inputClass) {
        Type = inputClass;
    } else if (SUPPORT_POINTER_EVENTS) {
        Type = PointerEventInput;
    } else if (SUPPORT_ONLY_TOUCH) {
        Type = TouchInput;
    } else if (!SUPPORT_TOUCH) {
        Type = MouseInput;
    } else {
        Type = TouchMouseInput;
    }
    return new (Type)(manager, inputHandler);
}

/**
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */
function inputHandler(manager, eventType, input) {
    var pointersLen = input.pointers.length;
    var changedPointersLen = input.changedPointers.length;
    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));

    input.isFirst = !!isFirst;
    input.isFinal = !!isFinal;

    if (isFirst) {
        manager.session = {};
    }

    // source event is the normalized value of the domEvents
    // like 'touchstart, mouseup, pointerdown'
    input.eventType = eventType;

    // compute scale, rotation etc
    computeInputData(manager, input);

    // emit secret event
    manager.emit('hammer.input', input);

    manager.recognize(input);
    manager.session.prevInput = input;
}

/**
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */
function computeInputData(manager, input) {
    var session = manager.session;
    var pointers = input.pointers;
    var pointersLength = pointers.length;

    // store the first input to calculate the distance and direction
    if (!session.firstInput) {
        session.firstInput = simpleCloneInputData(input);
    }

    // to compute scale and rotation we need to store the multiple touches
    if (pointersLength > 1 && !session.firstMultiple) {
        session.firstMultiple = simpleCloneInputData(input);
    } else if (pointersLength === 1) {
        session.firstMultiple = false;
    }

    var firstInput = session.firstInput;
    var firstMultiple = session.firstMultiple;
    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;

    var center = input.center = getCenter(pointers);
    input.timeStamp = now();
    input.deltaTime = input.timeStamp - firstInput.timeStamp;

    input.angle = getAngle(offsetCenter, center);
    input.distance = getDistance(offsetCenter, center);

    computeDeltaXY(session, input);
    input.offsetDirection = getDirection(input.deltaX, input.deltaY);

    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
    input.overallVelocityX = overallVelocity.x;
    input.overallVelocityY = overallVelocity.y;
    input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;

    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;

    input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
        session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);

    computeIntervalInputData(session, input);

    // find the correct target
    var target = manager.element;
    if (hasParent(input.srcEvent.target, target)) {
        target = input.srcEvent.target;
    }
    input.target = target;
}

function computeDeltaXY(session, input) {
    var center = input.center;
    var offset = session.offsetDelta || {};
    var prevDelta = session.prevDelta || {};
    var prevInput = session.prevInput || {};

    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
        prevDelta = session.prevDelta = {
            x: prevInput.deltaX || 0,
            y: prevInput.deltaY || 0
        };

        offset = session.offsetDelta = {
            x: center.x,
            y: center.y
        };
    }

    input.deltaX = prevDelta.x + (center.x - offset.x);
    input.deltaY = prevDelta.y + (center.y - offset.y);
}

/**
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */
function computeIntervalInputData(session, input) {
    var last = session.lastInterval || input,
        deltaTime = input.timeStamp - last.timeStamp,
        velocity, velocityX, velocityY, direction;

    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
        var deltaX = input.deltaX - last.deltaX;
        var deltaY = input.deltaY - last.deltaY;

        var v = getVelocity(deltaTime, deltaX, deltaY);
        velocityX = v.x;
        velocityY = v.y;
        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
        direction = getDirection(deltaX, deltaY);

        session.lastInterval = input;
    } else {
        // use latest velocity info if it doesn't overtake a minimum period
        velocity = last.velocity;
        velocityX = last.velocityX;
        velocityY = last.velocityY;
        direction = last.direction;
    }

    input.velocity = velocity;
    input.velocityX = velocityX;
    input.velocityY = velocityY;
    input.direction = direction;
}

/**
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */
function simpleCloneInputData(input) {
    // make a simple copy of the pointers because we will get a reference if we don't
    // we only need clientXY for the calculations
    var pointers = [];
    var i = 0;
    while (i < input.pointers.length) {
        pointers[i] = {
            clientX: round(input.pointers[i].clientX),
            clientY: round(input.pointers[i].clientY)
        };
        i++;
    }

    return {
        timeStamp: now(),
        pointers: pointers,
        center: getCenter(pointers),
        deltaX: input.deltaX,
        deltaY: input.deltaY
    };
}

/**
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */
function getCenter(pointers) {
    var pointersLength = pointers.length;

    // no need to loop when only one touch
    if (pointersLength === 1) {
        return {
            x: round(pointers[0].clientX),
            y: round(pointers[0].clientY)
        };
    }

    var x = 0, y = 0, i = 0;
    while (i < pointersLength) {
        x += pointers[i].clientX;
        y += pointers[i].clientY;
        i++;
    }

    return {
        x: round(x / pointersLength),
        y: round(y / pointersLength)
    };
}

/**
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */
function getVelocity(deltaTime, x, y) {
    return {
        x: x / deltaTime || 0,
        y: y / deltaTime || 0
    };
}

/**
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */
function getDirection(x, y) {
    if (x === y) {
        return DIRECTION_NONE;
    }

    if (abs(x) >= abs(y)) {
        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
    }
    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
}

/**
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */
function getDistance(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];

    return Math.sqrt((x * x) + (y * y));
}

/**
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */
function getAngle(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];
    return Math.atan2(y, x) * 180 / Math.PI;
}

/**
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */
function getRotation(start, end) {
    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
}

/**
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */
function getScale(start, end) {
    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
}

var MOUSE_INPUT_MAP = {
    mousedown: INPUT_START,
    mousemove: INPUT_MOVE,
    mouseup: INPUT_END
};

var MOUSE_ELEMENT_EVENTS = 'mousedown';
var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';

/**
 * Mouse events input
 * @constructor
 * @extends Input
 */
function MouseInput() {
    this.evEl = MOUSE_ELEMENT_EVENTS;
    this.evWin = MOUSE_WINDOW_EVENTS;

    this.pressed = false; // mousedown state

    Input.apply(this, arguments);
}

inherit(MouseInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function MEhandler(ev) {
        var eventType = MOUSE_INPUT_MAP[ev.type];

        // on start we want to have the left mouse button down
        if (eventType & INPUT_START && ev.button === 0) {
            this.pressed = true;
        }

        if (eventType & INPUT_MOVE && ev.which !== 1) {
            eventType = INPUT_END;
        }

        // mouse must be down
        if (!this.pressed) {
            return;
        }

        if (eventType & INPUT_END) {
            this.pressed = false;
        }

        this.callback(this.manager, eventType, {
            pointers: [ev],
            changedPointers: [ev],
            pointerType: INPUT_TYPE_MOUSE,
            srcEvent: ev
        });
    }
});

var POINTER_INPUT_MAP = {
    pointerdown: INPUT_START,
    pointermove: INPUT_MOVE,
    pointerup: INPUT_END,
    pointercancel: INPUT_CANCEL,
    pointerout: INPUT_CANCEL
};

// in IE10 the pointer types is defined as an enum
var IE10_POINTER_TYPE_ENUM = {
    2: INPUT_TYPE_TOUCH,
    3: INPUT_TYPE_PEN,
    4: INPUT_TYPE_MOUSE,
    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
};

var POINTER_ELEMENT_EVENTS = 'pointerdown';
var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';

// IE10 has prefixed support, and case-sensitive
if (window.MSPointerEvent && !window.PointerEvent) {
    POINTER_ELEMENT_EVENTS = 'MSPointerDown';
    POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
}

/**
 * Pointer events input
 * @constructor
 * @extends Input
 */
function PointerEventInput() {
    this.evEl = POINTER_ELEMENT_EVENTS;
    this.evWin = POINTER_WINDOW_EVENTS;

    Input.apply(this, arguments);

    this.store = (this.manager.session.pointerEvents = []);
}

inherit(PointerEventInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function PEhandler(ev) {
        var store = this.store;
        var removePointer = false;

        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;

        var isTouch = (pointerType == INPUT_TYPE_TOUCH);

        // get index of the event in the store
        var storeIndex = inArray(store, ev.pointerId, 'pointerId');

        // start and mouse must be down
        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
            if (storeIndex < 0) {
                store.push(ev);
                storeIndex = store.length - 1;
            }
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
            removePointer = true;
        }

        // it not found, so the pointer hasn't been down (so it's probably a hover)
        if (storeIndex < 0) {
            return;
        }

        // update the event in the store
        store[storeIndex] = ev;

        this.callback(this.manager, eventType, {
            pointers: store,
            changedPointers: [ev],
            pointerType: pointerType,
            srcEvent: ev
        });

        if (removePointer) {
            // remove from the store
            store.splice(storeIndex, 1);
        }
    }
});

var SINGLE_TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Touch events input
 * @constructor
 * @extends Input
 */
function SingleTouchInput() {
    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
    this.started = false;

    Input.apply(this, arguments);
}

inherit(SingleTouchInput, Input, {
    handler: function TEhandler(ev) {
        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];

        // should we handle the touch events?
        if (type === INPUT_START) {
            this.started = true;
        }

        if (!this.started) {
            return;
        }

        var touches = normalizeSingleTouches.call(this, ev, type);

        // when done, reset the started state
        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
            this.started = false;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function normalizeSingleTouches(ev, type) {
    var all = toArray(ev.touches);
    var changed = toArray(ev.changedTouches);

    if (type & (INPUT_END | INPUT_CANCEL)) {
        all = uniqueArray(all.concat(changed), 'identifier', true);
    }

    return [all, changed];
}

var TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */
function TouchInput() {
    this.evTarget = TOUCH_TARGET_EVENTS;
    this.targetIds = {};

    Input.apply(this, arguments);
}

inherit(TouchInput, Input, {
    handler: function MTEhandler(ev) {
        var type = TOUCH_INPUT_MAP[ev.type];
        var touches = getTouches.call(this, ev, type);
        if (!touches) {
            return;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function getTouches(ev, type) {
    var allTouches = toArray(ev.touches);
    var targetIds = this.targetIds;

    // when there is only one touch, the process can be simplified
    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
        targetIds[allTouches[0].identifier] = true;
        return [allTouches, allTouches];
    }

    var i,
        targetTouches,
        changedTouches = toArray(ev.changedTouches),
        changedTargetTouches = [],
        target = this.target;

    // get target touches from touches
    targetTouches = allTouches.filter(function(touch) {
        return hasParent(touch.target, target);
    });

    // collect touches
    if (type === INPUT_START) {
        i = 0;
        while (i < targetTouches.length) {
            targetIds[targetTouches[i].identifier] = true;
            i++;
        }
    }

    // filter changed touches to only contain touches that exist in the collected target ids
    i = 0;
    while (i < changedTouches.length) {
        if (targetIds[changedTouches[i].identifier]) {
            changedTargetTouches.push(changedTouches[i]);
        }

        // cleanup removed touches
        if (type & (INPUT_END | INPUT_CANCEL)) {
            delete targetIds[changedTouches[i].identifier];
        }
        i++;
    }

    if (!changedTargetTouches.length) {
        return;
    }

    return [
        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
        changedTargetTouches
    ];
}

/**
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */

var DEDUP_TIMEOUT = 2500;
var DEDUP_DISTANCE = 25;

function TouchMouseInput() {
    Input.apply(this, arguments);

    var handler = bindFn(this.handler, this);
    this.touch = new TouchInput(this.manager, handler);
    this.mouse = new MouseInput(this.manager, handler);

    this.primaryTouch = null;
    this.lastTouches = [];
}

inherit(TouchMouseInput, Input, {
    /**
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */
    handler: function TMEhandler(manager, inputEvent, inputData) {
        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH),
            isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);

        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
            return;
        }

        // when we're in a touch event, record touches to  de-dupe synthetic mouse event
        if (isTouch) {
            recordTouches.call(this, inputEvent, inputData);
        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
            return;
        }

        this.callback(manager, inputEvent, inputData);
    },

    /**
     * remove the event listeners
     */
    destroy: function destroy() {
        this.touch.destroy();
        this.mouse.destroy();
    }
});

function recordTouches(eventType, eventData) {
    if (eventType & INPUT_START) {
        this.primaryTouch = eventData.changedPointers[0].identifier;
        setLastTouch.call(this, eventData);
    } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
        setLastTouch.call(this, eventData);
    }
}

function setLastTouch(eventData) {
    var touch = eventData.changedPointers[0];

    if (touch.identifier === this.primaryTouch) {
        var lastTouch = {x: touch.clientX, y: touch.clientY};
        this.lastTouches.push(lastTouch);
        var lts = this.lastTouches;
        var removeLastTouch = function() {
            var i = lts.indexOf(lastTouch);
            if (i > -1) {
                lts.splice(i, 1);
            }
        };
        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
    }
}

function isSyntheticEvent(eventData) {
    var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
    for (var i = 0; i < this.lastTouches.length; i++) {
        var t = this.lastTouches[i];
        var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
            return true;
        }
    }
    return false;
}

var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;

// magical touchAction value
var TOUCH_ACTION_COMPUTE = 'compute';
var TOUCH_ACTION_AUTO = 'auto';
var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
var TOUCH_ACTION_NONE = 'none';
var TOUCH_ACTION_PAN_X = 'pan-x';
var TOUCH_ACTION_PAN_Y = 'pan-y';
var TOUCH_ACTION_MAP = getTouchActionProps();

/**
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */
function TouchAction(manager, value) {
    this.manager = manager;
    this.set(value);
}

TouchAction.prototype = {
    /**
     * set the touchAction value on the element or enable the polyfill
     * @param {String} value
     */
    set: function(value) {
        // find out the touch-action by the event handlers
        if (value == TOUCH_ACTION_COMPUTE) {
            value = this.compute();
        }

        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
        }
        this.actions = value.toLowerCase().trim();
    },

    /**
     * just re-set the touchAction value
     */
    update: function() {
        this.set(this.manager.options.touchAction);
    },

    /**
     * compute the value for the touchAction property based on the recognizer's settings
     * @returns {String} value
     */
    compute: function() {
        var actions = [];
        each(this.manager.recognizers, function(recognizer) {
            if (boolOrFn(recognizer.options.enable, [recognizer])) {
                actions = actions.concat(recognizer.getTouchAction());
            }
        });
        return cleanTouchActions(actions.join(' '));
    },

    /**
     * this method is called on each input cycle and provides the preventing of the browser behavior
     * @param {Object} input
     */
    preventDefaults: function(input) {
        var srcEvent = input.srcEvent;
        var direction = input.offsetDirection;

        // if the touch action did prevented once this session
        if (this.manager.session.prevented) {
            srcEvent.preventDefault();
            return;
        }

        var actions = this.actions;
        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];

        if (hasNone) {
            //do not prevent defaults if this is a tap gesture

            var isTapPointer = input.pointers.length === 1;
            var isTapMovement = input.distance < 2;
            var isTapTouchTime = input.deltaTime < 250;

            if (isTapPointer && isTapMovement && isTapTouchTime) {
                return;
            }
        }

        if (hasPanX && hasPanY) {
            // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
            return;
        }

        if (hasNone ||
            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
            (hasPanX && direction & DIRECTION_VERTICAL)) {
            return this.preventSrc(srcEvent);
        }
    },

    /**
     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
     * @param {Object} srcEvent
     */
    preventSrc: function(srcEvent) {
        this.manager.session.prevented = true;
        srcEvent.preventDefault();
    }
};

/**
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */
function cleanTouchActions(actions) {
    // none
    if (inStr(actions, TOUCH_ACTION_NONE)) {
        return TOUCH_ACTION_NONE;
    }

    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);

    // if both pan-x and pan-y are set (different recognizers
    // for different directions, e.g. horizontal pan but vertical swipe?)
    // we need none (as otherwise with pan-x pan-y combined none of these
    // recognizers will work, since the browser would handle all panning
    if (hasPanX && hasPanY) {
        return TOUCH_ACTION_NONE;
    }

    // pan-x OR pan-y
    if (hasPanX || hasPanY) {
        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
    }

    // manipulation
    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
        return TOUCH_ACTION_MANIPULATION;
    }

    return TOUCH_ACTION_AUTO;
}

function getTouchActionProps() {
    if (!NATIVE_TOUCH_ACTION) {
        return false;
    }
    var touchMap = {};
    var cssSupports = window.CSS && window.CSS.supports;
    ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function(val) {

        // If css.supports is not supported but there is native touch-action assume it supports
        // all values. This is the case for IE 10 and 11.
        touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
    });
    return touchMap;
}

/**
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */
var STATE_POSSIBLE = 1;
var STATE_BEGAN = 2;
var STATE_CHANGED = 4;
var STATE_ENDED = 8;
var STATE_RECOGNIZED = STATE_ENDED;
var STATE_CANCELLED = 16;
var STATE_FAILED = 32;

/**
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */
function Recognizer(options) {
    this.options = assign({}, this.defaults, options || {});

    this.id = uniqueId();

    this.manager = null;

    // default is enable true
    this.options.enable = ifUndefined(this.options.enable, true);

    this.state = STATE_POSSIBLE;

    this.simultaneous = {};
    this.requireFail = [];
}

Recognizer.prototype = {
    /**
     * @virtual
     * @type {Object}
     */
    defaults: {},

    /**
     * set options
     * @param {Object} options
     * @return {Recognizer}
     */
    set: function(options) {
        assign(this.options, options);

        // also update the touchAction, in case something changed about the directions/enabled state
        this.manager && this.manager.touchAction.update();
        return this;
    },

    /**
     * recognize simultaneous with an other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    recognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
            return this;
        }

        var simultaneous = this.simultaneous;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (!simultaneous[otherRecognizer.id]) {
            simultaneous[otherRecognizer.id] = otherRecognizer;
            otherRecognizer.recognizeWith(this);
        }
        return this;
    },

    /**
     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRecognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        delete this.simultaneous[otherRecognizer.id];
        return this;
    },

    /**
     * recognizer can only run when an other is failing
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    requireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
            return this;
        }

        var requireFail = this.requireFail;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (inArray(requireFail, otherRecognizer) === -1) {
            requireFail.push(otherRecognizer);
            otherRecognizer.requireFailure(this);
        }
        return this;
    },

    /**
     * drop the requireFailure link. it does not remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRequireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        var index = inArray(this.requireFail, otherRecognizer);
        if (index > -1) {
            this.requireFail.splice(index, 1);
        }
        return this;
    },

    /**
     * has require failures boolean
     * @returns {boolean}
     */
    hasRequireFailures: function() {
        return this.requireFail.length > 0;
    },

    /**
     * if the recognizer can recognize simultaneous with an other recognizer
     * @param {Recognizer} otherRecognizer
     * @returns {Boolean}
     */
    canRecognizeWith: function(otherRecognizer) {
        return !!this.simultaneous[otherRecognizer.id];
    },

    /**
     * You should use `tryEmit` instead of `emit` directly to check
     * that all the needed recognizers has failed before emitting.
     * @param {Object} input
     */
    emit: function(input) {
        var self = this;
        var state = this.state;

        function emit(event) {
            self.manager.emit(event, input);
        }

        // 'panstart' and 'panmove'
        if (state < STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }

        emit(self.options.event); // simple 'eventName' events

        if (input.additionalEvent) { // additional event(panleft, panright, pinchin, pinchout...)
            emit(input.additionalEvent);
        }

        // panend and pancancel
        if (state >= STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }
    },

    /**
     * Check that all the require failure recognizers has failed,
     * if true, it emits a gesture event,
     * otherwise, setup the state to FAILED.
     * @param {Object} input
     */
    tryEmit: function(input) {
        if (this.canEmit()) {
            return this.emit(input);
        }
        // it's failing anyway
        this.state = STATE_FAILED;
    },

    /**
     * can we emit?
     * @returns {boolean}
     */
    canEmit: function() {
        var i = 0;
        while (i < this.requireFail.length) {
            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
                return false;
            }
            i++;
        }
        return true;
    },

    /**
     * update the recognizer
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        // make a new copy of the inputData
        // so we can change the inputData without messing up the other recognizers
        var inputDataClone = assign({}, inputData);

        // is is enabled and allow recognizing?
        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
            this.reset();
            this.state = STATE_FAILED;
            return;
        }

        // reset when we've reached the end
        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
            this.state = STATE_POSSIBLE;
        }

        this.state = this.process(inputDataClone);

        // the recognizer has recognized a gesture
        // so trigger an event
        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
            this.tryEmit(inputDataClone);
        }
    },

    /**
     * return the state of the recognizer
     * the actual recognizing happens in this method
     * @virtual
     * @param {Object} inputData
     * @returns {Const} STATE
     */
    process: function(inputData) { }, // jshint ignore:line

    /**
     * return the preferred touch-action
     * @virtual
     * @returns {Array}
     */
    getTouchAction: function() { },

    /**
     * called when the gesture isn't allowed to recognize
     * like when another is being recognized or it is disabled
     * @virtual
     */
    reset: function() { }
};

/**
 * get a usable string, used as event postfix
 * @param {Const} state
 * @returns {String} state
 */
function stateStr(state) {
    if (state & STATE_CANCELLED) {
        return 'cancel';
    } else if (state & STATE_ENDED) {
        return 'end';
    } else if (state & STATE_CHANGED) {
        return 'move';
    } else if (state & STATE_BEGAN) {
        return 'start';
    }
    return '';
}

/**
 * direction cons to string
 * @param {Const} direction
 * @returns {String}
 */
function directionStr(direction) {
    if (direction == DIRECTION_DOWN) {
        return 'down';
    } else if (direction == DIRECTION_UP) {
        return 'up';
    } else if (direction == DIRECTION_LEFT) {
        return 'left';
    } else if (direction == DIRECTION_RIGHT) {
        return 'right';
    }
    return '';
}

/**
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */
function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
    var manager = recognizer.manager;
    if (manager) {
        return manager.get(otherRecognizer);
    }
    return otherRecognizer;
}

/**
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */
function AttrRecognizer() {
    Recognizer.apply(this, arguments);
}

inherit(AttrRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof AttrRecognizer
     */
    defaults: {
        /**
         * @type {Number}
         * @default 1
         */
        pointers: 1
    },

    /**
     * Used to check if it the recognizer receives valid input, like input.distance > 10.
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {Boolean} recognized
     */
    attrTest: function(input) {
        var optionPointers = this.options.pointers;
        return optionPointers === 0 || input.pointers.length === optionPointers;
    },

    /**
     * Process the input and return the state for the recognizer
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {*} State
     */
    process: function(input) {
        var state = this.state;
        var eventType = input.eventType;

        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
        var isValid = this.attrTest(input);

        // on cancel input and we've recognized before, return STATE_CANCELLED
        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
            return state | STATE_CANCELLED;
        } else if (isRecognized || isValid) {
            if (eventType & INPUT_END) {
                return state | STATE_ENDED;
            } else if (!(state & STATE_BEGAN)) {
                return STATE_BEGAN;
            }
            return state | STATE_CHANGED;
        }
        return STATE_FAILED;
    }
});

/**
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function PanRecognizer() {
    AttrRecognizer.apply(this, arguments);

    this.pX = null;
    this.pY = null;
}

inherit(PanRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PanRecognizer
     */
    defaults: {
        event: 'pan',
        threshold: 10,
        pointers: 1,
        direction: DIRECTION_ALL
    },

    getTouchAction: function() {
        var direction = this.options.direction;
        var actions = [];
        if (direction & DIRECTION_HORIZONTAL) {
            actions.push(TOUCH_ACTION_PAN_Y);
        }
        if (direction & DIRECTION_VERTICAL) {
            actions.push(TOUCH_ACTION_PAN_X);
        }
        return actions;
    },

    directionTest: function(input) {
        var options = this.options;
        var hasMoved = true;
        var distance = input.distance;
        var direction = input.direction;
        var x = input.deltaX;
        var y = input.deltaY;

        // lock to axis?
        if (!(direction & options.direction)) {
            if (options.direction & DIRECTION_HORIZONTAL) {
                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
                hasMoved = x != this.pX;
                distance = Math.abs(input.deltaX);
            } else {
                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
                hasMoved = y != this.pY;
                distance = Math.abs(input.deltaY);
            }
        }
        input.direction = direction;
        return hasMoved && distance > options.threshold && direction & options.direction;
    },

    attrTest: function(input) {
        return AttrRecognizer.prototype.attrTest.call(this, input) &&
            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
    },

    emit: function(input) {

        this.pX = input.deltaX;
        this.pY = input.deltaY;

        var direction = directionStr(input.direction);

        if (direction) {
            input.additionalEvent = this.options.event + direction;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */
function PinchRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(PinchRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'pinch',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
    },

    emit: function(input) {
        if (input.scale !== 1) {
            var inOut = input.scale < 1 ? 'in' : 'out';
            input.additionalEvent = this.options.event + inOut;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */
function PressRecognizer() {
    Recognizer.apply(this, arguments);

    this._timer = null;
    this._input = null;
}

inherit(PressRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PressRecognizer
     */
    defaults: {
        event: 'press',
        pointers: 1,
        time: 251, // minimal time of the pointer to be pressed
        threshold: 9 // a minimal movement is ok, but keep it low
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_AUTO];
    },

    process: function(input) {
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTime = input.deltaTime > options.time;

        this._input = input;

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
            this.reset();
        } else if (input.eventType & INPUT_START) {
            this.reset();
            this._timer = setTimeoutContext(function() {
                this.state = STATE_RECOGNIZED;
                this.tryEmit();
            }, options.time, this);
        } else if (input.eventType & INPUT_END) {
            return STATE_RECOGNIZED;
        }
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function(input) {
        if (this.state !== STATE_RECOGNIZED) {
            return;
        }

        if (input && (input.eventType & INPUT_END)) {
            this.manager.emit(this.options.event + 'up', input);
        } else {
            this._input.timeStamp = now();
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */
function RotateRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(RotateRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof RotateRecognizer
     */
    defaults: {
        event: 'rotate',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
    }
});

/**
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function SwipeRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(SwipeRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof SwipeRecognizer
     */
    defaults: {
        event: 'swipe',
        threshold: 10,
        velocity: 0.3,
        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
        pointers: 1
    },

    getTouchAction: function() {
        return PanRecognizer.prototype.getTouchAction.call(this);
    },

    attrTest: function(input) {
        var direction = this.options.direction;
        var velocity;

        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
            velocity = input.overallVelocity;
        } else if (direction & DIRECTION_HORIZONTAL) {
            velocity = input.overallVelocityX;
        } else if (direction & DIRECTION_VERTICAL) {
            velocity = input.overallVelocityY;
        }

        return this._super.attrTest.call(this, input) &&
            direction & input.offsetDirection &&
            input.distance > this.options.threshold &&
            input.maxPointers == this.options.pointers &&
            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
    },

    emit: function(input) {
        var direction = directionStr(input.offsetDirection);
        if (direction) {
            this.manager.emit(this.options.event + direction, input);
        }

        this.manager.emit(this.options.event, input);
    }
});

/**
 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */
function TapRecognizer() {
    Recognizer.apply(this, arguments);

    // previous time and center,
    // used for tap counting
    this.pTime = false;
    this.pCenter = false;

    this._timer = null;
    this._input = null;
    this.count = 0;
}

inherit(TapRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'tap',
        pointers: 1,
        taps: 1,
        interval: 300, // max time between the multi-tap taps
        time: 250, // max time of the pointer to be down (like finger on the screen)
        threshold: 9, // a minimal movement is ok, but keep it low
        posThreshold: 10 // a multi-tap can be a bit off the initial position
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_MANIPULATION];
    },

    process: function(input) {
        var options = this.options;

        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTouchTime = input.deltaTime < options.time;

        this.reset();

        if ((input.eventType & INPUT_START) && (this.count === 0)) {
            return this.failTimeout();
        }

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (validMovement && validTouchTime && validPointers) {
            if (input.eventType != INPUT_END) {
                return this.failTimeout();
            }

            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;

            this.pTime = input.timeStamp;
            this.pCenter = input.center;

            if (!validMultiTap || !validInterval) {
                this.count = 1;
            } else {
                this.count += 1;
            }

            this._input = input;

            // if tap count matches we have recognized it,
            // else it has began recognizing...
            var tapCount = this.count % options.taps;
            if (tapCount === 0) {
                // no failing requirements, immediately trigger the tap event
                // or wait as long as the multitap interval to trigger
                if (!this.hasRequireFailures()) {
                    return STATE_RECOGNIZED;
                } else {
                    this._timer = setTimeoutContext(function() {
                        this.state = STATE_RECOGNIZED;
                        this.tryEmit();
                    }, options.interval, this);
                    return STATE_BEGAN;
                }
            }
        }
        return STATE_FAILED;
    },

    failTimeout: function() {
        this._timer = setTimeoutContext(function() {
            this.state = STATE_FAILED;
        }, this.options.interval, this);
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function() {
        if (this.state == STATE_RECOGNIZED) {
            this._input.tapCount = this.count;
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Simple way to create a manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Hammer(element, options) {
    options = options || {};
    options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
    return new Manager(element, options);
}

/**
 * @const {string}
 */
Hammer.VERSION = '2.0.7';

/**
 * default settings
 * @namespace
 */
Hammer.defaults = {
    /**
     * set if DOM events are being triggered.
     * But this is slower and unused by simple implementations, so disabled by default.
     * @type {Boolean}
     * @default false
     */
    domEvents: false,

    /**
     * The value for the touchAction property/fallback.
     * When set to `compute` it will magically set the correct value based on the added recognizers.
     * @type {String}
     * @default compute
     */
    touchAction: TOUCH_ACTION_COMPUTE,

    /**
     * @type {Boolean}
     * @default true
     */
    enable: true,

    /**
     * EXPERIMENTAL FEATURE -- can be removed/changed
     * Change the parent input target element.
     * If Null, then it is being set the to main element.
     * @type {Null|EventTarget}
     * @default null
     */
    inputTarget: null,

    /**
     * force an input class
     * @type {Null|Function}
     * @default null
     */
    inputClass: null,

    /**
     * Default recognizer setup when calling `Hammer()`
     * When creating a new Manager these will be skipped.
     * @type {Array}
     */
    preset: [
        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
        [RotateRecognizer, {enable: false}],
        [PinchRecognizer, {enable: false}, ['rotate']],
        [SwipeRecognizer, {direction: DIRECTION_HORIZONTAL}],
        [PanRecognizer, {direction: DIRECTION_HORIZONTAL}, ['swipe']],
        [TapRecognizer],
        [TapRecognizer, {event: 'doubletap', taps: 2}, ['tap']],
        [PressRecognizer]
    ],

    /**
     * Some CSS properties can be used to improve the working of Hammer.
     * Add them to this method and they will be set when creating a new Manager.
     * @namespace
     */
    cssProps: {
        /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userSelect: 'none',

        /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */
        touchSelect: 'none',

        /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */
        touchCallout: 'none',

        /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */
        contentZooming: 'none',

        /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userDrag: 'none',

        /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */
        tapHighlightColor: 'rgba(0,0,0,0)'
    }
};

var STOP = 1;
var FORCED_STOP = 2;

/**
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Manager(element, options) {
    this.options = assign({}, Hammer.defaults, options || {});

    this.options.inputTarget = this.options.inputTarget || element;

    this.handlers = {};
    this.session = {};
    this.recognizers = [];
    this.oldCssProps = {};

    this.element = element;
    this.input = createInputInstance(this);
    this.touchAction = new TouchAction(this, this.options.touchAction);

    toggleCssProps(this, true);

    each(this.options.recognizers, function(item) {
        var recognizer = this.add(new (item[0])(item[1]));
        item[2] && recognizer.recognizeWith(item[2]);
        item[3] && recognizer.requireFailure(item[3]);
    }, this);
}

Manager.prototype = {
    /**
     * set options
     * @param {Object} options
     * @returns {Manager}
     */
    set: function(options) {
        assign(this.options, options);

        // Options that need a little more setup
        if (options.touchAction) {
            this.touchAction.update();
        }
        if (options.inputTarget) {
            // Clean up existing event listeners and reinitialize
            this.input.destroy();
            this.input.target = options.inputTarget;
            this.input.init();
        }
        return this;
    },

    /**
     * stop recognizing for this session.
     * This session will be discarded, when a new [input]start event is fired.
     * When forced, the recognizer cycle is stopped immediately.
     * @param {Boolean} [force]
     */
    stop: function(force) {
        this.session.stopped = force ? FORCED_STOP : STOP;
    },

    /**
     * run the recognizers!
     * called by the inputHandler function on every movement of the pointers (touches)
     * it walks through all the recognizers and tries to detect the gesture that is being made
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        var session = this.session;
        if (session.stopped) {
            return;
        }

        // run the touch-action polyfill
        this.touchAction.preventDefaults(inputData);

        var recognizer;
        var recognizers = this.recognizers;

        // this holds the recognizer that is being recognized.
        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
        // if no recognizer is detecting a thing, it is set to `null`
        var curRecognizer = session.curRecognizer;

        // reset when the last recognizer is recognized
        // or when we're in a new session
        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
            curRecognizer = session.curRecognizer = null;
        }

        var i = 0;
        while (i < recognizers.length) {
            recognizer = recognizers[i];

            // find out if we are allowed try to recognize the input for this one.
            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
            //      that is being recognized.
            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
            //      this can be setup with the `recognizeWith()` method on the recognizer.
            if (session.stopped !== FORCED_STOP && ( // 1
                    !curRecognizer || recognizer == curRecognizer || // 2
                    recognizer.canRecognizeWith(curRecognizer))) { // 3
                recognizer.recognize(inputData);
            } else {
                recognizer.reset();
            }

            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
            // current active recognizer. but only if we don't already have an active recognizer
            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
                curRecognizer = session.curRecognizer = recognizer;
            }
            i++;
        }
    },

    /**
     * get a recognizer by its event name.
     * @param {Recognizer|String} recognizer
     * @returns {Recognizer|Null}
     */
    get: function(recognizer) {
        if (recognizer instanceof Recognizer) {
            return recognizer;
        }

        var recognizers = this.recognizers;
        for (var i = 0; i < recognizers.length; i++) {
            if (recognizers[i].options.event == recognizer) {
                return recognizers[i];
            }
        }
        return null;
    },

    /**
     * add a recognizer to the manager
     * existing recognizers with the same event name will be removed
     * @param {Recognizer} recognizer
     * @returns {Recognizer|Manager}
     */
    add: function(recognizer) {
        if (invokeArrayArg(recognizer, 'add', this)) {
            return this;
        }

        // remove existing
        var existing = this.get(recognizer.options.event);
        if (existing) {
            this.remove(existing);
        }

        this.recognizers.push(recognizer);
        recognizer.manager = this;

        this.touchAction.update();
        return recognizer;
    },

    /**
     * remove a recognizer by name or instance
     * @param {Recognizer|String} recognizer
     * @returns {Manager}
     */
    remove: function(recognizer) {
        if (invokeArrayArg(recognizer, 'remove', this)) {
            return this;
        }

        recognizer = this.get(recognizer);

        // let's make sure this recognizer exists
        if (recognizer) {
            var recognizers = this.recognizers;
            var index = inArray(recognizers, recognizer);

            if (index !== -1) {
                recognizers.splice(index, 1);
                this.touchAction.update();
            }
        }

        return this;
    },

    /**
     * bind event
     * @param {String} events
     * @param {Function} handler
     * @returns {EventEmitter} this
     */
    on: function(events, handler) {
        if (events === undefined) {
            return;
        }
        if (handler === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            handlers[event] = handlers[event] || [];
            handlers[event].push(handler);
        });
        return this;
    },

    /**
     * unbind event, leave emit blank to remove all handlers
     * @param {String} events
     * @param {Function} [handler]
     * @returns {EventEmitter} this
     */
    off: function(events, handler) {
        if (events === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            if (!handler) {
                delete handlers[event];
            } else {
                handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
            }
        });
        return this;
    },

    /**
     * emit event to the listeners
     * @param {String} event
     * @param {Object} data
     */
    emit: function(event, data) {
        // we also want to trigger dom events
        if (this.options.domEvents) {
            triggerDomEvent(event, data);
        }

        // no handlers, so skip it all
        var handlers = this.handlers[event] && this.handlers[event].slice();
        if (!handlers || !handlers.length) {
            return;
        }

        data.type = event;
        data.preventDefault = function() {
            data.srcEvent.preventDefault();
        };

        var i = 0;
        while (i < handlers.length) {
            handlers[i](data);
            i++;
        }
    },

    /**
     * destroy the manager and unbinds all events
     * it doesn't unbind dom events, that is the user own responsibility
     */
    destroy: function() {
        this.element && toggleCssProps(this, false);

        this.handlers = {};
        this.session = {};
        this.input.destroy();
        this.element = null;
    }
};

/**
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */
function toggleCssProps(manager, add) {
    var element = manager.element;
    if (!element.style) {
        return;
    }
    var prop;
    each(manager.options.cssProps, function(value, name) {
        prop = prefixed(element.style, name);
        if (add) {
            manager.oldCssProps[prop] = element.style[prop];
            element.style[prop] = value;
        } else {
            element.style[prop] = manager.oldCssProps[prop] || '';
        }
    });
    if (!add) {
        manager.oldCssProps = {};
    }
}

/**
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */
function triggerDomEvent(event, data) {
    var gestureEvent = document.createEvent('Event');
    gestureEvent.initEvent(event, true, true);
    gestureEvent.gesture = data;
    data.target.dispatchEvent(gestureEvent);
}

assign(Hammer, {
    INPUT_START: INPUT_START,
    INPUT_MOVE: INPUT_MOVE,
    INPUT_END: INPUT_END,
    INPUT_CANCEL: INPUT_CANCEL,

    STATE_POSSIBLE: STATE_POSSIBLE,
    STATE_BEGAN: STATE_BEGAN,
    STATE_CHANGED: STATE_CHANGED,
    STATE_ENDED: STATE_ENDED,
    STATE_RECOGNIZED: STATE_RECOGNIZED,
    STATE_CANCELLED: STATE_CANCELLED,
    STATE_FAILED: STATE_FAILED,

    DIRECTION_NONE: DIRECTION_NONE,
    DIRECTION_LEFT: DIRECTION_LEFT,
    DIRECTION_RIGHT: DIRECTION_RIGHT,
    DIRECTION_UP: DIRECTION_UP,
    DIRECTION_DOWN: DIRECTION_DOWN,
    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
    DIRECTION_ALL: DIRECTION_ALL,

    Manager: Manager,
    Input: Input,
    TouchAction: TouchAction,

    TouchInput: TouchInput,
    MouseInput: MouseInput,
    PointerEventInput: PointerEventInput,
    TouchMouseInput: TouchMouseInput,
    SingleTouchInput: SingleTouchInput,

    Recognizer: Recognizer,
    AttrRecognizer: AttrRecognizer,
    Tap: TapRecognizer,
    Pan: PanRecognizer,
    Swipe: SwipeRecognizer,
    Pinch: PinchRecognizer,
    Rotate: RotateRecognizer,
    Press: PressRecognizer,

    on: addEventListeners,
    off: removeEventListeners,
    each: each,
    merge: merge,
    extend: extend,
    assign: assign,
    inherit: inherit,
    bindFn: bindFn,
    prefixed: prefixed
});

// this prevents errors when Hammer is loaded in the presence of an AMD
//  style loader but by script tag, not by the loader.
var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {})); // jshint ignore:line
freeGlobal.Hammer = Hammer;

if (typeof undefined === 'function' && undefined.amd) {
    undefined(function() {
        return Hammer;
    });
} else if ('object' != 'undefined' && module.exports) {
    module.exports = Hammer;
} else {
    window[exportName] = Hammer;
}

})(window, document, 'Hammer');
});

function History() {
  this.stack = [];
  this.stackIndex = -1;

  $(window.MaskingModule).trigger(Events.RedoUnavailable);
  $(window.MaskingModule).trigger(Events.UndoUnavailable);
}

History.current = null;
History.get = function () {
  if (History.current) {
    return History.current;
  }
  return History.restart();
};

History.restart = function () {
  return History.current = new History();
};

History.prototype.pushRasterLayerState = function (layer) {
  var imageData = layer.getImageData();

  this.pushWithLayer(layer.id, {
    execute: function execute(layer) {
      layer.setImage(imageData);
      $(window.MaskingModule).trigger(Events.LayerRastorUpdated, layer);
    }
  });
};

History.prototype.pushVectorLayerState = function (layer, execute) {
  function getState(layer) {
    var elements = {};

    for (var id in layer.polygons) {
      if (layer.elements[id]) {
        elements[id] = layer.elements[id].clone();
      }
    }

    return elements;
  }

  function restoreState(layer, state) {
    // remove the current polygons
    for (var polygonID in layer.polygons) {
      layer.removeElement(polygonID);
    }

    for (var elementID in state) {
      // copies so that modification of layer doesn't change history's stored state
      layer.addElement(state[elementID].clone());
    }

    MaskingModule.state.update.vector({
      layers: [layer.id]
    });
  }

  function finishedExecute() {
    var afterState = getState(layer);

    $(window.MaskingModule).trigger(Events.LayerVectorUpdated, layer);

    History.get().pushWithLayer(layer.id, {
      execute: function execute(layer) {
        restoreState(layer, afterState);
      },
      reverse: function reverse(layer) {
        restoreState(layer, beforeState);
      }
    });
  }

  var beforeState = getState(layer);

  if (execute) {
    if (execute.then) {
      execute.then(finishedExecute);
    } else {
      execute(layer);
      finishedExecute();
    }
  } else {
    finishedExecute();
  }
};

History.prototype.pushWithLayer = function (layerID, actionable) {
  if (layerID instanceof MaskingLayer) {
    layerID = layerID.id;
  }

  var step = {
    isValid: function isValid(layerID) {
      return !!MaskingModule.state.layers[layerID];
    },
    execute: function execute(layerID) {
      return actionable.execute(MaskingModule.getLayer(layerID));
    }
  };

  if (actionable.hasOwnProperty('reverse')) {
    step.reverse = function (layerID) {
      return actionable.reverse(MaskingModule.getLayer(layerID));
    };
  }

  return this.push(step, [layerID]);
};

History.prototype.push = function (actionable, args) {
  this.stackIndex++;

  if (this.stackIndex < this.stack.length) {
    // entries after this one are invalid
    // resize the stack accordingly
    this.stack.length = this.stackIndex;
  }

  $(window.MaskingModule).trigger(Events.RedoUnavailable);

  if (this.stackIndex > 0) {
    $(window.MaskingModule).trigger(Events.UndoAvailable);
  }

  var step = {
    isValid: function isValid() {
      if (actionable.hasOwnProperty('isValid')) {
        return actionable.isValid.apply(null, args);
      }
      return true;
    },
    execute: function execute() {
      return actionable.execute.apply(null, args);
    },
    reverse: function reverse() {
      return actionable.reverse.apply(null, args);
    },
    hasReverse: function hasReverse() {
      return actionable.hasOwnProperty('reverse');
    }
  };

  this.stack[this.stackIndex] = step;

  return step;
};

History.prototype.undo = function () {
  if (this.stackIndex <= 0) {
    throw new Error('undoing is unavailable');
  }

  var step = this.stack[this.stackIndex--];

  if (step.isValid()) {
    // forward the step's state that was pushed in
    if (step.hasReverse()) {
      step.reverse();
    } else {
      // step through history of non-reversable parts and execute in order
      for (var i = 0; i < this.stackIndex + 1; i++) {
        if (!this.stack[i].hasReverse()) {
          this.stack[i].execute();
        }
      }
    }

    $(window.MaskingModule).trigger(Events.RedoAvailable);

    if (this.stackIndex <= 0) {
      $(window.MaskingModule).trigger(Events.UndoUnavailable);
    }
  } else if (this.stackIndex <= 0) {
    // go one step further back
    return this.undo();
  }
};

History.prototype.redo = function () {
  if (this.stackIndex >= this.stack.length - 1) {
    throw new Error('redoing is unavailable');
  }

  var step = this.stack[++this.stackIndex];

  if (step.isValid()) {
    // forward the step's state that was pushed in
    step.execute();

    $(window.MaskingModule).trigger(Events.UndoAvailable);

    if (this.stackIndex === this.stack.length - 1) {
      $(window.MaskingModule).trigger(Events.RedoUnavailable);
    }
  } else {
    // go one step further
    return this.redo();
  }
};

History.prototype.clear = function () {
  this.stack = [];
  this.stackIndex = -1;

  $(window.MaskingModule).trigger(Events.RedoUnavailable);
  $(window.MaskingModule).trigger(Events.UndoUnavailable);
};

/**
 * @constructor MaskingView
 * @since 0.2.0
 */
function MaskingView() {
  this.bindings = bindings();
  // defaults to an empty dom element that's not in the tree
  this.display = $('<div></div>');
  this.blanket = null;
  this.background = null;
  this.canvas = null;
  this.raphael = null;

  // array of widget divs that need to be scaled & panned to project size
  this.scaledWidgets = [];

  this.displayOffset = {
    top: 0,
    left: 0
  };

  // state.layers
  this.layers = {};
  // state.layers.GLOBAL - always visible
  this.globalLayer = new ViewLayer('GLOBAL');
  this.globalLayer.canvas = null;
  this.globalLayer.ctx = null;

  // "cached" background for highlighting, is the backdrop of all layers for the highlighted one
  this.highlightBackground = document.createElement('canvas');
  // raster canvases that contain all layers in the group {groupName:canvas}
  this.groupsCache = {};

  // storage of what's being edited
  this.editing = {
    isEditing: false,
    layer: null,
    polygons: [],
    selected: null,
    modified: false,
    done: null,
    disabled: false
  };

  // raphael elements that have relative (to view scale) properties
  this.relativeAttrs = {};

  this.panningToggle = false;
  this.hovered = null;

  // on/off of view.bind({ hover: true/false })
  // this is used because vector hover binds are added when created
  this.hoveringBinded = false;

  this.peekLayersArr = [];
}

/**
 * Draw all of the state to view.
 *
 * This obeys {@link MaskingState#update state.update}, so if you want to be sure
 * everything is drawn you can call {@link MaskingStateUpdate#all state.update.all}
 * (at an obvious performance cost).
 *
 * @param {MaskingState} state - current state
 * @param {bool} doNotReset - set to true if you don't want `state.update.reset()` to be called
 * @returns {promise} a promise for when draw call completes
 * @memberOf MaskingView
 * @since 0.2.0
 */
MaskingView.prototype.draw = function (state, doNotReset) {
  var promises = [];
  if (state.update.displayImage) {
    promises.push(drawing.displayImage(this, state, state.update.displayImage));
  }

  if (state.update.project) {
    drawing.project(this, state, state.update.project);
  }

  if (state.update.masks) {
    var redraw = state.update.masks;

    if (redraw.size || redraw.offset) {
      drawing.masks.size(this, state, redraw.size);
    }

    if (redraw.raster) {
      drawing.masks.raster(this, state, redraw.raster);
    }

    if (redraw.vector) {
      drawing.masks.vector(this, state, redraw.vector);
    }

    if (redraw.hover) {
      drawing.masks.hover(this, state, redraw.hover);
    }

    if (redraw.peek) {
      drawing.masks.peek(this, state);
    }
  }

  if (!doNotReset) {
    state.update.reset();
  }

  return Promise.all(promises);
};

/**
 * Adds a DOM element plainly into the view. There isn't much magic here,
 * and you should be careful about adding things this way.
 *
 * See the Magnifier code for an example.
 *
 * @param {DOMElement} div - element to add inside of the masking view's display
 * @param {{eventName:function(event)}} events - jquery events (`$().on(event)`) to listen to on display
 * @param {bool} scaled
 * @memberOf MaskingView
 * @since 0.2.0
 */
MaskingView.prototype.addWidget = function (div, events, scaled) {
  this.blanket.append(div);

  if (scaled) {
    this.scaledWidgets.push(scaled);
  }

  var view = this;
  Object.keys(events || []).forEach(function (eventID) {
    view.display.on(eventID, function (e) {
      e.relative = relative(e, view.displayOffset, MaskingModule.state);
      events[eventID](e);
    });
  });
};

/**
 * @returns {bool} - if the view can/is panning right now
 * @memberOf MaskingView
 * @since 0.2.0
 */
MaskingView.prototype.isPanning = function () {
  return this.panningToggle;
};

/** *
 * @param {bool} enabled - if panning should be possible right now
 * @memberOf MaskingView
 * @since 0.2.0
 */
MaskingView.prototype.setPanning = function (enabled) {
  if (this.panningToggle != enabled) {
    // don't needlessly change cursor (like false->false)
    cursor.pan(this.blanket, enabled);
    $(window.MaskingModule).trigger(Events.Panning, enabled);
  }

  this.panningToggle = enabled;
};

/**
 * @returns {bool} - disabled
 * @memberOf MaskingView
 * @since 0.4.7
 */
MaskingView.prototype.disableEditing = function () {
  var disabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  return this.editing.disabled = disabled;
};

/**
 * @returns {bool} - if the view is in editing mode right now
 * @memberOf MaskingView
 * @since 0.2.0
 */
MaskingView.prototype.isEditing = function () {
  return this.editing.isEditing;
};

/**
 * Enables/disables polygon editing (dragging, movable handles, midline splits)
 * of selected layer polygons.
 *
 * This function will turn off hovering and panning when enabling.
 *
 * @param {bool} enabled - if editing of polygons should be possible right now
 * @throws when no layer is selected (and `enabled` is true)
 * @memberOf MaskingView
 * @since 0.2.0
 */
MaskingView.prototype.setEditing = function (enabled) {
  if (this.editing.disabled) {
    return;
  }

  var state = MaskingModule.state;
  var editing = this.editing;

  function modify() {
    editing.modified = true;
  }

  if (enabled) {
    if (!MaskingModule.hasSelectedLayer()) {
      throw new Error('Cannot edit polygons if there is no selected layer');
    }

    if (editing.isEditing) {
      // clear old editing
      this.setEditing(false);
    }

    MaskingModule.setHoverOption(LayerHoverOption.none).setPanning(false);

    editing.isEditing = true;
    editing.layer = MaskingModule.getSelectedLayer();
    editing.polygons = Object.keys(editing.layer.polygons).map(function (polygonID) {
      return editing.layer.elements[polygonID];
    }).filter(function (element) {
      return element instanceof PolygonElement;
    });

    editing.done = $.Deferred();
    History.get().pushVectorLayerState(editing.layer, editing.done.promise());

    editing.polygons.forEach(function (element) {
      element.setAttrs(Settings$1.layers.editableAttrs.polygon).addHandles(null, modify).addMidlines(null, modify).addHoleHandles(null, modify).makeDraggable(modify, function () {
        element.setAttr('fill-opacity', Settings$1.view.highlightedOpacity);

        if (editing.selected && editing.selected != element) {
          // revert fill-opacity of last selected
          editing.selected.setAttr('fill-opacity', Settings$1.layers.editableAttrs.polygon['fill-opacity']);
        }

        editing.selected = element;

        MaskingModule.draw();
      });
    });

    MaskingModule.draw();

    $(this).on('delete.edit', function () {
      if (editing.selected) {
        editing.selected.removeFromLayer();
        editing.selected = null;
        MaskingModule.draw();
      }
    });
  } else if (!enabled && editing.isEditing) {
    editing.polygons.forEach(function (element) {
      element.disableDrag().removeHandles().removeMidlines().removeHoleHandles().setAttrs(Settings$1.layers.polygonAttrs);

      if (element.id && editing.modified) {
        editing.layer.mergePolygon(element.id, true);
      }
    });

    // save state in history or not
    if (editing.modified) {
      editing.done.resolve();
    } else {
      editing.done.reject();
    }

    MaskingModule.draw();

    $(this).off('delete.edit');

    editing.isEditing = false;
    editing.layer = null;
    editing.polygons = [];
    editing.selected = null;
    editing.modified = false;
    editing.done = null;
  }
};

MaskingView.prototype.peekLayers = function () {
  var layerIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var on = arguments[1];

  var state = MaskingModule.state;
  var inputLayerIds = Array.isArray(layerIds) ? layerIds : [layerIds];

  // validate layerIds
  inputLayerIds.forEach(function (layerId) {
    var layer = state.layers[layerId];
    if (layerId && !layer) {
      throw new Error('Peek on an invalid layer');
    }
  });

  this.peekLayersArr = on ? inputLayerIds.map(function (layerId) {
    return layerId.toString();
  }) : [];
  state.update.updateMasks({
    peek: true
  });

  this.draw(state);
};

MaskingView.prototype.hoverOnLayer = function (layerID) {
  var state = MaskingModule.state;
  var layer = state.layers[layerID];

  if (layerID && !layer) {
    throw new Error('Hovering on an invalid layer');
  }

  if (this.hovered !== layerID) {
    this.hovered = layerID;

    $(window.MaskingModule).trigger(Events.LayerHovered, layerID);

    state.update.updateMasks({
      hover: true
    });
  }
};

MaskingView.prototype.hoverOnLayers = function (layers) {
  var state = MaskingModule.state;

  this.hovered = layers;

  $(window.MaskingModule).trigger(Events.LayerHovered, layers);

  state.update.updateMasks({
    hover: true
  });
};

MaskingView.prototype.hoverOnGroup = function (groupName) {
  var layers = MaskingModule.state.getGroupLayers(groupName);
  if (!this.hovered || this.hovered.groupName !== groupName) {
    this.hovered = layers;
    this.hovered.groupName = groupName;

    $(window.MaskingModule).trigger(Events.LayerHovered, layers);

    MaskingModule.update.updateMasks({
      hover: true
    });
  }
};

/**
 * Binds the view. Can call this function multiple times, but giving the same
 * option multiple times is undefined behaviour.
 *
 * Use the {@link MaskingView#unbind unbind} function for unbinding any of these
 * properties - setting to false will not unbind them.
 *
 * @param {object} elements
 * @param {DOMElement} elements.display - a dom element to render all masking tool (and listen to events from)
 * @param {bool} elements.drawing - binds tool drawing
 * @param {bool} elements.hover - hovering on display is captured and shown according to {@LayerHoverOption}
 * @param {bool} elements.middle_click_pan - middle clicking allows panning
 * @param {bool} elements.spacebar_pan - spacebar turns on panning
 * @param {bool} elements.arrowkey_navigation - up/left/right/down keys navigate around project
 * @param {bool} elements.mousewheel_zoom - scroll/mousewheel triggers zooming
 * @param {bool} elements.plusminus_zoom - +/- keys trigger zooming
 * @param {bool} elements.pinch_zoom - allows pinch-to-zoom project at almost any time
 * @param {bool} elements.doubleclick_reset_zoom - doubletap/click triggers zoom reset to viewport size
 * @param {bool} elements.bracket_thickness - [/] keys increase/decrease 'thickness' of current tool
 * @param {number[]} elements.edit_keys - keyCode numbers to trigger polygon editing
 * @param {number[]} elements.delete_keys - keyCode numbers to delete polygon while editing
 * @param {number[]} elements.cancel_keys - keyCode numbers to cancel tool (ctrl+key removes tool)
 * @param {object[]} elements.undo_keys - array of {key: 'z', ctrl: true}
 * @param {object[]} elements.redo_keys - array of {key: 'y', ctrl: true}
 * @memberOf MaskingView
 * @since 0.2.0
 */
MaskingView.prototype.bind = function (elements) {
  var view = this;

  if (elements.display) {
    this.display = $(elements.display);
    // necessary for android chrome browser to prevent navigation gestures
    this.display.css('touch-action', 'none');

    this.blanket = $(document.createElement('div')).css({
      position: 'relative',
      width: '100%',
      height: '100%'
    }).attr('data-label', 'blanket').appendTo(this.display);

    this.background = $(document.createElement('img')).css({
      'transform-origin': 'top left',
      'backface-visibility': 'hidden'
    }).attr('data-label', 'background').appendTo(this.blanket);

    this.canvas = $(document.createElement('canvas')).css({
      'transform-origin': 'top left',
      'backface-visibility': 'hidden',
      position: 'absolute',
      top: 0,
      left: 0
    }).attr('data-label', 'raster-masking').appendTo(this.blanket).get(0);

    this.globalLayer.canvas = $(document.createElement('canvas')).css({
      'transform-origin': 'top left',
      'backface-visibility': 'hidden',
      position: 'absolute',
      top: 0,
      left: 0
    }).attr('data-label', 'global-raster-layer').appendTo(this.blanket).get(0);

    this.globalLayer.ctx = this.globalLayer.canvas.getContext('2d');

    var tmpParent = $(document.createElement('div'));
    this.raphael = Raphael(tmpParent[0]);
    tmpParent.remove();

    $(this.raphael.canvas).css({
      'transform-origin': 'top left',
      'backface-visibility': 'hidden',
      position: 'absolute',
      top: 0,
      left: 0
    }).attr('data-label', 'vector-masking').appendTo(this.blanket);

    $(window).on('resize', function () {
      view.updateDisplay(true);
    });

    this.bindings.panning.drag.on(this, this.blanket);
  }

  if (elements.drawing) {
    this.bindings.drawing.on(this, this.blanket);
  }

  if (elements.hover) {
    this.bindings.hover.on(this, this.blanket);
  }

  if (elements.middle_click_pan) {
    this.bindings.panning.middleClick.on(this, this.blanket);
  }

  if (elements.spacebar_pan) {
    this.bindings.panning.spacebar.on(this);
  }

  if (elements.arrowkey_navigation) {
    this.bindings.panning.arrowkeys.on(this);
  }

  if (elements.mousewheel_zoom) {
    this.bindings.zoom.mousewheel.on(this, this.blanket);
  }

  if (elements.plusminus_zoom) {
    this.bindings.zoom.plusminus.on(this);
  }

  if (elements.pinch_zoom) {
    this.bindings.zoom.pinch.on(this, this.blanket);
  }

  if (elements.doubleclick_reset_zoom) {
    this.bindings.zoom.reset.on(this, this.blanket);
  }

  if (elements.bracket_thickness) {
    this.bindings.bracket_thickness.on(this);
  }

  if (elements.edit_keys) {
    var edit_keys = elements.edit_keys;
    if (!Array.isArray(edit_keys)) {
      edit_keys = [edit_keys];
    }

    this.bindings.edit.on(this, edit_keys);
  }

  if (elements.delete_keys) {
    var delete_keys = elements.delete_keys;
    if (!Array.isArray(delete_keys)) {
      delete_keys = [delete_keys];
    }

    this.bindings.delete.on(this, delete_keys);
  }

  if (elements.cancel_keys) {
    var cancel_keys = elements.cancel_keys;
    if (!Array.isArray(cancel_keys)) {
      cancel_keys = [cancel_keys];
    }

    this.bindings.cancel.on(this, cancel_keys);
  }

  if (elements.undo_keys) {
    var undo_keys = elements.undo_keys;
    if (!Array.isArray(undo_keys)) {
      undo_keys = [undo_keys];
    }

    this.bindings.undo.on(this, undo_keys);
  }

  if (elements.redo_keys) {
    var redo_keys = elements.redo_keys;
    if (!Array.isArray(redo_keys)) {
      redo_keys = [redo_keys];
    }

    this.bindings.redo.on(this, redo_keys);
  }

  return new Promise(function (resolve) {
    function finish() {
      view.updateDisplay(false);
      resolve();
    }

    // set in load event lower in this file
    // necessary just in case window was already loaded before we bind the
    // view, in which case updateDisplay would never fire without this
    if (window.loaded) {
      finish();
    } else {
      $(window).on('load', finish);
    }
  });
};

/**
 * Unbinds properties set by {@link MaskingView#bind bind}. Options disable
 * their counterparts in bind.
 *
 * @param {object} elements
 * @param {bool} elements.drawing - disables tool drawing
 * @param {bool} elements.hover - hovering on display is disabled
 * @param {bool} elements.middle_click_pan - middle clicking does not panning
 * @param {bool} elements.spacebar_pan - spacebar does  not turns on panning
 * @param {bool} elements.arrowkey_navigation - up/left/right/down keys don't navigate around project
 * @param {bool} elements.mousewheel_zoom - scroll/mousewheel doesn't zoom
 * @param {bool} elements.plusminus_zoom - +/- keys don't zoom
 * @param {bool} elements.pinch_zoom - disables pinch zooming
 * @param {bool} elements.doubleclick_reset_zoom - disables doubletap for zoom reset
 * @param {bool} elements.bracket_thickness - [/] keys don't increase/decrease 'thickness' of current tool
 * @param {number[]} elements.edit_keys - keyCode numbers that should not edit anymore
 * @param {number[]} elements.delete_keys - keyCode numbers that should not delete anymore
 * @param {number[]} elements.cancel_keys - keyCode numbers that should not cancel anymore
 * @param {object[]} elements.undo_keys - array of {key: 'z', ctrl: true} that should not undo anymore
 * @param {object[]} elements.redo_keys - array of {key: 'y', ctrl: true} that should not undo anymore
 * @memberOf MaskingView
 * @since 0.2.0
 */
MaskingView.prototype.unbind = function (elements) {
  if (elements.display) {
    throw new Error('unbinded display is unsupported at this time');
  }

  if (elements.drawing) {
    this.bindings.drawing.off(this, this.blanket);
  }

  if (elements.hover) {
    this.bindings.hover.off(this, this.blanket);
  }

  if (elements.middle_click_pan) {
    this.bindings.panning.middleClick.off(this, this.blanket);
  }

  if (elements.spacebar_pan) {
    this.bindings.panning.spacebar.off(this);
  }

  if (elements.arrowkey_navigation) {
    this.bindings.panning.arrowkeys.off(this);
  }

  if (elements.mousewheel_zoom) {
    this.bindings.zoom.mousewheel.off(this, this.blanket);
  }

  if (elements.plusminus_zoom) {
    this.bindings.zoom.plusminus.off(this);
  }

  if (elements.pinch_zoom) {
    this.bindings.zoom.pinch.off(this, this.blanket);
  }

  if (elements.doubleclick_reset_zoom) {
    this.bindings.zoom.reset.off(this, this.blanket);
  }

  if (elements.bracket_thickness) {
    this.bindings.bracket_thickness.off(this);
  }

  if (elements.edit_keys) {
    var edit_keys = elements.edit_keys;
    if (!Array.isArray(edit_keys)) {
      edit_keys = [edit_keys];
    }

    this.bindings.edit.off(this, edit_keys);
  }

  if (elements.delete_keys) {
    var delete_keys = elements.delete_keys;
    if (!Array.isArray(delete_keys)) {
      delete_keys = [delete_keys];
    }

    this.bindings.delete.off(this, delete_keys);
  }

  if (elements.cancel_keys) {
    var cancel_keys = elements.cancel_keys;
    if (!Array.isArray(cancel_keys)) {
      cancel_keys = [cancel_keys];
    }

    this.bindings.cancel.off(this, cancel_keys);
  }

  if (elements.undo_keys) {
    var undo_keys = elements.undo_keys;
    if (!Array.isArray(undo_keys)) {
      undo_keys = [undo_keys];
    }

    this.bindings.undo.off(this, undo_keys);
  }

  if (elements.redo_keys) {
    var redo_keys = elements.redo_keys;
    if (!Array.isArray(redo_keys)) {
      redo_keys = [redo_keys];
    }

    this.bindings.redo.off(this, redo_keys);
  }
};

/**
 * Recalculates view dimensions & offsets. This function should be called
 * whenever the display DOM element is moved, resized, etc. Because there
 * is no universal way to listen for that kind of change, you are responsible
 * updating. Note that binding will add a window resize listener, so that is
 * taken care of.
 *
 * @returns {Promise} - resolves after the draw completes (or immediately)
 * @param {bool} draw - should draw after updating
 * @memberOf MaskingView
 * @since 0.2.0
 */
MaskingView.prototype.updateDisplay = function (draw) {
  var displayWidth = this.display.width();
  var displayHeight = this.display.height();
  this.displayOffset = this.display.offset();

  MaskingModule.changeState({
    view: {
      width: displayWidth,
      height: displayHeight,
      container: {
        width: displayWidth,
        height: displayHeight
      }
    }
  });

  // pan ensures project is within bounds
  MaskingModule.pan(0, 0);

  if (draw) {
    return this.draw(MaskingModule.state);
  }
  return Promise.resolve();
};

// drawing functions (added below)
var drawing = {
  masks: {}
};

drawing.displayImage = function (view, state, redraw) {
  if (redraw.url) {
    if (state.view.displayImageURL) {
      // insert the old image in front while loading
      var $clone = $(view.background).clone().insertBefore(view.background);

      $(view.background).attr('src', state.view.displayImageURL).hide();

      return new Promise(function (resolve) {
        $(view.background).one('load error', function () {
          resolve();

          // retrigger size update after the image was loaded
          state.update.updateDisplayImage({ url: false });
          MaskingModule.draw().then(function () {
            $(view.background).show();
            $clone.remove();
          });
        });
      });
    }
    $(view.background).attr('src', '');
  }

  return Promise.resolve();
};

drawing.project = function (view, state, redraw) {
  if (redraw.size) {
    // changing project size will always require a full redraw of masks
    state.update.drawing();

    // raster canvases
    view.canvas.width = state.projectWidthWithGutter;
    view.canvas.height = state.projectHeightWithGutter;
    view.globalLayer.canvas.width = state.projectWidthWithGutter;
    view.globalLayer.canvas.height = state.projectHeightWithGutter;
    view.highlightBackground.width = state.projectWidthWithGutter;
    view.highlightBackground.height = state.projectHeightWithGutter;
    view.groupsCache = {};

    // svg vector canvas
    $(view.raphael.canvas).attr('width', state.projectWidthWithGutter).attr('height', state.projectHeightWithGutter);
    view.raphael.setViewBox(0, 0, state.projectWidthWithGutter, state.projectHeightWithGutter);
    view.raphael.canvas.setAttribute('preserveAspectRatio', 'none');
  }
};

drawing.masks.size = function (view, state, redraw) {
  var scaleX = state.widthScale;
  var scaleY = state.heightScale;
  var transX = state.view.offset.x - state.gutterX * scaleX;
  var transY = state.view.offset.y - state.gutterY * scaleY;
  var transform = 'matrix(' + scaleX + ',0,0,' + scaleY + ',' + transX + ',' + transY + ') translateZ(0)';

  $(view.globalLayer.canvas).css('transform', transform);
  $(view.canvas).css('transform', transform);
  $(view.raphael.canvas).css('transform', transform);

  // translate is different for background image (no gutter)
  // imageWidth & imageHeight are real w/h of the background image, because renders are not
  // always the same resolution as the project
  var imageWidth = view.background[0].naturalWidth || state.project.width;
  var imageHeight = view.background[0].naturalHeight || state.project.height;
  var backgroundScaleX = scaleX * (state.project.width / imageWidth);
  var backgroundScaleY = scaleY * (state.project.height / imageHeight);
  var backgroundTransX = state.view.offset.x;
  var backgroundTransY = state.view.offset.y;
  var backgroundTransform = 'matrix(' + backgroundScaleY + ',0,0,' + backgroundScaleY + ',' + backgroundTransX + ',' + backgroundTransY + ') translateZ(0)';

  $(view.background).css('transform', backgroundTransform);

  for (var i = 0; i < view.scaledWidgets.length; i++) {
    $(view.scaledWidgets[i]).css({
      left: state.view.offset.x + 'px',
      top: state.view.offset.y + 'px',
      width: Math.round(state.project.width * state.widthScale) + 'px',
      height: Math.round(state.project.height * state.heightScale) + 'px'
    });
  }

  if (redraw) {
    var scale = state.view.scale * state.view.heightRatio;
    for (var elementID in view.relativeAttrs) {
      var e = view.relativeAttrs[elementID];
      for (var attr in e.attrs) {
        setSVGAttr(e.element, attr, e.attrs[attr] / scale);
      }
    }
  }
};

drawing.masks.raster = function (view, state, redraw) {
  var layerIDs = state.layerIDs;
  var updateLayers = redraw.layers === 'all' ? new Set(layerIDs) : redraw.layers;
  var region = redraw.region;

  if (region === 'full') {
    region = {
      x: 0,
      y: 0,
      width: state.projectWidthWithGutter,
      height: state.projectHeightWithGutter
    };
  }

  var ctx = view.canvas.getContext('2d');

  if (updateLayers.size === 0) {
    // this is an optimization - if update.raster is called with no layers,
    // it's assumed that only GLOBAL needs to be redrawn
    view.globalLayer.ctx.clearRect(region.x, region.y, region.width, region.height);
    drawRasterLayer(view.globalLayer.ctx, state.layers.GLOBAL, region, Settings$1.view.selectedOpacity);
  } else if (state.view.layerHoverOption === LayerHoverOption.none) {
    ctx.clearRect(region.x, region.y, region.width, region.height);

    switch (state.view.layerViewOption) {
      case LayerViewOption.none:
        break;
      case LayerViewOption.current:
        if (state.selectedLayer) {
          drawRasterLayer(ctx, state.layers[state.selectedLayer], region, Settings$1.view.selectedOpacity);
        }
        break;
      case LayerViewOption.highlight:
        for (var i = 0; i < layerIDs.length; i++) {
          if (layerIDs[i] === state.selectedLayer) {
            drawRasterLayer(ctx, state.layers[layerIDs[i]], region, Settings$1.view.highlightedOpacity);
          } else {
            drawRasterLayer(ctx, state.layers[layerIDs[i]], region, Settings$1.view.nonHighlightedOpacity);
          }
        }
        break;
      case LayerViewOption.all:
        for (var x = 0; x < layerIDs.length; x++) {
          drawRasterLayer(ctx, state.layers[layerIDs[x]], region, Settings$1.view.nonHighlightedOpacity);
        }
        break;
    }

    view.globalLayer.ctx.clearRect(region.x, region.y, region.width, region.height);
    drawRasterLayer(view.globalLayer.ctx, state.layers.GLOBAL, region, Settings$1.view.selectedOpacity);
  } else /* is hovering */{
      var highlightCtx = view.highlightBackground.getContext('2d');

      highlightCtx.clearRect(region.x, region.y, region.width, region.height);
      for (var a = 0; a < layerIDs.length; a++) {
        drawRasterLayer(highlightCtx, state.layers[layerIDs[a]], region);
      }

      if (layerIDs.length === 0) {
        highlightCtx.clearRect(0, 0, view.highlightBackground.width, view.highlightBackground.height);
      }

      var groups = state.getLayerGroups();
      groups.forEach(function (groupName) {
        var layers = state.getGroupLayers(groupName);
        var l = layers.filter(function (layerID) {
          return updateLayers.has(layerID);
        });

        // some layers within this group are in redraw.layers
        if (l.length > 0) {
          if (!view.groupsCache[groupName]) {
            view.groupsCache[groupName] = document.createElement('canvas');
            view.groupsCache[groupName].width = state.projectWidthWithGutter;
            view.groupsCache[groupName].height = state.projectHeightWithGutter;
          }

          var _ctx = view.groupsCache[groupName].getContext('2d');
          _ctx.clearRect(region.x, region.y, region.width, region.height);
          for (var _i = 0; _i < layers.length; _i++) {
            drawRasterLayer(_ctx, state.layers[layers[_i]], region);
          }
        }
      });

      for (var group in view.groupsCache) {
        // remove groups that don't exist anymore
        if (groups.indexOf(group) === -1) {
          delete view.groupsCache[group];
        }
      }
    }
};

drawing.masks.vector = function (view, state, redraw) {
  var updateLayers = redraw.layers === 'all' ? new Set(state.layerIDs) : redraw.layers;
  var updateElements = {};
  if (redraw.elements === 'all') {
    updateLayers.forEach(function (layerID) {
      updateElements[layerID] = Object.keys(state.layers[layerID].elements);
    });

    updateElements.GLOBAL = Object.keys(state.layers.GLOBAL.elements);
  } else {
    updateElements.GLOBAL = [];
    updateLayers.forEach(function (layerID) {
      updateElements[layerID] = [];
    });

    redraw.elements.forEach(function (elementID) {
      if (state.layers.GLOBAL.elements[elementID]) {
        updateElements.GLOBAL.push(elementID);
      }

      updateLayers.forEach(function (layerID) {
        if (state.layers[layerID].elements[elementID]) {
          updateElements[layerID].push(elementID);
        }
      });
    });
  }

  var frontElements = view.raphael.set();

  function updateLayer(layer) {
    var viewLayer = void 0;
    if (layer.id === 'GLOBAL') {
      viewLayer = view.globalLayer;
    } else {
      viewLayer = view.layers[layer.id];
    }

    updateElements[layer.id].forEach(function (elementID) {
      var element = layer.elements[elementID];
      var viewElement = viewLayer.elements[elementID];

      if (!viewElement) {
        // element has not been added to the view yet, add to view.layers.elements
        viewElement = viewLayer.elements[elementID] = view.raphael[element.type]();
        $(viewElement.node).attr('data-id', elementID);

        setSVGAttrs(viewElement, element.attrs);

        if (layer.polygons[elementID]) {
          viewElement.mousemove(function (e) {
            var state = MaskingModule.state;

            if (shouldHover(state, view)) {
              var group = state.layerGroups[layer.id];
              if (group && Settings$1.view.layerHoverType === 'group') {
                view.hoverOnGroup(group);
                view.draw(state);
              } else {
                view.hoverOnLayer(layer.id);
                view.draw(state);
              }
            }
          });

          viewElement.mouseout(function (e) {
            var state = MaskingModule.state;

            if (shouldHover(state, view)) {
              view.hoverOnLayer(null);
              view.draw(state);
            }
          });

          viewElement.click(function (e) {
            var state = MaskingModule.state;

            if (shouldHover(state, view) || state.view.layerHoverOption !== LayerHoverOption.none && !view.isPanning()) {
              if (Settings$1.view.layerHoverType === 'group' && layer.group) {
                $(window.MaskingModule).trigger(Events.LayerClicked, [layer.id, layer.group, state.getGroupLayers(layer.group)]);
              } else {
                $(window.MaskingModule).trigger(Events.LayerClicked, layer.id);
              }
            }
          });
        }
      }

      element.getEvents().forEach(function (event) {
        if (event.name === 'drag') {
          // drag is a special case event, using raphael's drag event
          viewElement.drag(function (dx, dy, x, y, e) {
            if (e.which === 2) {
              // still want to propogate middle click
              return;
            }

            if (!view.isPanning()) {
              e.relative = relative(e, view.displayOffset);
              event.callback(e, 'drag');
            }
          }, function (x, y, e) {
            if (e.which === 2) {
              // still want to propogate middle click
              return;
            }

            if (!view.isPanning()) {
              e.relative = relative(e, view.displayOffset);
              event.callback(e, 'dragstart');
            }
          }, function (e) {
            if (e.which === 2) {
              // still want to propogate middle click
              return;
            }

            if (!view.isPanning()) {
              e.relative = relative(e, view.displayOffset);
              event.callback(e, 'dragend');
            }
          });
        } else {
          $(viewLayer.elements[elementID].node).on(event.name, function (e) {
            e.relative = relative(e, view.displayOffset);
            event.callback(e);
          });
        }
      });

      element.getRemovedEvents().forEach(function (event) {
        if (event === 'drag') {
          viewElement.undrag();
        } else {
          $(viewLayer.elements[elementID].node).off(event);
        }
      });

      element.getAnimations().forEach(function (animation) {
        viewElement.animate(animation.attrs, animation.ms, animation.easing, animation.callback);
      });

      if (element.inFront) {
        frontElements.push(viewElement);
        element.inFront = false;
      }

      if (element.attrs.relative) {
        view.relativeAttrs[elementID] = {
          element: viewElement,
          attrs: element.attrs.relative
        };

        for (var attr in element.attrs.relative) {
          // initial relative setting
          setSVGAttr(viewElement, attr, element.attrs.relative[attr] / (state.view.scale * state.view.heightRatio));
        }

        delete element.attrs.relative;
      }

      setSVGAttrs(viewElement, element.getAttrs());
    });

    for (var elementID in viewLayer.elements) {
      // remove view elements that aren't in state anymore
      if (!layer.elements[elementID]) {
        viewLayer.elements[elementID].remove();
        delete viewLayer.elements[elementID];
        delete view.relativeAttrs[elementID];
      }
    }
  }

  updateLayers.forEach(function (layerID) {
    if (state.layers[layerID]) {
      if (!view.layers[layerID]) {
        view.layers[layerID] = new ViewLayer(layerID);
      }

      updateLayer(state.layers[layerID]);
    }
  });

  updateLayer(state.layers.GLOBAL);
  drawVectorLayer(view.globalLayer, 1.0);

  frontElements.toFront();

  // remove non-existant layers
  var layerIDs = state.layerIDs;
  for (var layerID in view.layers) {
    if (layerIDs.indexOf(layerID) === -1) {
      var viewLayer = view.layers[layerID];
      for (var elementID in viewLayer.elements) {
        viewLayer.elements[elementID].remove();
        delete viewLayer.elements[elementID];
        delete view.relativeAttrs[elementID];
      }

      delete view.layers[layerID];
    }
  }

  /* jshint shadow:true */
  if (state.view.layerHoverOption === LayerHoverOption.none) {
    switch (state.view.layerViewOption) {
      case LayerViewOption.none:
        for (var _layerID in view.layers) {
          hideVectorLayer(view.layers[_layerID]);
        }
        break;
      case LayerViewOption.current:
        for (var _layerID2 in view.layers) {
          if (state.selectedLayer === _layerID2) {
            drawVectorLayer(view.layers[_layerID2], Settings$1.view.selectedOpacity);
          } else {
            hideVectorLayer(view.layers[_layerID2]);
          }
        }
        break;
      case LayerViewOption.highlight:
        for (var _layerID3 in view.layers) {
          if (state.selectedLayer === _layerID3) {
            drawVectorLayer(view.layers[_layerID3], Settings$1.view.highlightedOpacity);
          } else {
            drawVectorLayer(view.layers[_layerID3], Settings$1.view.nonHighlightedOpacity);
          }
        }
        break;
      case LayerViewOption.all:
        for (var _layerID4 in view.layers) {
          drawVectorLayer(view.layers[_layerID4], Settings$1.view.selectedOpacity);
        }
        break;
    }
  }
};

drawing.masks.peek = function (view, state) {
  var allowedModes = [LayerViewOption.current, LayerViewOption.highlight];
  if (!allowedModes.includes(state.view.layerViewOption)) {
    return;
  }

  var ctx = view.canvas.getContext('2d');

  var hasSelectedLayer = state.selectedLayer !== null;
  var isSelectedLayer = function isSelectedLayer(layerID) {
    return hasSelectedLayer && state.selectedLayer === layerID;
  };

  var layerIds = Object.keys(view.layers);

  if (view.peekLayersArr.length === 0) {
    ctx.clearRect(0, 0, view.canvas.width, view.canvas.height);
    layerIds.forEach(function (layerID) {
      if (!isSelectedLayer(layerID)) {
        hideVectorLayer(view.layers[layerID]);
      } else {
        // re-draw selected layer because we're clearing everything
        drawRasterLayer(ctx, state.layers[layerID]);
      }
    });
  } else {
    ctx.save();
    ctx.globalAlpha = Settings$1.view.highlightedOpacity;
    ctx.globalCompositeOperation = 'source-over';

    if (view.peekLayersArr.groupName && view.groupsCache[view.peekLayersArr.groupName]) {
      ctx.drawImage(view.groupsCache[view.peekLayersArr.groupName], 0, 0);
    } else {
      view.peekLayersArr.forEach(function (layerID) {
        if (!isSelectedLayer(layerID)) {
          drawRasterLayer(ctx, state.layers[layerID]);
        }
      });
    }

    ctx.restore();

    layerIds.forEach(function (layerID) {
      if (!isSelectedLayer(layerID)) {
        if (view.peekLayersArr.indexOf(layerID) !== -1) {
          drawVectorLayer(view.layers[layerID], Settings$1.view.highlightedOpacity);
        } else {
          hideVectorLayer(view.layers[layerID]);
        }
      }
    });
  }
};

drawing.masks.hover = function (view, state, redraw) {
  var ctx = view.canvas.getContext('2d');

  /* jshint shadow:true */
  switch (state.view.layerHoverOption) {
    case LayerHoverOption.single:
      if (!view.hovered) {
        ctx.clearRect(0, 0, view.canvas.width, view.canvas.height);

        for (var layerID in view.layers) {
          // opacity: 0 instead of hiding, because mouse events still need to trigger highlight
          // TODO: could do this for polygons only (because opacity:0 is less performant vs display:none)
          drawVectorLayer(view.layers[layerID], 0);
        }
      } else if (Array.isArray(view.hovered)) {
        ctx.save();
        ctx.globalAlpha = Settings$1.view.highlightedOpacity;
        ctx.globalCompositeOperation = 'copy';

        if (view.hovered.groupName && view.groupsCache[view.hovered.groupName]) {
          ctx.drawImage(view.groupsCache[view.hovered.groupName], 0, 0);
        } else {
          // array of layers, not a group
          for (var i = 0; i < view.hovered.length; i++) {
            drawRasterLayer(ctx, state.layers[view.hovered[i]]);
          }
        }

        ctx.restore();

        for (var _layerID5 in view.layers) {
          if (view.hovered.indexOf(_layerID5) != -1) {
            drawVectorLayer(view.layers[_layerID5], Settings$1.view.highlightedOpacity);
          } else {
            drawVectorLayer(view.layers[_layerID5], 0);
          }
        }
      } else {
        ctx.save();
        ctx.globalCompositeOperation = 'copy';
        ctx.globalAlpha = Settings$1.view.highlightedOpacity;
        ctx.drawImage(state.layers[view.hovered].drawingCanvas, 0, 0);
        ctx.restore();

        for (var _layerID6 in view.layers) {
          if (_layerID6 === view.hovered) {
            drawVectorLayer(view.layers[_layerID6], Settings$1.view.highlightedOpacity);
          } else {
            drawVectorLayer(view.layers[_layerID6], 0);
          }
        }
      }

      break;
    case LayerHoverOption.highlight:
      ctx.save();
      ctx.globalCompositeOperation = 'copy';
      ctx.globalAlpha = Settings$1.view.nonHighlightedOpacity;
      ctx.drawImage(view.highlightBackground, 0, 0);
      ctx.globalCompositeOperation = 'source-over';

      if (Array.isArray(view.hovered)) {
        if (view.hovered) {
          ctx.globalAlpha = Settings$1.view.highlightedOpacity;
          if (view.hovered.groupName && view.groupsCache[view.hovered.groupName]) {
            ctx.drawImage(view.groupsCache[view.hovered.groupName], 0, 0);
          } else {
            // array of layers, not a group
            for (var x = 0; x < view.hovered.length; x++) {
              drawRasterLayer(ctx, state.layers[view.hovered[x]]);
            }
          }
        }

        for (var _layerID7 in view.layers) {
          if (view.hovered.indexOf(_layerID7) != -1) {
            drawVectorLayer(view.layers[_layerID7], Settings$1.view.highlightedOpacity);
          } else {
            drawVectorLayer(view.layers[_layerID7], Settings$1.view.nonHighlightedOpacity);
          }
        }
      } else {
        if (view.hovered) {
          ctx.globalAlpha = Settings$1.view.highlightedOpacity;
          ctx.drawImage(state.layers[view.hovered].drawingCanvas, 0, 0);
        }

        for (var _layerID8 in view.layers) {
          if (_layerID8 === view.hovered) {
            drawVectorLayer(view.layers[_layerID8], Settings$1.view.highlightedOpacity);
          } else {
            drawVectorLayer(view.layers[_layerID8], Settings$1.view.nonHighlightedOpacity);
          }
        }
      }

      ctx.restore();

      break;
    case LayerHoverOption.none:
      view.hovered = null;
  }
};

function drawRasterLayer(ctx, layer, region, opacity) {
  // this is an optimization for completely empty raster layers
  if (layer.hasNoRasterComponent) {
    return;
  }

  if (layer.type === 'RWForeground' && !MaskingModule.state.view.showForeground) {
    // do not show the foreground
    return;
  }

  if (!region) {
    region = {
      x: 0,
      y: 0,
      width: layer.drawingCanvas.width,
      height: layer.drawingCanvas.height
    };
  }

  if (opacity != null) {
    ctx.save();
    ctx.globalAlpha = opacity;
  }

  ctx.drawImage(layer.drawingCanvas, region.x, region.y, region.width, region.height, region.x, region.y, region.width, region.height);

  if (opacity != null) {
    ctx.restore();
  }
}

function hideVectorLayer(viewLayer) {
  for (var id in viewLayer.elements) {
    viewLayer.elements[id].hide();
  }
}

function drawVectorLayer(viewLayer, opacity) {
  if (isNaN(opacity)) {
    opacity = Settings$1.view.nonHighlightedOpacity;
  }

  var state = MaskingModule.state;
  var layerID = viewLayer.layerID;


  if (state.layers[layerID] && state.layers[layerID].type === 'RWForeground') {
    if (!state.view.showForeground) {
      // do not show the foreground
      return hideVectorLayer(viewLayer);
    }
  }

  for (var id in viewLayer.elements) {
    var element = viewLayer.elements[id];

    // optimized by storing a opacity state in element, to not change style when not needed
    if (element.opacity != opacity) {
      element.opacity = opacity;
      setSVGAttr(element, 'opacity', opacity);
    }

    if (element.node.style.display === 'none') {
      element.show();
    }
  }
}

function setSVGAttr(element, attr, value) {
  // special cases for performance (order by commoninality for MAX performance :p)
  switch (attr) {
    case 'r':
      if (!Number.isNaN(value)) {
        element.node.setAttribute('r', value);
      }
      break;
    case 'stroke-width':
      element.node.style['stroke-width'] = value;
      break;
    case 'path':
    case 'd':
      element.node.setAttribute('d', value);
      break;
    case 'cx':
      element.node.setAttribute('cx', value);
      break;
    case 'cy':
      element.node.setAttribute('cy', value);
      break;
    case 'opacity':
      element.node.style.opacity = value;
      break;
    case 'stroke':
      element.node.style.stroke = value;
      break;
    case 'stroke-opacity':
      element.node.style['stroke-opacity'] = value;
      break;
    case 'fill':
      element.node.style.fill = value;
      break;
    case 'fill-opacity':
      element.node.style['fill-opacity'] = value;
      break;
    case 'cursor':
      element.node.style.cursor = value;
      break;
    case 'relative':
      // ignore - done elsewhere
      break;
    default:
      element.attr(attr, value);
  }
}

function setSVGAttrs(element, attrs) {
  for (var attr in attrs) {
    setSVGAttr(element, attr, attrs[attr]);
  }
}

function ViewLayer(layerID) {
  this.layerID = layerID;
  this.elements = {};
}

var cursor = {
  last: 'initial',

  pan: function pan(surface, show) {
    if (show) {
      var current = surface.css('cursor');
      if (current != 'move') {
        cursor.last = current;
      }

      surface.css('cursor', 'move');
    } else {
      surface.css('cursor', cursor.last);
      cursor.last = 'initial';
    }
  },
  tool: function tool(surface, show, type) {
    if (show) {
      cursor.last = surface.css('cursor');
      surface.css('cursor', type || 'crosshair');
    } else {
      surface.css('cursor', 'initial');
      cursor.last = 'initial';
    }
  }
};

function bindings() {
  var bindings = {
    panning: {},
    zoom: {}
  };

  // pan & pinch share this
  var lastPan = {
    x: 0,
    y: 0
  };

  // map of {keydown:function(e), keyup:function(e)}
  // used so that each key listener isn't it's own event
  var keyListeners = {};

  $(window).keydown(function (e) {
    for (var k in keyListeners) {
      if (keyListeners[k].keydown) {
        keyListeners[k].keydown(e);
      }
    }
  });

  $(window).keyup(function (e) {
    for (var k in keyListeners) {
      if (keyListeners[k].keyup) {
        keyListeners[k].keyup(e);
      }
    }
  });

  bindings.drawing = {
    on: function on(view, element) {
      element.on('mousedown.drawing touchstart.drawing', function (e) {
        if (view.isPanning() || view.isEditing() || e.type === 'mousedown' && e.which != 1) {
          return;
        } else if (e.type === 'touchstart') {
          e.preventDefault();
        }

        e.relative = relative(e, view.displayOffset);

        if (MaskingModule.hasTool()) {
          MaskingModule.getCurrentTool().start(e);
        }
      });

      element.on('mousemove.drawing touchmove.drawing', function (e) {
        if (view.isPanning() || view.isEditing() || e.which === 2) {
          return;
        }

        e.relative = relative(e, view.displayOffset);

        if (MaskingModule.hasTool()) {
          MaskingModule.getCurrentTool().move(e);
        }
      });

      element.on('mouseup.drawing touchend.drawing', function (e) {
        if (view.isPanning() || view.isEditing() || e.type === 'mouseup' && e.which != 1) {
          return;
        }

        e.relative = relative(e, view.displayOffset);

        if (MaskingModule.hasTool()) {
          MaskingModule.getCurrentTool().end(e);
        }
      });

      $(window.MaskingModule).on(Events.ToolChanged + '.cursor', function (e, tool) {
        cursor.tool(element, !!tool, tool ? tool.cursor : null);
      });
    },
    off: function off(view, element) {
      element.off('mousedown.drawing touchstart.drawing');
      element.off('mousemove.drawing touchmove.drawing');
      element.off('mouseup.drawing touchend.drawing');
      $(window.MaskingModule).off(Events.ToolChanged + '.cursor');
      cursor.tool(element, false);
    }
  };

  bindings.hover = {
    on: function on(view, element) {
      view.hoveringBinded = true;

      element.on('mousedown.hover touchstart.hover', function (e) {
        if (e.type === 'mousedown' && e.which != 1) {
          return;
        }

        var state = MaskingModule.state;
        e.relative = relative(e, view.displayOffset);

        if (shouldHover(state, view)) {
          // raster layer click (vector click is detected by svg element click handler)
          var clickedLayer = getLayerIDAtPosition(e.relative, state);
          if (clickedLayer) {
            // TODO
            $(window.MaskingModule).trigger(Events.LayerClicked, clickedLayer);
          }
        }
      });

      var previousHoveredLayer = void 0;
      element.on('mousemove.hover touchmove.hover', function (e) {
        // middle click
        if (e.which === 2) {
          return;
        }

        var state = MaskingModule.state;
        e.relative = relative(e, view.displayOffset);

        if (shouldHover(state, view)) {
          // raster layer hovering
          var id = getLayerIDAtPosition(e.relative, state);

          if (id !== previousHoveredLayer) {
            previousHoveredLayer = id;

            var type = Settings$1.view.layerHoverType;
            var group = state.layerGroups[id];
            if (group && type === 'group') {
              view.hoverOnGroup(group);
              view.draw(state);
            } else {
              view.hoverOnLayer(id);
              view.draw(state);
            }
          }
        }
      });
    },
    off: function off(view, element) {
      view.hoveringBinded = false;
      element.off('mousedown.hover touchstart.hover');
      element.off('mousemove.hover touchmove.hover');
    }
  };

  bindings.panning.drag = {
    on: function on(view, element) {
      var hammer$$1 = $(element).data('hammer');
      if (!hammer$$1) {
        hammer$$1 = new hammer.Manager($(element)[0]);
        $(element).data('hammer', hammer$$1);
      }

      hammer$$1.add(new hammer.Pan({
        threshold: 10
      }));

      hammer$$1.on('panstart', function (e) {
        lastPan = {
          x: e.deltaX,
          y: e.deltaY
        };
      });

      hammer$$1.on('panmove', function (e) {
        if (view.isPanning()) {
          var delta = {
            x: e.deltaX,
            y: e.deltaY
          };

          MaskingModule.pan(delta.x - lastPan.x, delta.y - lastPan.y).draw();
          lastPan = delta;
        }
      });
    },
    off: function off(view, element) {
      $(element).data('hammer').off('panstart panmove');
    }
  };

  bindings.panning.middleClick = {
    on: function on(view, element) {
      var lastX = void 0,
          lastY = void 0,
          started = void 0,
          wasAlreadyPanning = void 0;

      // binds mousemove/mouseup on window so that dragging
      // outside of defined display box keeps going

      $(element).on('mousedown.middleClick', function (e) {
        if (e.which === 2) {
          e.stopPropagation();
          lastX = e.clientX;
          lastY = e.clientY;

          started = true;
          wasAlreadyPanning = view.isPanning();
          view.setPanning(true);
        }
      });
      $(window).on('mousemove.middleClick', function (e) {
        if (started) {
          e.stopPropagation();
          e.preventDefault();

          var moveX = e.clientX - lastX;
          var moveY = e.clientY - lastY;
          lastX = e.clientX;
          lastY = e.clientY;

          MaskingModule.pan(moveX, moveY).draw();
        }
      });
      $(window).on('mouseup.middleClick', function (e) {
        if (started && e.which === 2) {
          started = false;
          if (!wasAlreadyPanning) {
            view.setPanning(false);
          }
        }
      });
    },
    off: function off(view, element) {
      $(element).off('mousedown.middleClick');
      $(window).off('mousemove.middleClick');
      $(window).off('mouseup.middleClick');
    }
  };

  bindings.panning.spacebar = {
    on: function on(view) {
      var down = false,
          first_press = 0;
      keyListeners.spacebar = {
        keydown: function keydown(e) {
          if (e.keyCode === 32 && !down) {
            view.setPanning(down = true);

            if (new Date().getTime() - first_press < 200) {
              // double clicking spacebar resets zoom
              MaskingModule.resetZoom().panCenter().draw();
              first_press = 0;
            } else {
              first_press = new Date().getTime();
            }
          }
        },
        keyup: function keyup(e) {
          if (e.keyCode === 32) {
            view.setPanning(down = false);
          }
        }
      };
    },
    off: function off(view) {
      delete keyListeners.spacebar;
    }
  };

  bindings.panning.arrowkeys = {
    on: function on(view) {
      keyListeners.arrowkeys = {
        keydown: function keydown(e) {
          var state = MaskingModule.state;
          var dx = state.project.width * Settings$1.view.arrowKeyPan;
          var dy = state.project.height * Settings$1.view.arrowKeyPan;

          if (e.which === 37) {
            MaskingModule.pan(-dx, 0).draw();
          } else if (e.which === 38) {
            MaskingModule.pan(0, -dy).draw();
          } else if (e.which === 39) {
            MaskingModule.pan(dx, 0).draw();
          } else if (e.which === 40) {
            MaskingModule.pan(0, dy).draw();
          }
        }
      };
    },
    off: function off(view) {
      delete keyListeners.arrowkeys;
    }
  };

  bindings.zoom.mousewheel = {
    on: function on(view, element) {
      var zoomIncrement = Settings$1.view.zoomIncrement;
      var zoomIn = 1.0 + zoomIncrement;
      var zoomOut = 1.0 - zoomIncrement;

      function zoom(e) {
        var pos = relative(e, view.displayOffset);

        if (e.ctrlKey) {
          // ctrl + mousewheel
          e.preventDefault();
        }

        if (e.originalEvent.wheelDelta / 120 > 0 || e.detail < 0) {
          MaskingModule.zoom(zoomIn, pos.x, pos.y).draw();
        } else {
          MaskingModule.zoom(zoomOut, pos.x, pos.y).draw();
        }
      }

      $(element).on('mousewheel.zoom DOMMouseScroll.zoom', zoom);
    },
    off: function off(view, element) {
      $(element).off('mousewheel.zoom DOMMouseScroll.zoom');
    }
  };

  bindings.zoom.plusminus = {
    on: function on(view) {
      var zoomIncrement = Settings$1.view.zoomIncrement;
      var zoomIn = 1.0 + zoomIncrement;
      var zoomOut = 1.0 - zoomIncrement;

      keyListeners.plusminus = {
        keydown: function keydown(e) {
          if (e.ctrlKey && (e.keyCode === 187 || e.keyCode === 189)) {
            // ctrl + / ctrl -
            e.preventDefault();
          }

          if (e.keyCode === 187) {
            MaskingModule.zoom(zoomIn).draw();
          } else if (e.keyCode === 189) {
            MaskingModule.zoom(zoomOut).draw();
          }
        }
      };
    },
    off: function off(view) {
      delete keyListeners.plusminus;
    }
  };

  bindings.zoom.pinch = {
    on: function on(view, element) {
      var startScale = void 0;
      var hammer$$1 = $(element).data('hammer');

      if (!hammer$$1) {
        hammer$$1 = new hammer.Manager($(element)[0]);
        $(element).data('hammer', hammer$$1);
      }

      hammer$$1.add(new hammer.Pinch());
      hammer$$1.get('pinch').recognizeWith('pan');

      hammer$$1.on('pinchstart', function (e) {
        lastPan = {
          x: e.deltaX,
          y: e.deltaY
        };

        startScale = MaskingModule.state.view.scale;
      });

      hammer$$1.on('pinch', function (e) {
        var focal = relative(e.center, view.displayOffset);
        var delta = {
          x: e.deltaX,
          y: e.deltaY
        };

        MaskingModule.pan(delta.x - lastPan.x, delta.y - lastPan.y).setZoom(e.scale * startScale, focal.x, focal.y).draw();

        lastPan = delta;
      });
    },
    off: function off(view, element) {
      $(element).data('hammer').off('pinchstart pinch');
    }
  };

  bindings.zoom.reset = {
    on: function on(view, element) {
      var hammer$$1 = $(element).data('hammer');

      if (!hammer$$1) {
        hammer$$1 = new hammer.Manager($(element)[0]);
        $(element).data('hammer', hammer$$1);
      }

      hammer$$1.add(new hammer.Tap({
        event: 'doubletap',
        taps: 2
      }));

      hammer$$1.on('doubletap', function (e) {
        if (!MaskingModule.hasTool()) {
          MaskingModule.resetZoom().panCenter().draw();
        }
      });
    },
    off: function off(view, element) {
      $(element).data('hammer').off('doubletap');
    }
  };

  bindings.bracket_thickness = {
    on: function on(view) {
      keyListeners.bracket_thickness = {
        keydown: function keydown(e) {
          var tool = void 0;
          if (e.keyCode === 221) {
            if (MaskingModule.hasTool()) {
              tool = MaskingModule.getCurrentTool();
              if (tool.settings.thickness) {
                tool.setting('thickness', tool.setting('thickness') + 1);
              }
            }
          } else if (e.keyCode === 219) {
            if (MaskingModule.hasTool()) {
              tool = MaskingModule.getCurrentTool();
              if (tool.settings.thickness) {
                tool.setting('thickness', tool.setting('thickness') - 1);
              }
            }
          }
        }
      };
    },
    off: function off(view) {
      delete keyListeners.bracket_thickness;
    }
  };

  bindings.edit = {
    on: function on(view, keys) {
      var down = false;
      keys.forEach(function (key) {
        keyListeners['edit' + key] = {
          keydown: function keydown(e) {
            if (e.keyCode === key && !down && MaskingModule.hasSelectedLayer()) {
              view.setEditing(down = true);
            }
          },
          keyup: function keyup(e) {
            if (e.keyCode === key && !e.ctrlKey) {
              view.setEditing(down = false);
            }
          }
        };
      });
    },
    off: function off(view, keys) {
      keys.forEach(function (key) {
        delete keyListeners['edit' + key];
      });
    }
  };

  bindings.delete = {
    on: function on(view, keys) {
      keys.forEach(function (key) {
        var down = false;
        keyListeners['delete' + key] = {
          keydown: function keydown(e) {
            if (e.keyCode === key && !down) {
              $(view).trigger('delete');
            }
          },
          keyup: function keyup(e) {
            if (e.keyCode === 32) {
              down = false;
            }
          }
        };
      });
    },
    off: function off(view, keys) {
      keys.forEach(function (key) {
        delete keyListeners['edit' + key];
      });
    }
  };

  bindings.cancel = {
    on: function on(view, keys) {
      keys.forEach(function (key) {
        var down = false;
        keyListeners['cancel' + key] = {
          keydown: function keydown(e) {
            if (e.keyCode === key && !down && MaskingModule.hasTool()) {
              // ctrl+(cancel key) removes current tool
              if (e.ctrlKey) {
                MaskingModule.removeTool();
              } else {
                MaskingModule.getCurrentTool().cancel();
              }

              down = true;
            }
          },
          keyup: function keyup(e) {
            if (e.keyCode === key) {
              down = false;
            }
          }
        };
      });
    },
    off: function off(view, keys) {
      keys.forEach(function (key) {
        delete keyListeners['cancel' + key];
      });
    }
  };

  bindings.undo = {
    on: function on(view, keys) {
      keys.forEach(function (key) {
        keyListeners['undo' + key.key + key.ctrl] = {
          keydown: function keydown(e) {
            var pressed = String.fromCharCode(e.keyCode + 32);
            if (key.key === pressed && key.ctrl === e.ctrlKey) {
              try {
                // undo/redo throws Error when no undo/redo is available
                // catch errors so that devtools doesn't think holding ctrl-z down is an uncaught exception
                History.get().undo();
                MaskingModule.draw();
              } catch (err) {
                console.error(err);
              }
            }
          }
        };
      });
    },
    off: function off(view, keys) {
      keys.forEach(function (key) {
        delete keyListeners['undo' + key.key + key.ctrl];
      });
    }
  };

  bindings.redo = {
    on: function on(view, keys) {
      keys.forEach(function (key) {
        keyListeners['redo' + key.key + key.ctrl] = {
          keydown: function keydown(e) {
            var pressed = String.fromCharCode(e.keyCode + 32);
            if (key.key === pressed && key.ctrl === e.ctrlKey) {
              try {
                // undo/redo throws Error when no undo/redo is available
                // catch errors so that devtools doesn't think holding ctrl-y down is an uncaught exception
                History.get().redo();
                MaskingModule.draw();
              } catch (err) {
                console.error(err);
              }
            }
          }
        };
      });
    },
    off: function off(view, keys) {
      keys.forEach(function (key) {
        delete keyListeners['redo' + key.key + key.ctrl];
      });
    }
  };

  return bindings;
}

function shouldHover(state, view) {
  return view.hoveringBinded && !state.currentTool && state.view.layerHoverOption !== LayerHoverOption.none && !view.isPanning();
}

function getClientX(event) {
  event = event.originalEvent || event;

  if (event.clientX) {
    return event.clientX;
  } else if (event.x) {
    return event.x;
  } else if (event.touches && event.touches.length > 0) {
    return event.touches[0].clientX;
  } else if (event.changedTouches && event.changedTouches.length > 0) {
    return event.changedTouches[0].clientX;
  }
  return undefined;
}

function getClientY(event) {
  event = event.originalEvent || event;

  if (event.clientY) {
    return event.clientY;
  } else if (event.y) {
    return event.y;
  } else if (event.touches && event.touches.length > 0) {
    return event.touches[0].clientY;
  } else if (event.changedTouches && event.changedTouches.length > 0) {
    return event.changedTouches[0].clientY;
  }
  return undefined;
}

function relative(e, offset) {
  var state = MaskingModule.state;
  offset = offset || {};

  var pos = {
    x: getClientX(e) - (offset.left || 0) - state.view.offset.x,
    y: getClientY(e) - (offset.top || 0) - state.view.offset.y
  };

  pos.x /= state.view.widthRatio;
  pos.y /= state.view.heightRatio;
  pos.x /= state.view.scale;
  pos.y /= state.view.scale;

  pos.x += state.gutterX;
  pos.y += state.gutterY;

  return pos;
}

function getLayerIDAtPosition(pos, state) {
  var layerIDs = state.layerIDs;
  for (var i = layerIDs.length - 1; i >= 0; i--) {
    // TODO: create map of pixels that contain layer IDs to make this faster - it's very fast as is now though
    if (state.layers[layerIDs[i]].drawingContext.getImageData(pos.x, pos.y, 1, 1).data[3]) {
      return layerIDs[i];
    }
  }

  return null;
}

// necessary in case bind() is called after window.onload
$(window).on('load', function () {
  window.loaded = true;
});

// uses a global window object reference, to avoid circular dependencies
/**
 * @namespace MaskingModule
 */
var MaskingModule$1 = window.MaskingModule = {};
var STATE = new MaskingState();

Object.defineProperty(MaskingModule$1, 'state', {
  enumerable: true,
  get: function get$$1() {
    return STATE;
  },
  set: function set$$1(state) {
    if (state instanceof MaskingState) {
      STATE = state;
    } else {
      STATE = new MaskingState(state);
    }

    STATE.update.all();
  }
});

Object.defineProperty(MaskingModule$1, 'update', {
  enumerable: true,
  get: function get$$1() {
    return STATE.update;
  }
});

Object.defineProperty(MaskingModule$1, 'view', { value: new MaskingView() });

/**
 * Extends the current state. This does the same thing as setting `state`, but
 * without overriding old state.
 *
 * Note: you likely don't want to use this method, unless there is no built
 * in method to change the state you want to (please don't do so manually);
 * it is slow to draw because it will do a full update
 *
 * @example
 * MaskingModule.changeState({
 *   project: {
 *     width: 100,
 *     height: 155,
 *   }
 * });
 *
 * MaskingModule.changeState({
 *   project: {
 *     image: {
 *       url: 'master.jpg'
 *     }
 *   }
 * });
 *
 * // state will retain the project size
 *
 * @param {object} state - object with state properties to override
 * @returns {MaskingModule}
 * @memberOf MaskingModule
 * @since 0.2.0
 */
MaskingModule$1.changeState = function (state) {
  if (state instanceof MaskingState) {
    throw new Error('You passed a full masking state to changeState - set `state` instead');
  }

  if (!state) {
    return MaskingModule$1;
  }

  $.extend(true, STATE, state);

  return MaskingModule$1;
};

/**
 * Resets all state. This is equivalent to calling:
 *
 * ```
 *   MaskingModule.state = new MaskingModule.MaskingState();
 * ```
 *
 * @returns {MaskingModule}
 * @memberOf MaskingModule
 * @since 0.2.0
 */
MaskingModule$1.reset = function () {
  MaskingModule$1.state = new MaskingState();
  return MaskingModule$1;
};

var lastDrawingCall = Promise.resolve();

/**
 * Draws all current state to the view.
 *
 * @example
 * MaskingModule.pan(-50, +25).draw();
 *
 * @returns {promise} a promise for when draw call completes
 * @memberOf MaskingModule
 * @since 0.2.0
 */
MaskingModule$1.draw = function () {
  return lastDrawingCall.then(function () {
    lastDrawingCall = new Promise(function (resolve) {
      window.requestAnimationFrame(function () {
        MaskingModule$1.view.draw(STATE).then(function () {
          return resolve();
        });
      });
    });

    return lastDrawingCall;
  });
};

MaskingModule$1.on = function () {
  var _$;

  return (_$ = $(MaskingModule$1)).on.apply(_$, arguments);
};

/**
 * Helper shortcut for jQuery event binding.
 *
 * @example
 * MaskingModule.on(MaskingModule.Events.LayerClicked, handleClick);
 *
 * @returns {MaskingModule}
 * @memberOf MaskingModule
 * @since 0.4.1
 */
MaskingModule$1.on = function () {
  var _$2;

  return (_$2 = $(MaskingModule$1)).on.apply(_$2, arguments);
};

/**
 * Helper shortcut for jQuery event unbinding.
 *
 * @example
 * MaskingModule.off(MaskingModule.Events.LayerClicked);
 *
 * @returns {MaskingModule}
 * @memberOf MaskingModule
 * @since 0.4.1
 */
MaskingModule$1.off = function () {
  var _$3;

  return (_$3 = $(MaskingModule$1)).off.apply(_$3, arguments);
};

/**
 * Sets the background image for masking, useful for showing renders and
 * previews.
 *
 * @example
 * MaskingModule.setDisplayImage('/project/render.png', true);
 *
 * @param {string} url of image for display (not always project image)
 * @param {bool} [drawOnLoad=false] set to draw when the image is loaded
 * @returns {promise} a promise for when image is loaded
 * @memberOf MaskingModule
 * @since 0.2.0
 */
MaskingModule$1.setDisplayImage = function (url, drawOnLoad) {
  STATE.view.displayImageURL = url;

  return new Promise(function (resolve) {
    if (drawOnLoad) {
      // browser should reuse the image cache when drawing, avoiding the "jpeg tear"
      var i = new Image();
      i.onload = function () {
        MaskingModule$1.draw().then(function () {
          return resolve();
        });
      };

      i.src = url;
    } else {
      resolve();
    }
  });
};

/**
 * Resets the background image to the project image.
 *
 * @example
 * MaskingModule.setDisplayImage('/project/render.png', true);
 * // ...
 * // user is done looking at render
 * MaskingModule.resetDisplayImage(true);
 *
 * @param {bool} [drawOnLoad=false] set to draw when the image is loaded
 * @returns {MaskingModule}
 * @memberOf MaskingModule
 * @since 0.2.0
 */
MaskingModule$1.resetDisplayImage = function (drawOnLoad) {
  return MaskingModule$1.setDisplayImage(STATE.project.image.url, drawOnLoad);
};

/**
 * @returns {Tool} the currently selected masking tool
 * @throws when no tool is present
 * @memberOf MaskingModule
 * @since 0.2.0
 */
MaskingModule$1.getCurrentTool = function () {
  if (STATE.currentTool) {
    return STATE.currentTool;
  }
  throw new Error('no tool selected');
};

/**
 * Set the current masking tool. This will also cancel the old tool, and
 * turn off panning.
 *
 * @example
 *   MaskingModule.setTool(MaskingModule.Tools.Polygon);
 *
 * @param {Tool} tool - instance or constructor
 * @returns {MaskingModule}
 * @memberOf MaskingModule
 * @since 0.2.0
 */
MaskingModule$1.setTool = function (tool) {
  if (STATE.currentTool) {
    STATE.currentTool.remove();
  }

  MaskingModule$1.setHoverOption(LayerHoverOption.none).setPanning(false);

  if (typeof tool === 'function') {
    // tool can be passed as the constructor function
    STATE.currentTool = new tool();
  } else if (tool) {
    STATE.currentTool = tool;
  } else {
    throw new Error('invalid tool');
  }

  $(MaskingModule$1).trigger(Events.ToolChanged, STATE.currentTool);
  return MaskingModule$1;
};

/**
 * @example
 * if (MaskingModule.hasTool()) {
 *   MaskingModule.getCurrentTool().cancel();
 * }
 *
 * @returns {bool} whether there is a tool currently open
 * @memberOf MaskingModule
 * @since 0.2.0
 */
MaskingModule$1.hasTool = function () {
  return !!STATE.currentTool;
};

/**
 * Removes the currently selected tool.
 *
 * @returns {MaskingModule}
 * @memberOf MaskingModule
 * @since 0.2.0
 */
MaskingModule$1.removeTool = function () {
  if (STATE.currentTool) {
    STATE.currentTool.remove();
    STATE.currentTool = null;
    MaskingModule$1.draw();
    $(MaskingModule$1).trigger(Events.ToolChanged, null);
  }

  return MaskingModule$1;
};

/**
 * @returns {string} `saveString` for {@link MaskingModule#loadMasterMask loadMasterMask}
 * @memberOf MaskingModule
 */
MaskingModule$1.exportMasterMask = function () {
  var master = new MasterMask(STATE.project.width, STATE.project.height);

  STATE.layerIDs.forEach(function (layerID) {
    var exported = STATE.layers[layerID].exportMask(true);
    master.addMask(layerID, exported.canvas.getContext('2d'));
  });

  return master.saveString();
};

/**
 * @param {string} saveString - raw master mask save string
 * @param {object} options - map of layerID: { properties, order } like {@link MaskingLayer}
 * @returns {string[]} layerIDs that were loaded
 * @memberOf MaskingModule
 */
MaskingModule$1.loadMasterMask = function (saveString, options) {
  options = options || {};
  MaskingModule$1.removeAllLayers();

  var master = new MasterMask();
  if (master.loadString(saveString)) {
    var canvas = document.createElement('canvas');
    canvas.width = master.width;
    canvas.height = master.height;
    var ctx = canvas.getContext('2d');
    var data = ctx.getImageData(0, 0, canvas.width, canvas.height);

    master.layerIDs.forEach(function (layerID) {
      STATE.newLayer(layerID, options[layerID].properties, options[layerID].order);
      master.getMaskToData(layerID, STATE.layers[layerID].maskColor, data);
      STATE.layers[layerID].setImage(data, STATE.gutterX, STATE.gutterY);
    });

    return master.layerIDs;
  }
  throw new Error('loading mastermask failed');
};

/**
 * Loads a single layer, given an image url. Mask image is assumed to be the
 * RW black & white mask type.
 *
 * @example
 * MaskingModule.loadLayer('/project/mask_0.png', {
 *   id: '0',
 *   pos: { x: 0, y: 0, width: 1400, height: 1000 }
 * });
 *
 * @param {string} url - url of image
 * @param {object} options
 * @param {string|number} [options.id] id to assign
 * @param {Polygon[]} [options.polygons] array of polygons in layer
 * @param {object} [options.perspective] perspective of the layer
 * @param {object} [options.pos] position (x, y, width, height) of the mask image inside the project image
 * @param {object} options.pos.x - top-left x position
 * @param {object} options.pos.y - top-left y position
 * @param {object} options.pos.width - mask width
 * @param {object} options.pos.height - mask height
 * @param {object} [options.properties] layer properties passed to {@link Layer}
 * @param {number} [options.order] index in order, be sure it does not conflict with other layers
 * @param {boolean} adjustForGutter - adjusts the mask and polygons to take into account the gutter.
 * @returns {promise} a promise for when layer is fully loaded
 * @memberOf MaskingModule
 * @since 0.2.0
 */
MaskingModule$1.loadLayer = function (url, options) {
  var adjustForGutter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (options.pos && (isNaN(options.pos.x) || isNaN(options.pos.y))) {
    delete options.pos;
  }

  options.pos = options.pos || {
    x: 0,
    y: 0,
    width: STATE.projectWidthWithGutter,
    height: STATE.projectHeightWithGutter
  };

  var layerPresent = !!STATE.layers[options.id];

  var layer = void 0;
  if (layerPresent) {
    layer = STATE.layers[options.id];
  } else {
    layer = STATE.layers[STATE.newLayer(options.id, options.properties, options.order)];
  }

  if (options.perspective) {
    layer.perspective = options.perspective;
  }

  if (options.type) {
    layer.type = options.type;
  }

  // adjust for initial gutter
  if (adjustForGutter) {
    options.pos.x += STATE.gutterX;
    options.pos.y += STATE.gutterY;

    options.polygons = options.polygons ? options.polygons.map(function (polygon) {
      return polygon.add(new Point(STATE.gutter));
    }) : [];
  }

  function loadVector() {
    if (options.polygons && options.polygons.length > 0) {
      for (var i = 0; i < options.polygons.length; i++) {
        layer.addElement(new PolygonElement(options.polygons[i], true));
      }
    }

    return Promise.resolve(layer.id);
  }

  function loadRaster() {
    return new Promise(function (resolve, reject) {
      function loadImage(image) {
        layer.loadMaskImage(image, options.pos);
        STATE.update.raster({
          layers: [layer.id],
          region: options.pos
        });

        resolve(layer.id);
      }

      if (options.preload) {
        options.preload.promise.then(function () {
          loadImage(options.preload.image);
        }, function () {
          reject(layer.id);
        });
      } else {
        var image = new Image();
        // needed for remote images with CORS headers so
        // canvas doesn't become tainted
        image.setAttribute('crossOrigin', 'Anonymous');

        image.onload = function () {
          loadImage(image);
        };

        image.onerror = function () {
          reject(layer.id);
        };

        image.src = url;
      }
    });
  }

  if (layerPresent) {
    // still try to load vector, but raster is present
    return loadVector();
  }

  if (Settings$1.loadVectorOnly) {
    return loadVector();
  }

  if (Settings$1.loadRasterOnly) {
    return loadRaster().then(null, function () {
      if (options.polygons && options.polygons.length > 0) {
        // draw vector polygons to the raster canvas, converting to full raster project
        layer.drawPolygon({
          draw: options.polygons
        });

        return Promise.resolve(layer.id);
      }
      return Promise.reject(layer.id);
    });
  }

  if (Settings$1.preferRaster) {
    return loadRaster().then(null, function () {
      return loadVector();
    });
  }
  return loadVector().then(function () {
    if (!options.polygons || options.polygons.length == 0) {
      return loadRaster().then(null, function () {
        return (
          // don't pass promise rejection - it's just an empty layer
          Promise.resolve(layer.id)
        );
      });
    }
  });
};

/**
 * Load an array of layers in order, each using {@link MaskingModule.loadLayer loadLayer}.
 *
 * See {@link MaskingModule.loadLayersXML loadLayersXML} for a more ergonmic way of calling this.
 *
 * @example
 * MaskingModule.loadLayers([
 *   {
 *     url: '/project/mask_0.png',
 *     options: {
 *       id: 0,
 *       pos: { x: 0, y: 0, width: 1400, height: 1000 }
 *     }
 *   },
 *   {
 *     url: '/project/mask_1.png',
 *     options: {
 *       id: 1,
 *       pos: { x: 25, y: 75, width: 450, height: 239 }
 *     }
 *   },
 *   ...
 * ]);
 *
 * @param {object[]} layers - array of {url, options} that are fed to `loadLayer`
 * @param {options} options - object
 * @param {string} options.mastermask - optional url for the mastermask file
 * @param {boolean} options.adjustLayerGutters - if true, it will adjust the layer's mask & polygons to take the gutter into account
 * @param {boolean} options.allowRemoval - if true, will also remove layers that don't exist in the current state
 * @returns {promise} a promise for when layers are all loaded
 * @memberOf MaskingModule
 * @since 0.2.0
 */
MaskingModule$1.loadLayers = function (layers, _ref) {
  var mastermask = _ref.mastermask,
      _ref$adjustLayerGutte = _ref.adjustLayerGutters,
      adjustLayerGutters = _ref$adjustLayerGutte === undefined ? false : _ref$adjustLayerGutte,
      _ref$allowRemoval = _ref.allowRemoval,
      allowRemoval = _ref$allowRemoval === undefined ? false : _ref$allowRemoval;

  var loadMasterMask = new Promise(function (resolve, reject) {
    if (allowRemoval) {
      var newLayerIds = layers.toArray().map(function (layer) {
        return layer.options.id;
      });
      MaskingModule$1.removeNonSpecifiedLayers(newLayerIds);
    }

    if (mastermask && !Settings$1.loadVectorOnly) {
      $.get({
        url: mastermask,
        dataType: 'text'
      }).then(function (text) {
        var options = {};
        for (var i = 0; i < layers.length; i++) {
          options[layers[i].options.id] = {
            properties: layers[i].options.properties,
            order: i
          };
        }

        resolve(MaskingModule$1.loadMasterMask(text, options));
      }, function () {
        resolve();
      });

      // this is an optimization for mastermask - when no mastermask file
      // is on the server, you don't want to just start downloading mask
      // files then and there, you'd prefer that they've already been
      // downloading in the background. here, we'll download 5 of the layer
      // images for use (> 5 queues requests anyways), and those images
      // will be in cache for use later
      $(layers).each(function (i, layer) {
        if (i > 4) {
          return false;
        }

        var img = new Image();

        var promise = new Promise(function (resolve, reject) {
          img.onload = function () {
            resolve();
          };

          img.onerror = function () {
            reject();
          };

          img.src = layer.url;
        });

        layer.options.preload = {
          image: img,
          promise: promise
        };
      });
    } else {
      resolve();
    }
  });

  return loadMasterMask.then(function () {
    var _$4;

    var promises = [];
    for (var i = 0; i < layers.length; i++) {
      layers[i].options.order = i;
      promises.push(MaskingModule$1.loadLayer(layers[i].url, layers[i].options, adjustLayerGutters));
    }

    return (_$4 = $).when.apply(_$4, promises);
  });
};

/**
 * Loads layers from the project.xml file, using {@link MaskingModule.loadLayers loadLayers}.
 *
 * You probably want to use {@link MaskingModule.loadProjectXML loadProjectXML}
 * if you're loading a full project.
 *
 * @example
 * $.ajax({
 *   type: 'GET',
 *   url: projectPath + '/project.xml',
 *   dataType: 'xml',
 * }).then(function(xml) {
 *   return MaskingModule.loadLayersXML(xml, projectPath);
 * });
 *
 * @param {xml} xml - xml object of the project.xml root
 * @param {string} projectPath - url path that will contain mask images
 * @param {boolean} allowRemoval - if true will remove any layers from our state
 * @returns {promise} a promise for when layers are all loaded
 * @memberOf MaskingModule
 * @since 0.2.0
 */
MaskingModule$1.loadLayersXML = function (xml, projectPath) {
  var allowRemoval = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var layers = MaskingModule$1.parseLayerXML(xml, projectPath);

  if (Settings$1.useMasterMask) {
    return MaskingModule$1.loadLayers(layers, { mastermask: projectPath + '/mask_mastermask.png', allowRemoval: allowRemoval });
  }
  return MaskingModule$1.loadLayers(layers, { allowRemoval: allowRemoval });
};

/**
  * Parse layer xml and convert into layer JSON
  * @param {xml} xml - xml object of the project.xml root
  * @param {string} projectPath - url path that will contain mask images
  * @returns {array} of layers
  * @memberOf MaskingModule
  * @since 0.4.4
  */
MaskingModule$1.parseLayerXML = function (xml, projectPath) {
  function mapPoints(str) {
    var noGutter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var points = str.split(':').map(function (p) {
      var points = p.split(',').map(function (p) {
        return parseInt(p);
      });
      if (noGutter) {
        return new Point(points[0], points[1]);
      }
      return new Point(points[0] + STATE.gutterX, points[1] + STATE.gutterY);
    });

    while (points.length > 1 && points[0].equals(points[points.length - 1])) {
      // polygon doesn't need repeated origin
      points.pop();
    }

    return points;
  }

  function parsePolygonTags(tags) {
    var polygons = [];
    tags.each(function (i, tag) {
      var polygon = new Polygon(mapPoints($(tag).attr('points')));

      $(tag).find('hole').each(function (i, h) {
        polygon.holes.push(new Polygon(mapPoints($(h).attr('points'))));
      });

      polygons.push(polygon);
    });

    return polygons;
  }

  function getPoints(element) {
    var noGutter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var points = [];

    var pointInd = 1;
    while (true) {
      var point = $(element).attr('p' + pointInd);
      pointInd++;

      if (point) {
        points.push(mapPoints(point, noGutter)[0]);
      } else {
        break;
      }
    }

    if (points[0].equals(points[points.length - 1])) {
      // polygon doesn't need repeated origin
      points.pop();
    }

    return points;
  }

  function parseContourTags(tags) {
    var polygons = [];
    tags.each(function (_, tag) {
      var polygon = new Polygon(getPoints(tag));

      $(tag).find('hole').each(function (i, hole) {
        polygon.holes.push(new Polygon(getPoints(hole)));
      });

      polygons.push(polygon);
    });

    return polygons;
  }

  function parsePolygons(layerXML) {
    var category = categoryType(layerXML);
    if (category === 'opening') {
      return;
    }
    if (layerXML.find('polygon').length) {
      return parsePolygonTags(layerXML.find('polygon'));
    } else if (layerXML.find('contour').length) {
      return parseContourTags(layerXML.find('contour'));
    } else if (layerHasPoints(layerXML)) {
      return parseContourTags(layerXML);
    }
  }

  function layerHasPoints(layerXML) {
    if (!layerXML.attr('p1')) {
      return false;
    }
    return true;
  }

  function layerType(layerXML) {
    return layerXML.attr('layerType') || 'RW' + layerXML.attr('type');
  }

  function categoryType(layerXML) {
    var type = layerType(layerXML);
    return Settings$1.layerTypeCategories[type];
  }

  function parsePerspective(layerXML) {
    var category = categoryType(layerXML);
    if (!layerXML.attr('perspectiveP1') && !(category === 'opening' && layerHasPoints(layerXML))) {
      return;
    }

    function perspectivePoint(n) {
      var points = layerXML.attr('perspectiveP' + n).split(',');
      return new Point(parseInt(points[0]), parseInt(points[1]));
    }

    var points = [];
    if (category === 'opening' && layerHasPoints(layerXML)) {
      // openings may have up to 6 point perspectives, whereas others have 4 points
      points.push.apply(points, toConsumableArray(getPoints(layerXML, true)));
    } else {
      points.push(perspectivePoint(1), perspectivePoint(2), perspectivePoint(3), perspectivePoint(4));
    }

    return new Perspective(points);
  }

  function parseGroup(layerXML, groups) {
    if (groups.length == 0) {
      return layerXML.attr('type');
    }
    var layerID = layerXML.attr('layerID');
    var layerGroup = void 0;
    groups.each(function (_, group) {
      var ind = 0;
      while (true) {
        var id = $(group).attr('layer' + ind);
        ind++;

        if (id) {
          if (id === layerID) {
            layerGroup = $(group).attr('groupID');
            return false;
          }
        } else {
          break;
        }
      }
    });

    return layerGroup;
  }

  return $(xml).find('layers').find('layer').map(function (i, e) {
    var layerXML = $(e);
    return {
      url: projectPath + '/mask_' + layerXML.attr('layerID') + '.png',
      options: {
        id: layerXML.attr('layerID'),
        gammaLevel: parseInt(layerXML.attr('gammaLevel')),
        shadowsLevel: parseInt(layerXML.attr('shadowsLevel')),
        type: layerXML.attr('type') || layerXML.attr('layerType'),
        perspective: parsePerspective(layerXML),
        polygons: parsePolygons(layerXML),
        pos: {
          x: parseInt(layerXML.attr('maskX')) + STATE.gutterX,
          y: parseInt(layerXML.attr('maskY')) + STATE.gutterY,
          width: parseInt(layerXML.attr('maskWid')),
          height: parseInt(layerXML.attr('maskHgt'))
        },
        properties: {
          group: parseGroup(layerXML, $(xml).find('groups>group')),
          layerType: layerType(layerXML)
        }
      }
    };
  });
};

/**
 * Loads a project from xml, removing layers that existed before.
 *
 * @example
 * return $.ajax({
 *   type: 'GET',
 *   url: projectPath + '/project.xml',
 *   dataType: 'xml',
 * }).then(function(xml) {
 *   return MaskingModule.loadProjectXML(xml, projectPath);
 * });
 *
 * @param {xml} xml - xml object
 * @param {string} projectPath - where project.xml and mask files are
 * @param {boolean} updateOnly - if true, loading a project will be non-destructive (default: false)
 * @returns {promise} a promise for when project is fully loaded
 * @memberOf MaskingModule
 * @since 0.2.0
 */
MaskingModule$1.loadProjectXML = function (xml, projectPath) {
  var updateOnly = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (!updateOnly) {
    MaskingModule$1.removeTool().removeAllLayers();
  }

  var $project = $(xml).is('project') ? $(xml) : $(xml).find('project');

  MaskingModule$1.changeState({
    project: {
      width: parseInt($project.attr('wid')),
      height: parseInt($project.attr('hgt')),
      image: {
        url: projectPath + '/master.jpg'
      }
    }
  });

  return MaskingModule$1.loadLayersXML(xml, projectPath, updateOnly).then(function () {
    if (!updateOnly) {
      $(MaskingModule$1).trigger(Events.ProjectLoaded, STATE);
    }
  });
};

MaskingModule$1.loadProjectJson = function (project, projectPath) {
  var adjustLayerGutters = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var updateOnly = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  if (!updateOnly) {
    MaskingModule$1.removeTool().removeAllLayers();
  }

  var masterImage = project.masterImage || projectPath + '/master.jpg';

  MaskingModule$1._masterCacheImage = new Image();
  MaskingModule$1._masterCacheImage.src = masterImage;

  MaskingModule$1.changeState({
    project: {
      width: project.width,
      height: project.height,
      image: {
        url: masterImage
      }
    }
  });

  // load layers
  if (Settings$1.useMasterMask) {
    return MaskingModule$1.loadLayers(project.layers, {
      mastermask: project.masterMask || projectPath + '/mask_mastermask.png',
      adjustLayerGutters: adjustLayerGutters,
      allowRemoval: updateOnly
    });
  }
  return MaskingModule$1.loadLayers(project.layers, { adjustLayerGutters: adjustLayerGutters, allowRemoval: updateOnly }).then(function () {
    if (!updateOnly) {
      $(MaskingModule$1).trigger(Events.ProjectLoaded, STATE);
    }
  });
};

/**
 * Loads a project from xml, removing layers that existed before.
 *
 * @example
 * return $.ajax({
  *   type: 'GET',
  *   url: projectPath + '/project.xml',
  *   dataType: 'xml',
  * }).then(function(xml) {
  *   return MaskingModule.loadProjectXML(xml, projectPath);
  * });
  *
  * @param {xml} xml - xml object
  * @param {string} projectPath - where project.xml and mask files are
  * @returns {project} JSON of the project
  * @memberOf MaskingModule
  * @since 0.4.4
  */
MaskingModule$1.parseProjectXML = function (xml, projectPath) {
  var $project = $(xml).is('project') ? $(xml) : $(xml).find('project');

  var project = {
    project: {
      width: parseInt($project.attr('wid')),
      height: parseInt($project.attr('hgt')),
      ppf: parseFloat($project.attr('ppf')),
      scaleP1: fromCSVPoints($project.attr('scaleP1')),
      scaleP2: fromCSVPoints($project.attr('scaleP2')),
      image: {
        url: projectPath + '/master.jpg'
      }
    }
  };

  MaskingModule$1.changeState(project);
  project.project.layers = MaskingModule$1.parseLayerXML(xml, projectPath);
  return project;
};

/**
 * Downloads & loads a project from url, using {@link MaskingModule.loadProjectXML loadProjectXML}.
 *
 * @example
 * MaskingModule.loadProject("/projects/Farmhouse").then(function() {
 *   MaskingModule.panCenter().draw();
 * });
 *
 * @param {string} projectPath - where project.xml and mask files are
 * @returns {promise} a promise for when project is fully loaded (resolved with project xml object)
 * @memberOf MaskingModule
 * @since 0.2.0
 */
MaskingModule$1.loadProject = function (projectPath) {
  // we know that project has a master image, and is usually the largest
  // file to download, so start downloading before project.xml (and keep Image referenced)
  MaskingModule$1._masterCacheImage = new Image();
  MaskingModule$1._masterCacheImage.src = projectPath + '/master.jpg';

  return $.ajax({
    type: 'GET',
    url: projectPath + '/project.xml',
    dataType: 'xml'
  }).then(function (xml) {
    return MaskingModule$1.loadProjectXML(xml, projectPath).then(function () {
      return xml;
    });
  });
};

/**
 * @example
 * if (MaskingModule.hasSelectedLayer()) {
 *   MaskingModule.getSelectedLayer().setImage(...);
 * }
 *
 * @returns {bool} whether there is a layer currently selected
 * @memberOf MaskingModule
 * @since 0.2.0
 */
MaskingModule$1.hasSelectedLayer = function () {
  return !!STATE.selectedLayer;
};

/**
 * @example
 * MaskingModule.getSelectedLayer().loadMaskImage(...);
 *
 * @returns {Layer} the selected layer
 * @throws when no layer is present
 * @memberOf MaskingModule
 * @since 0.2.0
 */
MaskingModule$1.getSelectedLayer = function () {
  if (!STATE.selectedLayer) {
    throw new Error('no layer selected');
  }

  return STATE.layers[STATE.selectedLayer];
};

/**
 * @example
 * MaskingModule.getLayer('25').drawRaster(...);
 *
 * @returns {Layer} the selected layer
 * @throws when no layer is present
 * @memberOf MaskingModule
 * @since 0.2.0
 */
MaskingModule$1.getLayer = function (id) {
  var layer = STATE.layers[id];

  if (!layer) {
    throw new Error('invalid layer');
  }

  return layer;
};

MaskingModule$1.getLayers = function () {
  return STATE.layers;
};

/**
 * Creates a new layer.
 *
 * @example
 * // equivalent to selectNewLayer
 * let layerID = MaskingModule.newLayer();
 * MaskingModule.selectLayer(layerID);
 *
 * @param {string|number} [id] - id of layer to use
 * @param {object} [properties] - layer properties (see {@link Layer} constructor)
 * @returns {string} id of the new layer
 * @memberOf MaskingModule
 * @since 0.2.0
 */
MaskingModule$1.newLayer = function (id, properties) {
  return STATE.newLayer(id, properties);
};

/**
 * Creates a new layer and selects it.
 *
 * @example
 * MaskingModule.selectNewLayer('32');
 *
 * @param {string|number} [id] - of layer to use
 * @param {object} [properties] - layer properties (see {@link Layer} constructor)
 * @returns {MaskingModule}
 * @memberOf MaskingModule
 * @since 0.2.0
 */
MaskingModule$1.selectNewLayer = function (id, properties) {
  return MaskingModule$1.selectLayer(STATE.newLayer(id, properties));
};

/**
 * Selects a layer by id. Will remove current tool.
 *
 * @param {string|number} id - id of layer
 * @returns {MaskingModule}
 * @memberOf MaskingModule
 * @since 0.2.0
 */
MaskingModule$1.selectLayer = function (id) {
  id = id == null ? null : id.toString();

  if (id && !STATE.layers[id]) {
    throw new Error('Layer not found: ' + id);
  }

  if (MaskingModule$1.hasTool()) {
    MaskingModule$1.removeTool();
    STATE.selectedLayer = id;
    $(MaskingModule$1).trigger(Events.LayerSelected, id);
  } else {
    STATE.selectedLayer = id;
    $(MaskingModule$1).trigger(Events.LayerSelected, id);
  }

  return MaskingModule$1;
};

/**
 * Shifts layer within the layer compositing order.
 *
 * @param {string|number} id - id of layer
 * @param {number|"top"|"bottom"} amount - number of layers to go up or down
 * @returns {MaskingModule}
 * @memberOf MaskingModule
 * @since 0.2.0
 */
MaskingModule$1.shiftLayer = function (id, amount) {
  STATE.shiftLayer(id, amount);

  $(MaskingModule$1).trigger(Events.LayerModified, {
    type: 'shifted',
    layerID: id
  });

  return MaskingModule$1;
};

/**
 * Sets the order of the layers
 *
 * @param {number[]} ids - id of layer
 * @returns {MaskingModule}
 * @memberOf MaskingModule
 * @since 0.4.4
 */
MaskingModule$1.setLayerOrder = function (ids) {
  STATE.setLayerOrder(ids);

  $(MaskingModule$1).trigger(Events.LayerModified, {
    type: 'shifted',
    layerIDs: ids
  });

  return MaskingModule$1;
};

/**
 * Clips a layer from all other layers, in both raster and vector. This
 * could be useful for foreground to cut out from other layers.
 *
 * @param {string|number} layerID - layer to clip
 * @returns {MaskingModule}
 * @memberOf MaskingModule
 * @since 0.3.0
 */
MaskingModule$1.clipLayer = function (layerID) {
  var clip = MaskingModule$1.getLayer(layerID);

  STATE.layerIDs.forEach(function (id) {
    if (id === clip.id) {
      return;
    }

    var layer = MaskingModule$1.getLayer(id);

    for (var polygonID in clip.polygons) {
      layer.clipPolygon(layer.addPolygon(clip.polygons[polygonID].clone()));
    }

    if (!clip.hasNoRasterComponent && !layer.hasNoRasterComponent) {
      layer.drawRaster(function (ctx) {
        ctx.save();
        ctx.globalCompositeOperation = 'destination-out';
        ctx.drawImage(clip.drawingCanvas, 0, 0);
        ctx.restore();
      });
    }
  });

  return MaskingModule$1;
};

/**
 * Merges layer(s) into one existing layer, removing the others.
 *
 * @param {string|number} id - id of layer to merge into
 * @param {...string} layers - any layer ID(s) to merge into
 * @returns {MaskingModule}
 * @memberOf MaskingModule
 * @since 0.2.0
 */
MaskingModule$1.mergeLayers = function () {
  var _STATE;

  (_STATE = STATE).mergeLayers.apply(_STATE, arguments);
  return MaskingModule$1;
};

/**
 * Removes the layer by id.
 *
 * @param {?string|?number} id - id of layer, or leave blank to remove the current layer
 * @returns {MaskingModule}
 * @memberOf MaskingModule
 * @since 0.2.0
 */
MaskingModule$1.removeLayer = function (id) {
  if (id === undefined) {
    id = STATE.selectedLayer;
  }

  id = id.toString();

  if (STATE.selectedLayer === id) {
    MaskingModule$1.selectLayer(null);
  }

  delete STATE.layers[id];
  delete STATE.layerGroups[id];

  for (var i = 0; i < STATE.layersOrder.length; i++) {
    if (STATE.layersOrder[i] === id) {
      STATE.layersOrder.splice(i, 1);
      STATE.update.drawing();
      break;
    }
  }

  $(MaskingModule$1).trigger(Events.LayerModified, {
    type: 'removed',
    layerID: id
  });

  return MaskingModule$1;
};

/**
 * Removes a group of layers by the group name.
 *
 * @param {string} groupName - name (common "type") of the group of layers to remove
 * @returns {MaskingModule}
 * @memberOf MaskingModule
 * @since 0.2.0
 */
MaskingModule$1.removeGroup = function (groupName) {
  STATE.getGroupLayers(groupName).forEach(function (layerID) {
    MaskingModule$1.removeLayer(layerID);
  });

  return MaskingModule$1;
};

/**
 * Removes all layers.
 *
 * @returns {MaskingModule}
 * @memberOf MaskingModule
 * @since 0.2.0
 */
MaskingModule$1.removeAllLayers = function () {
  for (var id in STATE.layers) {
    if (id !== 'GLOBAL') {
      MaskingModule$1.removeLayer(id);
    }
  }

  return MaskingModule$1;
};

/**
 * Removes all layers that are not specified in input array (layerIds)
 *
 *
 * @returns {MaskingModule}
 * @param {layerIds[]} - array of ids to remove
 * @memberOf MaskingModule
 * @since 0.4.4
 */
MaskingModule$1.removeNonSpecifiedLayers = function () {
  var layerIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var oldLayerIds = Object.keys(STATE.layers);
  var layerIdsToRemove = oldLayerIds.filter(function (stateLayerId) {
    return !layerIds.includes(stateLayerId);
  });

  return MaskingModule$1.removeLayersById(layerIdsToRemove);
};

/**
 * Removes passed in layers.
 *
 * @returns {MaskingModule}
 * @param {layerIds[]} - array of ids to remove
 * @memberOf MaskingModule
 * @since 0.4.4
 */
MaskingModule$1.removeLayersById = function () {
  var layerIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  if (Array.isArray(layerIds)) {
    layerIds.filter(function (id) {
      return id !== 'GLOBAL';
    }).forEach(function (layerId) {
      MaskingModule$1.removeLayer(layerId);
    });
  }
  return MaskingModule$1;
};

/**
 * Shows layer(s) momentarily, it is similar to hoverOnLayer except that
 * it works when ViewLayerOption = ViewLayerOption.highlight|ViewLayerOption.single
 * and does not react to mouse events
 *
 * @returns {MaskingModule}
 * @param {string|number|Array[string|numbers]} layerID - id to hover over
 * @param {boolean} [on] - if true, turns the peek layer on
 * @memberOf MaskingModule
 * @since 0.4.6
 */
MaskingModule$1.peekLayers = function (layerIds, on) {
  MaskingModule$1.view.peekLayers(layerIds, on);
  return MaskingModule$1;
};

/**
 * Hovers on layer, which is displayed differently depending on the
 * {@link LayerHoverOption}.
 *
 * @example
 * MaskingModule.hoverOnLayer(25, MaskingModule.LayerHoverOption.highlight).draw();
 *
 * @param {string|number} layerID - id to hover over
 * @param {LayerHoverOption} [type] - which type of hover
 * @returns {MaskingModule}
 * @memberOf MaskingModule
 * @since 0.2.0
 */
MaskingModule$1.hoverOnLayer = function (layerID, type) {
  if (type) {
    MaskingModule$1.setHoverOption(type);
  }

  layerID = layerID == null ? null : layerID.toString();
  MaskingModule$1.view.hoverOnLayer(layerID);
  return MaskingModule$1;
};

/**
 * Hovers on a list of layers, which is displayed differently depending on
 * the {@link LayerHoverOption}.
 *
 * @example
 * MaskingModule.hoverOnLayers([25, 12, 34], MaskingModule.LayerHoverOption.highlight).draw();
 *
 * @param {string|number} layerID - id to hover over
 * @param {LayerHoverOption} [type] - which type of hover
 * @returns {MaskingModule}
 * @memberOf MaskingModule
 * @since 0.3.0
 */
MaskingModule$1.hoverOnLayers = function (layers, type) {
  if (type) {
    MaskingModule$1.setHoverOption(type);
  }

  MaskingModule$1.view.hoverOnLayers(layers);
  return MaskingModule$1;
};

/**
 * Hovers on a layer group, which is displayed differently depending on the
 * {@link LayerHoverOption}.
 *
 * @param {string} groupName - group that should be hovered
 * @param {LayerHoverOption} [type] - which type of hover
 * @returns {MaskingModule}
 * @memberOf MaskingModule
 * @since 0.2.0
 */
MaskingModule$1.hoverOnGroup = function (groupName, type) {
  if (type) {
    MaskingModule$1.setHoverOption(type);
  }

  MaskingModule$1.view.hoverOnGroup(groupName);
  return MaskingModule$1;
};

/**
 * Sets the type of hovering to use in the UI.
 *
 * @example
 * MaskingModule.hoverOnLayer(25).setHoverOption(MaskingModule.LayerHoverOption.single).draw();
 *
 * @param {LayerHoverOption} type - which type of hover
 * @returns {MaskingModule}
 * @memberOf MaskingModule
 * @since 0.2.0
 */
MaskingModule$1.setHoverOption = function (type) {
  if (STATE.view.layerHoverOption === type) {
    return MaskingModule$1;
  }

  STATE.view.layerHoverOption = type;

  return MaskingModule$1;
};

/**
 * Changes the layer view.
 *
 * @example
 * MaskingModule.setLayerViewOption(MaskingModule.LayerViewOption.current).draw();
 *
 * @param {LayerViewOption} type - which type of view
 * @returns {MaskingModule}
 * @memberOf MaskingModule
 * @since 0.2.0
 */
MaskingModule$1.setLayerViewOption = function (type) {
  if (STATE.view.layerViewOption === type) {
    return MaskingModule$1;
  }

  STATE.view.layerViewOption = type;

  return MaskingModule$1;
};

/**
 * Zooms the project view, to a set scale
 *
 * @param {number} scale - multiplier for width & height
 * @param {number} [focalX] - point to zoom into (relative to project size)
 * @param {number} [focalY] - point to zoom into (relative to project size)
 * @returns {MaskingModule}
 * @memberOf MaskingModule
 * @since 0.2.0
 */
MaskingModule$1.setZoom = function (scale, focalX, focalY) {
  scale = Math.min(scale, MaskingModule$1.Settings.zoomLimits.max);
  scale = Math.max(scale, MaskingModule$1.Settings.zoomLimits.min);

  var rX = void 0,
      rY = void 0;
  if (focalX && focalY) {
    rX = (focalX - STATE.gutterX) / STATE.project.width;
    rY = (focalY - STATE.gutterY) / STATE.project.height;
  } else {
    focalX = STATE.view.container.width / 2 - STATE.view.offset.x;
    focalX = focalX / STATE.view.widthRatio / STATE.view.scale;
    rX = focalX / STATE.project.width;

    focalY = STATE.view.container.height / 2 - STATE.view.offset.y;
    focalY = focalY / STATE.view.heightRatio / STATE.view.scale;
    rY = focalY / STATE.project.height;
  }

  var oldWidth = STATE.project.width * STATE.widthScale;
  var newWidth = STATE.project.width * STATE.view.widthRatio * scale;
  var oldHeight = STATE.project.height * STATE.heightScale;
  var newHeight = STATE.project.height * STATE.view.heightRatio * scale;

  var fracX = (newWidth - oldWidth) / oldWidth;
  var fracY = (newHeight - oldHeight) / oldHeight;

  var moveX = -oldWidth * fracX * rX;
  var moveY = -oldHeight * fracY * rY;

  STATE.view.scale = scale;

  return MaskingModule$1.pan(moveX, moveY);
};

/**
 * Zooms the project view, to a relative scale
 *
 * @param {number} scale - multiplier for current scale
 * @param {number} [focalX] - point to zoom into (relative to project size)
 * @param {number} [focalY] - point to zoom into (relative to project size)
 * @returns {MaskingModule}
 * @memberOf MaskingModule
 * @since 0.2.0
 */
MaskingModule$1.zoom = function (scale, focalX, focalY) {
  return MaskingModule$1.setZoom(STATE.view.scale * scale, focalX, focalY);
};

/**
 * Resets the zoom level to 100%.
 *
 * @returns {MaskingModule}
 * @memberOf MaskingModule
 * @since 0.2.0
 */
MaskingModule$1.resetZoom = function () {
  return MaskingModule$1.setZoom(1.0);
};

/**
 * Pans the project view to an offset point.
 *
 * @param {number} x - cordinate offset (relative to project size)
 * @param {number} y - cordinate offset (relative to project size)
 * @returns {MaskingModule}
 * @memberOf MaskingModule
 * @since 0.2.0
 */
MaskingModule$1.panTo = function (x, y) {
  var panBounds = Settings$1.panBounds;

  var minX = -STATE.view.width * STATE.view.scale * panBounds;
  var maxX = STATE.view.container.width - STATE.view.scale * STATE.view.width * (1 - panBounds);

  var minY = -STATE.view.height * STATE.view.scale * panBounds;
  var maxY = STATE.view.container.height - STATE.view.scale * STATE.view.height * (1 - panBounds);

  // allow user to go to edge at all times
  minX = Math.min(minX, -(STATE.view.width * STATE.view.scale - STATE.view.container.width));
  maxX = Math.max(maxX, 0);
  minY = Math.min(minY, -(STATE.view.height * STATE.view.scale - STATE.view.container.height));
  maxY = Math.max(maxY, 0);

  STATE.view.offset.x = Math.min(Math.max(x, minX), maxX);
  STATE.view.offset.y = Math.min(Math.max(y, minY), maxY);

  return MaskingModule$1;
};

/**
 * Pans to a relative position.
 *
 * @param {number} x - cordinate offset from old point
 * @param {number} y - cordinate offset from old point
 * @returns {MaskingModule}
 * @memberOf MaskingModule
 * @since 0.2.0
 */
MaskingModule$1.pan = function (moveX, moveY) {
  return MaskingModule$1.panTo(STATE.view.offset.x + moveX, STATE.view.offset.y + moveY);
};

/**
 * Centers image in project view.
 *
 * @returns {MaskingModule}
 * @memberOf MaskingModule
 * @since 0.2.0
 */
MaskingModule$1.panCenter = function () {
  var x = STATE.view.container.width / 2 - STATE.project.width * STATE.widthScale / 2;
  var y = STATE.view.container.height / 2 - STATE.project.height * STATE.heightScale / 2;
  return MaskingModule$1.panTo(x, y);
};

/**
 * Turns panning on or off.
 *
 * @param {bool} enabled - whether panning is on
 * @returns {MaskingModule}
 * @memberOf MaskingModule
 * @since 0.2.0
 */
MaskingModule$1.setPanning = function (enabled) {
  MaskingModule$1.view.setPanning(enabled);
  return MaskingModule$1;
};

MaskingTool.Prototype = MaskingToolPrototype;

/**
 * MaskingTool is an abstract tool, implement a new MaskingTool like below:
 *
 *   function MyMaskingTool() {
 *     MaskingModule.Tool.call(this);
 *     this.cursor = 'pointer'; // optional css cursor
 *   }
 *
 *   MyMaskingTool.prototype = MaskingModule.Tool.Prototype();
 *
 * @interface MaskingTool
 * @constructor MaskingTool
 * @since 0.2.0
 */
function MaskingTool() {
  this.started = false;

  /**
   * Mapping of masking tools settings. Settings are in the form of:
   *
   * ```
   * {
   *   name: "mySettingName",
   *   type: "bool" | "number" | "myCustomType"
   * }
   * ```
   *
   * @type {object}
   * @name MaskingTool#settings
   * @since 0.2.0
   */
  this.settings = {};
}

function MaskingToolPrototype() {
  return Object.create(MaskingTool.prototype);
}

/**
 * Adds a setting for the tool. Usually, only the tool will need to call this.
 *
 * @param {string} name - setting name
 * @param {string} type - "bool" | "number" | "myCustomType"
 * @param {function} getCurrent - function that returns the setting value
 * @param {function(value)} update - function that sets the setting
 * @memberOf MaskingTool
 * @since 0.2.0
 */
MaskingTool.prototype.addSetting = function (name, type, getCurrent, update) {
  this.settings[name] = {
    name: name,
    type: type,
    getCurrent: getCurrent,
    update: update
  };
};

/**
 * Adds a setting for the tool. Usually, only the tool will need to call this.
 *
 * This function is just a shortcut for {@link MaskingTool#addSetting addSetting},
 * for properties of the tool object (using the name as key).
 *
 * @param {string} name
 * @param {string} type
 * @memberOf MaskingTool
 * @since 0.2.0
 */
MaskingTool.prototype.addStandardSetting = function (name, type) {
  var _this = this;
  this.addSetting(name, type, function () {
    return _this[name];
  }, function (value) {
    _this[name] = value;
  });
};

/**
 * Get/Set a setting of the masking tool.
 *
 * @param {string} name - unique identifier of the setting
 * @param [setting] - if defined, sets the setting
 * @returns setting value if `setting` isn't provided
 * @memberOf MaskingTool
 * @since 0.2.0
 */
MaskingTool.prototype.setting = function (name, setting) {
  if (setting !== undefined) {
    this.settings[name].update(setting);
  } else {
    return this.settings[name].getCurrent();
  }
};

/**
 * @memberOf MaskingTool
 * @since 0.2.0
 */
MaskingTool.prototype.remove = function () {
  this.cancel();
  this.removeTool();
};

/**
 * Will cancel the masking tool and draw the result.
 *
 * @see MaskingTool#cancelTool
 * @memberOf MaskingTool
 * @since 0.2.0
 */
MaskingTool.prototype.cancel = function () {
  this.started = false;
  this.cancelTool();
  MaskingModule.draw();
};

/**
 * Called to start the tool, usually on "mousedown".
 *
 * @param {event} event - jquery event with a `relative` property
 * @see MaskingTool#startTool
 * @memberOf MaskingTool
 * @since 0.2.0
 */
MaskingTool.prototype.start = function (event) {
  this.started = true;
  this.startTool(event);
};

/**
 * Called to when moving cursor/touch, when pressed or just hovering.
 *
 * @param {event} event - jquery event with a `relative` property
 * @see MaskingTool#moveTool
 * @see MaskingTool#hoverTool
 * @memberOf MaskingTool
 * @since 0.2.0
 */
MaskingTool.prototype.move = function (event) {
  if (this.started) {
    this.moveTool(event);
  } else {
    this.hoverTool(event);
  }
};

/**
 * Called to end the tool, usually on "mouseup".
 *
 * @param {event} event - jquery event with a `relative` property
 * @see MaskingTool#endTool
 * @memberOf MaskingTool
 * @since 0.2.0
 */
MaskingTool.prototype.end = function (event) {
  if (this.started) {
    this.endTool(event);
    this.started = false;
  }
};

/**
 * @returns if the tool is currently erasing
 * @throws error if tool does not support erasing
 * @memberOf MaskingTool
 * @since 0.2.0
 */
MaskingTool.prototype.isErasing = function () {
  if (this.hasOwnProperty('erase')) {
    return this.erase;
  }
  throw new Error('tool does not support erasing');
};

/**
 * @param {bool} on - whether the tool should erase or not
 * @throws error if tool does not support erasing
 * @memberOf MaskingTool
 * @since 0.2.0
 */
MaskingTool.prototype.setErase = function (on) {
  if (this.hasOwnProperty('erase')) {
    this.erase = on;
  } else {
    throw new Error('tool does not support erasing');
  }
};

/**
 * Override this function that will remove the tool (like a "permanent cancel").
 *
 * @memberOf MaskingTool
 * @since 0.2.0
 */
MaskingTool.prototype.removeTool = function () {};

/**
 * Override this function that will cancel the tool.
 *
 * @memberOf MaskingTool
 * @since 0.2.0
 */
MaskingTool.prototype.cancelTool = function () {};

/**
 * Override this function that will start the tool.
 *
 * @param {event} event - jquery event with a `relative` property
 * @see MaskingTool#start
 * @memberOf MaskingTool
 * @since 0.2.0
 */
MaskingTool.prototype.startTool = function (event) {
  throw new Error('Unimplemented startTool function in MaskingTool');
};

/**
 * Override this function that is called when moving the tool while clicked.
 *
 * @param {event} event - jquery event with a `relative` property
 * @see MaskingTool#move
 * @memberOf MaskingTool
 * @since 0.2.0
 */
MaskingTool.prototype.moveTool = function (event) {
  throw new Error('Unimplemented moveTool function in MaskingTool');
};

/**
 * Override this function that is called when moving the tool without clicking.
 *
 * Default does nothing.
 *
 * @param {event} event - jquery event with a `relative` property
 * @see MaskingTool#move
 * @memberOf MaskingTool
 * @since 0.2.0
 */
MaskingTool.prototype.hoverTool = function (event) {};

/**
 * Override this function that is called when the tool is ended.
 *
 * @see MaskingTool#end
 * @memberOf MaskingTool
 * @since 0.2.0
 */
MaskingTool.prototype.endTool = function (event) {
  throw new Error('Unimplemented endTool function in MaskingTool');
};

function PolygonBase(layer) {
  this.layer = layer;
  this.polygon = null;
  this.element = null;
  this.startPoint = null;
  this.finish = null;
  this.tempPoint = null;
  this.startTime = null;
}

PolygonBase.prototype.setFinishHandler = function (callback) {
  this.finish = callback;
};

PolygonBase.prototype.isStarted = function () {
  return !!this.polygon;
};

PolygonBase.prototype.createStartPoint = function (e, attrs) {
  attrs = attrs || {};
  var _this = this;

  this.polygon = new Polygon([new Point(e.relative)]);

  if (Settings$1.tools.polygon.progressive) {
    this.polygon.closePath = false;
    $.extend(true, attrs, {
      polygon: {
        'fill-opacity': 0
      }
    });
  }

  this.startTime = new Date().getTime();

  this.element = new PolygonElement(this.polygon).addToLayer(this.layer).setAttrs(attrs.polygon);
  this.startPoint = new HandleElement(e.relative).addToLayer(this.layer).setAttrs(attrs.handle).addEvent('mousedown', handleClick).addEvent('touchend', handleClick);

  function handleClick(e) {
    e.stopPropagation();
    _this.startPoint.removeFromLayer();

    if (_this.finish) {
      _this.polygon.closePath = true;
      _this.finish(_this.polygon);
    }
  }
};

PolygonBase.prototype.previewPoint = function (e) {
  if (this.isStarted()) {
    this.tempPoint = new Point(e.relative);
    // don't write point to polygon, create a temporary polygon with tempPoint
    var points = [].concat(this.polygon.points).concat(this.tempPoint);
    var polygon = new Polygon(points);

    if (Settings$1.tools.polygon.progressive) {
      polygon.closePath = false;
    }

    this.element.updatePolygon(polygon);
    MaskingModule.draw();
  }
};

PolygonBase.prototype.createPoint = function (e) {
  if (!this.isStarted()) {
    this.createStartPoint(e);
    return;
  }

  // clicked once, and dragged the temp point
  if (this.polygon.points.length === 1 && this.tempPoint) {
    // if second click is within ~240ms, it should be ignored because user only meant to make one click
    if (new Date().getTime() - this.startTime > 240) {
      var lastPoint = this.polygon.points[0];
      var a = e.relative.x - lastPoint.x;
      var b = e.relative.y - lastPoint.y;
      var distance = a * a + b * b;

      // if the two points are really close to each other, user only meant one click
      if (distance > 1500 / MaskingModule.state.view.scale) {
        // user clicked once, dragged, and released click
        this.polygon.points.push(new Point(e.relative));
        this.element.updatePolygon(this.polygon);
        MaskingModule.draw();
      }
    }
  } else if (this.polygon.points.length > 1) {
    this.polygon.points.push(new Point(e.relative));
    this.element.updatePolygon(this.polygon);
    MaskingModule.draw();
  }
};

PolygonBase.prototype.movePolygon = function (polygon) {
  if (this.isStarted()) {
    this.polygon = polygon;
    this.element.updatePolygon(polygon);
    MaskingModule.draw();
  }
};

PolygonBase.prototype.clear = function () {
  if (this.element) {
    this.element.removeFromLayer();
    this.startPoint.removeFromLayer();
  }

  this.polygon = null;
  this.tempPoint = null;
};

function RectangleBase(layer) {
  this.layer = layer;
  this.startPoint = null;
  this.polygon = null;
  this.finish = null;
}

RectangleBase.prototype.setFinishHandler = function (callback) {
  this.finish = callback;
};

RectangleBase.prototype.isStarted = function () {
  return !!this.startPoint;
};

RectangleBase.prototype.createStartPoint = function (e, attrs) {
  this.startPoint = new Point(e.relative);
  this.polygon = new PolygonElement(new Polygon([this.startPoint])).addToLayer(this.layer).setAttrs(attrs);
};

RectangleBase.prototype.endPoint = function (e) {
  if (!this.isStarted()) {
    this.createStartPoint(e);
  } else {
    var points = [this.startPoint, new Point(e.relative.x, this.startPoint.y), new Point(e.relative), new Point(this.startPoint.x, e.relative.y)];

    var a = points[0].x - points[2].x;
    var b = points[0].y - points[2].y;
    var size = a * a + b * b;

    // small rectangle is disgarded
    if (size > 120 / MaskingModule.state.view.scale) {
      var polygon = new Polygon(points);
      this.polygon.updatePolygon(polygon);
      if (this.finish) {
        this.finish(polygon);
      }
    }
  }
};

RectangleBase.prototype.moveRect = function (e) {
  if (this.isStarted()) {
    var points = [this.startPoint, new Point(e.relative.x, this.startPoint.y), new Point(e.relative), new Point(this.startPoint.x, e.relative.y)];

    this.polygon.updatePolygon(new Polygon(points));

    MaskingModule.draw();
  }
};

RectangleBase.prototype.clear = function () {
  if (this.polygon) {
    this.polygon.removeFromLayer();
  }

  this.startPoint = null;
};

function RasterRectangle() {
  MaskingTool.call(this);

  if (!MaskingModule.hasSelectedLayer()) {
    throw new Error('Tool requires a layer to be selected');
  }

  this.layer = MaskingModule.getSelectedLayer();
  this.rectBase = new RectangleBase(this.layer);

  this.erase = false;
  this.addStandardSetting('erase', 'bool');

  var _this = this;
  this.rectBase.setFinishHandler(function (polygon) {
    _this.rectBase.clear();

    var erase = _this.erase;
    History.get().pushWithLayer(_this.layer, {
      execute: function execute(layer) {
        if (erase) {
          layer.erasePolygon(polygon);
        } else {
          layer.drawPolygon(polygon);
        }
      }
    }).execute();

    MaskingModule.draw();
  });

  History.restart().pushRasterLayerState(this.layer);
}

RasterRectangle.prototype = MaskingTool.Prototype();

RasterRectangle.prototype.removeTool = function () {
  History.get().clear();
};

RasterRectangle.prototype.cancelTool = function () {
  this.rectBase.clear();
};

RasterRectangle.prototype.startTool = function (e) {
  if (!this.rectBase.isStarted()) {
    this.rectBase.createStartPoint(e, {
      fill: this.erase ? Settings$1.view.eraseColor : this.layer.maskColor,
      stroke: this.erase ? Settings$1.view.eraseColor : this.layer.maskColor
    });
  }
};

RasterRectangle.prototype.moveTool = function (e) {
  this.rectBase.moveRect(e);
};

RasterRectangle.prototype.hoverTool = function (e) {
  this.rectBase.moveRect(e);
};

RasterRectangle.prototype.endTool = function (e) {
  this.rectBase.endPoint(e);
};

function VectorRectangle() {
  MaskingTool.call(this);

  if (!MaskingModule.hasSelectedLayer()) {
    throw new Error('Tool requires a layer to be selected');
  }

  this.layer = MaskingModule.getSelectedLayer();
  this.rectBase = new RectangleBase(this.layer);

  this.erase = false;
  this.addStandardSetting('erase', 'bool');

  var _this = this;
  this.rectBase.setFinishHandler(function (polygon) {
    _this.rectBase.clear();

    History.get().pushVectorLayerState(_this.layer, function (layer) {
      if (_this.erase) {
        layer.clipPolygon(polygon, true);
      } else {
        layer.mergePolygon(polygon, true);
      }
    });

    MaskingModule.draw();
  });

  History.restart().pushVectorLayerState(this.layer);
}

VectorRectangle.prototype = MaskingTool.Prototype();

VectorRectangle.prototype.removeTool = function () {
  History.get().clear();
};

VectorRectangle.prototype.cancelTool = function () {
  this.rectBase.clear();
};

VectorRectangle.prototype.startTool = function (e) {
  if (!this.rectBase.isStarted()) {
    this.rectBase.createStartPoint(e, {
      fill: this.erase ? Settings$1.view.eraseColor : this.layer.maskColor,
      stroke: this.erase ? Settings$1.view.eraseColor : this.layer.maskColor
    });
  }
};

VectorRectangle.prototype.moveTool = function (e) {
  this.rectBase.moveRect(e);
};

VectorRectangle.prototype.hoverTool = function (e) {
  this.rectBase.moveRect(e);
};

VectorRectangle.prototype.endTool = function (e) {
  this.rectBase.endPoint(e);
};

function RasterPolygon() {
  MaskingTool.call(this);

  if (!MaskingModule.hasSelectedLayer()) {
    throw new Error('Tool requires a layer to be selected');
  }

  this.layer = MaskingModule.getSelectedLayer();
  this.polygonBase = new PolygonBase(this.layer);

  this.erase = false;
  this.addStandardSetting('erase', 'bool');

  var _this = this;
  this.polygonBase.setFinishHandler(function (polygon) {
    _this.polygonBase.clear();

    var erase = _this.erase;
    History.get().pushWithLayer(_this.layer, {
      execute: function execute(layer) {
        if (erase) {
          layer.erasePolygon(polygon);
        } else {
          layer.drawPolygon(polygon);
        }
      }
    }).execute();

    MaskingModule.draw();
  });

  History.restart().pushRasterLayerState(this.layer);
}

RasterPolygon.prototype = MaskingTool.Prototype();

RasterPolygon.prototype.removeTool = function () {
  History.get().clear();
};

RasterPolygon.prototype.cancelTool = function () {
  this.polygonBase.clear();
};

RasterPolygon.prototype.startTool = function (e) {
  if (!this.polygonBase.isStarted()) {
    this.polygonBase.createStartPoint(e, {
      polygon: {
        fill: this.erase ? Settings$1.view.eraseColor : this.layer.maskColor,
        stroke: this.erase ? Settings$1.view.eraseColor : this.layer.maskColor
      },
      handle: {
        fill: this.erase ? Settings$1.view.eraseColor : this.layer.maskColorAccent
      }
    });
  }
};

RasterPolygon.prototype.moveTool = function (e) {
  this.polygonBase.previewPoint(e);
};

RasterPolygon.prototype.hoverTool = function (e) {
  this.polygonBase.previewPoint(e);
};

RasterPolygon.prototype.endTool = function (e) {
  this.polygonBase.createPoint(e);
};

function VectorPolygon() {
  MaskingTool.call(this);

  if (!MaskingModule.hasSelectedLayer()) {
    throw new Error('Tool requires a layer to be selected');
  }

  this.layer = MaskingModule.getSelectedLayer();
  this.polygonBase = new PolygonBase(this.layer);

  this.erase = false;
  this.addStandardSetting('erase', 'bool');

  var _this = this;
  this.polygonBase.setFinishHandler(function (polygon, id) {
    _this.polygonBase.clear();

    History.get().pushVectorLayerState(_this.layer, function (layer) {
      if (_this.erase) {
        layer.clipPolygon(polygon, true);
      } else {
        layer.mergePolygon(polygon, true);
      }
    });

    MaskingModule.draw();
  });

  History.restart().pushVectorLayerState(this.layer);
}

VectorPolygon.prototype = MaskingTool.Prototype();

VectorPolygon.prototype.removeTool = function () {
  History.get().clear();
};

VectorPolygon.prototype.cancelTool = function () {
  this.polygonBase.clear();
};

VectorPolygon.prototype.startTool = function (e) {
  if (!this.polygonBase.isStarted()) {
    this.polygonBase.createStartPoint(e, {
      polygon: {
        fill: this.erase ? Settings$1.view.eraseColor : this.layer.maskColor,
        stroke: this.erase ? Settings$1.view.eraseColor : this.layer.maskColor
      },
      handle: {
        fill: this.erase ? Settings$1.view.eraseColor : this.layer.maskColorAccent
      }
    });
  }
};

VectorPolygon.prototype.moveTool = function (e) {
  this.polygonBase.previewPoint(e);
};

VectorPolygon.prototype.hoverTool = function (e) {
  this.polygonBase.previewPoint(e);
};

VectorPolygon.prototype.endTool = function (e) {
  this.polygonBase.createPoint(e);
};

function StampTool() {
  MaskingTool.call(this);

  if (!MaskingModule.hasSelectedLayer()) {
    throw new Error('Tool requires a layer to be selected');
  }

  this.layer = MaskingModule.getSelectedLayer();
  this.polygonBase = new PolygonBase(MaskingModule.getLayer('GLOBAL'));

  this.erase = false;
  this.addStandardSetting('erase', 'bool');

  this.shape = null;

  var _this = this;
  this.polygonBase.setFinishHandler(function (polygon) {
    _this.shape = polygon;
  });

  History.restart().pushVectorLayerState(this.layer);
}

StampTool.prototype = MaskingTool.Prototype();

StampTool.prototype.removeTool = function () {
  History.get().clear();
};

StampTool.prototype.cancelTool = function () {
  this.polygonBase.clear();
  this.shape = null;
};

StampTool.prototype.startTool = function (e) {
  if (this.shape) {
    var point = this.shape.centroid();
    var polygon = this.shape.clone().shift(e.relative.x - point.x, e.relative.y - point.y);

    var erase = this.erase;
    History.get().pushVectorLayerState(this.layer, function (layer) {
      if (erase) {
        layer.clipPolygon(polygon, true);
      } else {
        layer.mergePolygon(polygon, true);
      }
    });
  } else if (!this.polygonBase.isStarted()) {
    this.polygonBase.createStartPoint(e);
  }
};

StampTool.prototype.update = function (e) {
  if (this.shape) {
    var point = this.shape.centroid();
    this.polygonBase.movePolygon(this.shape.shift(e.relative.x - point.x, e.relative.y - point.y));
    MaskingModule.draw();
  } else {
    this.polygonBase.previewPoint(e);
  }
};

StampTool.prototype.moveTool = function (e) {
  this.update(e);
};

StampTool.prototype.hoverTool = function (e) {
  this.update(e);
};

StampTool.prototype.endTool = function (e) {
  if (!this.shape) {
    this.polygonBase.createPoint(e);
  }
};

function FloodFillTool(options) {
  MaskingTool.call(this);
  options = options || {};

  if (!MaskingModule.hasSelectedLayer()) {
    throw new Error('Tool requires a layer to be selected');
  }

  this.layer = MaskingModule.getSelectedLayer();
  this.colorThreshold = options.colorThreshold || 20;
  this.blurRadius = options.blurRadius || 5;
  this.simplifyTolerant = options.simplifyTolerant || 2;
  this.simplifyCount = options.simplifyCount || 30;
  this.erase = options.erase || false;

  this.addStandardSetting('colorThreshold', 'number');
  this.addStandardSetting('blurRadius', 'number');
  this.addStandardSetting('simplifyTolerant', 'number');
  this.addStandardSetting('simplifyCount', 'number');
  this.addStandardSetting('erase', 'bool');

  var _this = this;
  MaskingModule.state.project.image.load.then(function () {
    _this.ready = true;
  });
}

FloodFillTool.prototype = MaskingTool.Prototype();

FloodFillTool.prototype.fill = function (e) {
  if (!this.ready) {
    throw new Error('Project image canvas was not loaded');
  }

  var state = MaskingModule.state;
  var image = {
    data: state.project.image.data,
    width: state.project.width,
    height: state.project.height,
    bytes: 4
  };

  // Note that relative position includes a gutter, and flood fill doesn't
  // use a gutter on the project image, so gutter has to be taken out and
  // added to polygon points later
  var mask = MagicWand.floodFill(image, Math.floor(e.relative.x - state.gutterX), Math.floor(e.relative.y - state.gutterY), this.colorThreshold);
  mask = MagicWand.gaussBlurOnlyBorder(mask, this.blurRadius);

  // Trace the flood fill mask and get the points of the trace
  var contours = MagicWand.traceContours(mask);
  contours = MagicWand.simplifyContours(contours, this.simplifyTolerant, this.simplifyCount);

  function contourToPolygon(contour) {
    // Go through the points in this contour and create Point objects
    var points = [];
    for (var j = 0; j < contour.points.length; j++) {
      points.push(state.gutter.add(contour.points[j]));
    }

    return new Polygon(points);
  }

  // Go through the points of the contours and create a polygons from it
  var polygons = {
    draw: [],
    erase: []
  };

  for (var i = 0; i < contours.length; i++) {
    var contour = contours[i];
    var polygon = contourToPolygon(contour);

    // There are inner polygons and one outer polygon created from the flood fill.
    // We will draw the outer polygon, then erase all the inner polygons.
    if (contour.inner) {
      polygons.erase.push(polygon);
    } else {
      polygons.draw.push(polygon);
    }
  }

  if (this.erase) {
    this.layer.erasePolygon(polygons.draw);
  } else {
    this.layer.drawPolygon(polygons);
  }

  MaskingModule.draw();

  $(window.MaskingModule).trigger(Events.LayerRastorUpdated, this.layer);
};

FloodFillTool.prototype.startTool = function (e) {
  this.fill(e);
};

FloodFillTool.prototype.moveTool = function (e) {
  this.fill(e);
};

FloodFillTool.prototype.endTool = function (e) {};

function BrushTool(options) {
  MaskingTool.call(this);
  options = options || {};

  this.cursor = 'none';

  if (!MaskingModule.hasSelectedLayer()) {
    throw new Error('Tool requires a layer to be selected');
  }

  this.layer = MaskingModule.getSelectedLayer();
  this.global = MaskingModule.state.layers.GLOBAL;

  // this tool transfers the current layer's raster component to GLOBAL,
  // draws on that, then when the tool is removed, pushes GLOBAL back
  // to the current layer
  //
  // this is almost entirely a performance optimization, but it also gives
  // a better UX because the layer won't be composited over
  //
  // so naturally, saving layers when in the middle of drawing with brush
  // is going to be incorrect (current layer will be blank)

  // copy layer to global
  this.global.setImage(this.layer);
  this.layer.drawRaster(function (ctx) {
    // clear layer
    ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
  });

  this.doneWithCtx = $.Deferred();
  this.ctx = this.global.useRasterContext(this.doneWithCtx.promise());

  this.thickness = options.thickness || 5;
  this.erase = options.erase || false;

  var _this = this;
  this.addSetting('erase', 'bool', function () {
    return _this.erase;
  }, function (value) {
    _this.erase = value;

    // update radius of the circle under cursor
    _this.handle.setAttr('fill', _this.erase ? Settings$1.view.eraseColor : _this.layer.maskColor);

    MaskingModule.draw();
  });

  this.addSetting('thickness', 'number', function () {
    return _this.thickness;
  }, function (value) {
    _this.thickness = value;

    // update radius of the circle under cursor
    _this.handle.setAttr('r', _this.thickness);

    MaskingModule.draw();
  });

  // circle under cursor to show brush size
  this.currentPoint = new Point(-100, -100);
  this.handle = new HandleElement(this.currentPoint).setAttrs({
    cursor: 'none',
    fill: this.erase ? Settings$1.view.eraseColor : this.layer.maskColor,
    r: this.thickness
  }).addToLayer(this.global);

  this.lastPoint = null;
  this.line = [];

  History.restart().pushRasterLayerState(this.global);
}

BrushTool.prototype = MaskingTool.Prototype();

BrushTool.prototype.removeTool = function () {
  this.handle.removeFromLayer();
  this.doneWithCtx.resolve();

  // copy global to layer
  this.layer.setImage(this.global);
  this.global.drawRaster(function (ctx) {
    // clear global
    ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
  });

  History.get().clear();

  $(window.MaskingModule).trigger(Events.LayerRastorUpdated, this.layer);
};

BrushTool.prototype.cancelTool = function () {
  if (this.lastPoint) {
    this.lastPoint = null;
  }

  this.line = [];
};

BrushTool.prototype.startTool = function (e) {
  this.ctx.save();
  this.ctx.globalCompositeOperation = this.erase ? 'destination-out' : 'source-over';
  this.ctx.strokeStyle = this.layer.maskColor;
  this.ctx.lineJoin = 'round';
  this.ctx.lineCap = 'round';
  this.ctx.lineWidth = this.thickness * 2;
  this.ctx.beginPath();

  this.ctx.moveTo(e.relative.x, e.relative.y);
  this.ctx.lineTo(e.relative.x, e.relative.y);
  this.ctx.stroke();

  this.lastPoint = e.relative;
  this.line.push(e.relative);

  MaskingModule.update.raster({
    layers: ['GLOBAL'],
    region: {
      left: e.relative.x - this.thickness,
      right: e.relative.x + this.thickness,
      top: e.relative.y - this.thickness,
      bottom: e.relative.y + this.thickness
    }
  });

  MaskingModule.draw();
};

BrushTool.prototype.moveTool = function (e) {
  this.ctx.lineTo(e.relative.x, e.relative.y);
  this.ctx.moveTo(e.relative.x, e.relative.y);
  this.ctx.stroke();

  MaskingModule.update.raster({
    layers: ['GLOBAL'],
    region: {
      left: Math.min(this.lastPoint.x, e.relative.x) - this.thickness,
      right: Math.max(this.lastPoint.x, e.relative.x) + this.thickness,
      top: Math.min(this.lastPoint.y, e.relative.y) - this.thickness,
      bottom: Math.max(this.lastPoint.y, e.relative.y) + this.thickness
    }
  });

  this.handle.moveTo(this.currentPoint.moveTo(e.relative));

  this.lastPoint = e.relative;
  this.line.push(e.relative);
  MaskingModule.draw();
};

BrushTool.prototype.hoverTool = function (e) {
  this.handle.moveTo(this.currentPoint.moveTo(e.relative));
  MaskingModule.draw();
};

BrushTool.prototype.endTool = function (e) {
  this.moveTool(e);
  this.ctx.restore();

  var color = this.layer.maskColor;
  var erase = this.erase;
  var thickness = this.thickness;
  var line = this.line;

  History.get().pushWithLayer('GLOBAL', {
    execute: function execute(layer) {
      layer.drawRaster(function (ctx) {
        ctx.save();
        ctx.globalCompositeOperation = erase ? 'destination-out' : 'source-over';
        ctx.strokeStyle = color;
        ctx.lineJoin = 'round';
        ctx.lineCap = 'round';
        ctx.lineWidth = thickness * 2;
        ctx.beginPath();

        line.forEach(function (point) {
          ctx.lineTo(point.x, point.y);
          ctx.moveTo(point.x, point.y);
        });

        ctx.stroke();
        ctx.restore();
      });
    }
  });

  this.lastPoint = null;
  this.line = [];
};

function LassoTool(options) {
  MaskingTool.call(this);
  options = options || {};

  if (!MaskingModule.hasSelectedLayer()) {
    throw new Error('Tool requires a layer to be selected');
  }

  this.layer = MaskingModule.getSelectedLayer();
  this.global = MaskingModule.state.layers.GLOBAL;

  // see brush.js for reasoning to draw on GLOBAL
  this.global.setImage(this.layer);
  this.layer.drawRaster(function (ctx) {
    ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
  });

  this.doneWithCtx = $.Deferred();
  this.ctx = this.global.useRasterContext(this.doneWithCtx.promise());

  this.thickness = options.thickness || 2;
  this.erase = options.erase || false;

  this.addStandardSetting('thickness', 'number');
  this.addStandardSetting('erase', 'bool');

  this.points = [];
  this.startData = null;

  History.restart().pushRasterLayerState(this.global);
}

LassoTool.prototype = MaskingTool.Prototype();

LassoTool.prototype.removeTool = function () {
  this.doneWithCtx.resolve();

  // copy global to layer
  this.layer.setImage(this.global);
  this.global.drawRaster(function (ctx) {
    // clear global
    ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
  });

  History.get().clear();
};

LassoTool.prototype.cancelTool = function () {
  this.points = [];

  if (this.startData) {
    this.global.setImage(this.startData);
    this.startData = null;
  }
};

LassoTool.prototype.startTool = function (e) {
  this.startData = this.ctx.getImageData(0, 0, this.ctx.canvas.width, this.ctx.canvas.height);

  this.ctx.save();
  this.ctx.strokeStyle = this.erase ? Settings$1.view.eraseColor : this.layer.maskColor;
  this.ctx.lineJoin = 'round';
  this.ctx.lineCap = 'round';
  this.ctx.lineWidth = this.thickness * 2;
  this.ctx.beginPath();

  this.ctx.moveTo(e.relative.x, e.relative.y);
  this.ctx.lineTo(e.relative.x, e.relative.y);
  this.ctx.stroke();

  this.points.push(e.relative);

  MaskingModule.update.raster({
    layers: ['GLOBAL'],
    region: {
      left: e.relative.x - this.thickness,
      right: e.relative.x + this.thickness,
      top: e.relative.y - this.thickness,
      bottom: e.relative.y + this.thickness
    }
  });

  MaskingModule.draw();
};

LassoTool.prototype.moveTool = function (e) {
  this.ctx.lineTo(e.relative.x, e.relative.y);
  this.ctx.moveTo(e.relative.x, e.relative.y);
  this.ctx.stroke();

  var lastPoint = this.points[this.points.length - 1];
  this.points.push(e.relative);

  for (var i = 0; i < this.points.length - 4; i++) {
    var p1 = this.points[i];
    var p2 = this.points[i + 1];
    var p3 = lastPoint;
    var p4 = e.relative;

    var intersect = Polygon.lineIntersect(p1.x, p1.y, p2.x, p2.y, p3.x, p3.y, p4.x, p4.y);
    if (intersect) {
      this.points.splice(0, i + 1);
      this.points[this.points.length - 1] = intersect;

      // override MaskingTool.started
      this.started = false;

      // redraw path without points before intersection
      this.ctx.putImageData(this.startData, 0, 0);
      this.finish();
      return;
    }
  }

  MaskingModule.update.raster({
    layers: ['GLOBAL'],
    region: {
      left: Math.min(lastPoint.x, e.relative.x) - this.thickness,
      right: Math.max(lastPoint.x, e.relative.x) + this.thickness,
      top: Math.min(lastPoint.y, e.relative.y) - this.thickness,
      bottom: Math.max(lastPoint.y, e.relative.y) + this.thickness
    }
  });

  MaskingModule.draw();
};

LassoTool.prototype.endTool = function (e) {
  this.cancel();
};

LassoTool.prototype.finish = function () {
  var color = this.layer.maskColor;
  var erase = this.erase;
  var points = this.points.map(function (point) {
    return new Point(point);
  });

  History.get().pushWithLayer('GLOBAL', {
    execute: function execute(layer) {
      layer.drawRaster(function (ctx) {
        ctx.save();
        ctx.globalCompositeOperation = erase ? 'destination-out' : 'source-over';
        ctx.fillStyle = color;
        ctx.lineJoin = 'round';
        ctx.lineCap = 'round';
        ctx.beginPath();

        ctx.moveTo(points[0].x, points[0].y);
        points.forEach(function (point) {
          ctx.lineTo(point.x, point.y);
        });

        ctx.fill();
        ctx.restore();
      });
    }
  }).execute();

  MaskingModule.update.raster({
    layers: ['GLOBAL']
  });

  MaskingModule.draw();

  this.points = [];
  this.startData = null;
};

function OpeningTool() {
  var _this = this;

  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  MaskingTool.call(this);

  this.cursor = 'initial';

  if (!MaskingModule.hasSelectedLayer()) {
    throw new Error('Tool requires a layer to be selected');
  }

  this.disableElementEditingFlag = options.disableElementEditing;
  this.enableSyncPolygonLayerFlag = options.syncPolygonLayer;
  this.syncedAttrs = {};
  this.syncedElement = null;

  var updates = [];
  function updateAll(polygon) {
    for (var i = 0; i < updates.length; i++) {
      updates[i](polygon);
    }
  }

  var layer = MaskingModule.getSelectedLayer();
  var contour = layer.perspective.contour.add(MaskingModule.state.gutter);
  var layerType = layer.type && 'RW' + layer.type;

  if (this.disableElementEditingFlag) {
    MaskingModule.view.disableEditing(true);
  }

  if (this.enableSyncPolygonLayerFlag) {
    this.syncPolyonLayer(layer, contour, layerType);
  }

  updates.push(function (polygon) {
    for (var i = 0; i < polygon.points.length; i++) {
      contour.points[i].moveTo(polygon.points[i]);
    }
  });

  // draggable uses layerType to setCurve
  // NOTE: do not pass the ordered points below, as they are messed up
  this.draggable = new PolygonElement(contour, false, layerType).addToLayer(layer).setAttrs(Settings$1.tools.opening.polygon);

  var updatePerspective = function updatePerspective() {
    layer.perspective.contour = contour.minus(MaskingModule.state.gutter);
    $(window.MaskingModule).trigger(Events.LayerPerspectiveUpdated, layer);

    if (_this.enableSyncPolygonLayerFlag) {
      _this.syncedElement.updatePolygon(contour);
      $(window.MaskingModule).trigger(Events.LayerVectorUpdated, layer);
    }
  };

  function createEdge(p1, p2, cursor) {
    var element = new PolygonElement([contour.points[p1], contour.points[p2]]).addToLayer(layer).setAttrs(Settings$1.tools.opening.edge).makeDraggable(function (polygon) {
      element.setAttrs(Settings$1.tools.opening.edgeHighlight);

      contour.points[p1].moveTo(polygon.points[0]);
      contour.points[p2].moveTo(polygon.points[1]);
      updateAll(contour);
    }, null, updatePerspective).setAttr('cursor', cursor).addEvent('mouseover', function () {
      element.setAttrs(Settings$1.tools.opening.edgeHighlight);
      MaskingModule.draw();
    }).addEvent('mouseout', function () {
      element.setAttrs(Settings$1.tools.opening.edge);
      MaskingModule.draw();
    });

    updates.push(function (perspective) {
      element.polygon.points[0].moveTo(perspective.points[p1]);
      element.polygon.points[1].moveTo(perspective.points[p2]);
      element.updatePolygon();
    });

    return element;
  }

  function createCurve(p1, p2, p3, cursor) {
    // TODO: new CurveElement that extends PolygonElement
    var element = new PolygonElement([contour.points[p1], contour.points[p2], contour.points[p3]], false, layerType).addToLayer(layer).setAttrs(Settings$1.tools.opening.edge).makeDraggable(function (polygon) {
      // TODO: decide whether line should be draggable, or only the points
      element.setAttrs(Settings$1.tools.opening.edgeHighlight);

      contour.points[p1].moveTo(polygon.points[0]);
      contour.points[p2].moveTo(polygon.points[1]);
      contour.points[p3].moveTo(polygon.points[2]);
      updateAll(contour);
    }, null, updatePerspective).setAttr('cursor', cursor).addEvent('mouseover', function () {
      element.setAttrs(Settings$1.tools.opening.edgeHighlight);
      MaskingModule.draw();
    }).addEvent('mouseout', function () {
      element.setAttrs(Settings$1.tools.opening.edge);
      MaskingModule.draw();
    });

    updates.push(function (perspective) {
      element.polygon.points[0].moveTo(perspective.points[p1]);
      element.polygon.points[1].moveTo(perspective.points[p2]);
      element.polygon.points[2].moveTo(perspective.points[p3]);
      element.updatePolygon();
    });

    return element;
  }

  // array of point indexes ordered clockwise (CW) from upper left
  var pointCWIndex = Perspective.getPointsFromTopLeftCorner(contour.points);

  if (pointCWIndex.length === 5) {
    this.topEdge = createCurve(pointCWIndex[0], pointCWIndex[1], pointCWIndex[4], 'ns-resize');
  } else {
    this.topEdge = createEdge(pointCWIndex[0], pointCWIndex[1], 'ns-resize');
  }
  if (pointCWIndex.length === 6) {
    this.upperLeftCorner = createEdge(pointCWIndex[1], pointCWIndex[2], 'ew-resize');
    this.leftEdge = createEdge(pointCWIndex[2], pointCWIndex[3], 'ew-resize');
    this.bottomEdge = createEdge(pointCWIndex[3], pointCWIndex[4], 'ns-resize');
    this.rightEdge = createEdge(pointCWIndex[4], pointCWIndex[5], 'ew-resize');
    this.upperRightCorner = createEdge(pointCWIndex[5], pointCWIndex[0], 'ew-resize');
  } else {
    this.upperLeftCorner = undefined;
    this.leftEdge = createEdge(pointCWIndex[1], pointCWIndex[2], 'ew-resize');
    this.bottomEdge = createEdge(pointCWIndex[2], pointCWIndex[3], 'ns-resize');
    this.rightEdge = createEdge(pointCWIndex[3], pointCWIndex[0], 'ew-resize');
    this.upperRightCorner = undefined;
  }

  this.draggable.addHandles(Settings$1.tools.opening.handle, updateAll, null, updatePerspective).makeDraggable(updateAll, null, updatePerspective);

  updates.push(function (polygon) {
    for (var i = 0; i < polygon.points.length; i++) {
      _this.draggable.polygon.points[i].moveTo(polygon.points[i]);
      _this.draggable.handles[i].moveTo(polygon.points[i]);
    }

    _this.draggable.updatePolygon();
  });
}

OpeningTool.prototype = MaskingTool.Prototype();

OpeningTool.prototype.cancelTool = function () {
  if (!this.draggable) {
    return;
  }

  [this.draggable, this.leftEdge, this.bottomEdge, this.rightEdge, this.topEdge].forEach(function (draggable) {
    draggable.removeFromLayer();
  });
  if (this.upperLeftCorner) {
    [this.upperLeftCorner, this.upperRightCorner].forEach(function (draggable) {
      draggable.removeFromLayer();
    });
  }

  this.draggable = null;

  if (this.disableElementEditingFlag) {
    MaskingModule.view.disableEditing(false);
  }

  if (this.enableSyncPolygonLayerFlag) {
    // unhide element
    this.syncedElement.setAttrs(Object.assign({}, this.syncedAttrs, { path: this.syncedElement.attrs.path }));
  }
};

OpeningTool.prototype.startTool = function (e) {};
OpeningTool.prototype.moveTool = function (e) {};
OpeningTool.prototype.endTool = function (e) {};

OpeningTool.prototype.syncPolyonLayer = function (layer, contour, layerType) {
  var elements = layer.getAllElements();
  if (elements.length) {
    // only supports syncing first element
    this.syncedElement = elements[0];
  }

  if (!(this.syncedElement && this.syncedElement instanceof PolygonElement)) {
    this.syncedElement = new PolygonElement(contour, true, layerType).addToLayer(layer);
  }

  this.syncedAttrs = Object.assign({}, this.syncedElement.attrs);
  this.syncedElement.setAttrs({
    'fill-opacity': 0,
    'stroke-opacity': 0
  });
};

function SetScaleTool(options) {
  MaskingTool.call(this);
  options = options || {};

  var color = SetScaleTool.color || (SetScaleTool.color = 'white');
  this.cursor = 'initial';

  var state = MaskingModule.state;
  this.layer = state.layers.GLOBAL;

  this.startPoint = options.startPoint || new Point(state.project.width / 2, state.project.height / 4);
  this.endPoint = options.endPoint || new Point(state.project.width / 2, state.project.height * (3 / 4));

  function updateScale(polygon) {
    $(window.MaskingModule).trigger(Events.ScaleSet, {
      start: polygon.points[0],
      end: polygon.points[1]
    });
  }

  var _this = this;
  this.element = new PolygonElement([this.startPoint, this.endPoint]).addToLayer(this.layer).makeDraggable(null, null, updateScale).addHandles(Settings$1.tools.setscale.handle, null, null, updateScale).setAttrs(Settings$1.tools.setscale.polygon).addEvent('mouseover', function () {
    _this.element.setAttrs(Settings$1.tools.setscale.polygonHighlight);
    MaskingModule.draw();
  }).addEvent('mouseout', function () {
    _this.element.setAttrs(Settings$1.tools.setscale.polygon);
    MaskingModule.draw();
  });

  this.element.handles.forEach(function (handle) {
    handle.addEvent('mouseover', function () {
      handle.setAttrs(Settings$1.tools.setscale.handleHighlight);
      MaskingModule.draw();
    });
    handle.addEvent('mouseout', function () {
      handle.setAttrs(Settings$1.tools.setscale.handle);
      MaskingModule.draw();
    });
  });

  this.lastLayerViewOption = state.view.layerViewOption;
  // do not show layers when editing the scale
  MaskingModule.setLayerViewOption(LayerViewOption.none).setHoverOption(LayerHoverOption.none).draw();
}

SetScaleTool.prototype = MaskingTool.Prototype();

SetScaleTool.prototype.removeTool = function () {
  MaskingModule.setLayerViewOption(this.lastLayerViewOption);
};

SetScaleTool.prototype.cancelTool = function () {
  this.element.removeFromLayer();
};

SetScaleTool.prototype.startTool = function (e) {};
SetScaleTool.prototype.moveTool = function (e) {};
SetScaleTool.prototype.endTool = function (e) {};

function SetScaleProgressiveTool() {
  MaskingTool.call(this);

  var color = SetScaleProgressiveTool.color || (SetScaleProgressiveTool.color = 'white');
  this.cursor = 'crosshair';

  var state = MaskingModule.state;
  this.layer = state.layers.GLOBAL;

  this.startPoint = null;
  this.endPoint = null;
  this.done = false;

  this.lastLayerViewOption = state.view.layerViewOption;
  // do not show layers when editing the scale
  MaskingModule.setLayerViewOption(LayerViewOption.none).setHoverOption(LayerHoverOption.none).draw();
}

SetScaleProgressiveTool.prototype = MaskingTool.Prototype();

SetScaleProgressiveTool.prototype.removeTool = function () {
  MaskingModule.setLayerViewOption(this.lastLayerViewOption);
};

SetScaleProgressiveTool.prototype.cancelTool = function () {
  if (this.element) {
    this.element.removeFromLayer();
  }
};

SetScaleProgressiveTool.prototype.startTool = function (e) {
  if (this.startPoint) {
    if (!this.done) {
      this.done = true;
      this.endPoint.moveTo(e.relative);

      var scale = new Polygon([this.startPoint, this.endPoint]);
      updateScale(scale);

      this.element.removeFromLayer();
      this.element = new PolygonElement(scale).addToLayer(this.layer).addHandles(Settings$1.tools.setscale.handle, null, null, updateScale).setAttrs(Settings$1.tools.setscale.polygon);
    }

    MaskingModule.draw();
    return;
  }

  this.startPoint = new Point(e.relative);
  this.endPoint = this.startPoint.clone();

  this.element = new PolygonElement([this.startPoint, this.endPoint]).addToLayer(this.layer).setAttrs(Settings$1.tools.setscale.polygon).setAttr('cursor', 'crosshair');
};

SetScaleProgressiveTool.prototype.hoverTool = function (e) {
  if (!this.startPoint || this.done) {
    return;
  }

  this.element.polygon.points[1].moveTo(e.relative);
  this.element.updatePolygon();
  MaskingModule.draw();
};

SetScaleProgressiveTool.prototype.moveTool = function (e) {
  if (this.done) {
    return;
  }

  this.element.polygon.points[1].moveTo(e.relative);
  this.element.updatePolygon();
  MaskingModule.draw();
};

SetScaleProgressiveTool.prototype.endTool = function (e) {};

function updateScale(polygon) {
  $(window.MaskingModule).trigger(Events.ScaleSet, {
    start: polygon.points[0],
    end: polygon.points[1]
  });
}

var PerspectiveManager = PerspectiveToolModule.PerspectiveManager,
    PerspectiveEvents = PerspectiveToolModule.Events;

var div = $(document.createElement('div')).attr('data-label', 'perspective-tool').css({
  width: 0,
  height: 0,
  top: 0,
  left: 0,
  position: 'absolute'
});

var tool = null;

function PerspectiveTool() {
  var _this = this;

  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  MaskingTool.call(this);

  if (!MaskingModule.hasSelectedLayer()) {
    throw new Error('Tool requires a layer to be selected');
  }

  this.cursor = 'initial';

  this.layer = MaskingModule.getSelectedLayer();
  var state = MaskingModule.state;

  this.widthFeet = options.widthFeet;
  this.heightFeet = options.heightFeet;

  var viewState = {
    getXScale: function getXScale() {
      return state.project.width / (state.view.scale * state.view.width);
    },
    getYScale: function getYScale() {
      return state.project.height / (state.view.scale * state.view.height);
    },
    getOffset: function getOffset() {
      return state.view.offset;
    }
  };

  if (!tool) {
    tool = PerspectiveManager.init(div.get(0), state.project.width, state.project.height, viewState);
    this.setDimensions(this.widthFeet, this.heightFeet);
    MaskingModule.view.addWidget(div, null, $(div).find('svg'));
    state.update.updateMasks({
      size: true
    });
    MaskingModule.draw();

    div.on(PerspectiveEvents.RESIZE + ' ' + PerspectiveEvents.MOVED, function (event) {
      for (var _len = arguments.length, points = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        points[_key - 1] = arguments[_key];
      }

      updateState(_this.layer, points);
      $(window.MaskingModule).trigger(Events.LayerPerspectiveUpdated, _this.layer);
    });
  }

  this.addSetting('widthFeet', 'number', function () {
    return _this.widthFeet;
  }, function (value) {
    _this.widthFeet = value;
    _this.setDimensions(_this.widthFeet, _this.heightFeet);
  });

  this.addSetting('heightFeet', 'number', function () {
    return _this.heightFeet;
  }, function (value) {
    _this.heightFeet = value;
    _this.setDimensions(_this.widthFeet, _this.heightFeet);
  });

  tool.setPoints(this.layer.perspective.contour.points);
  div.show();

  this.setDimensions(this.widthFeet, this.heightFeet);
}

function updateState(layer, points) {
  layer.perspective.contour = new Polygon([new Point(points[0].x, points[0].y), new Point(points[1].x, points[1].y), new Point(points[2].x, points[2].y), new Point(points[3].x, points[3].y)]);
}

PerspectiveTool.prototype = MaskingTool.Prototype();

PerspectiveTool.prototype.resetPoints = function () {
  var sizeRatio = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0.1;

  var defaultSize = Math.min(this.layer.width, this.layer.height) * sizeRatio;
  var x0 = this.layer.width / 2 - defaultSize / 2;
  var y0 = this.layer.height / 2 - defaultSize / 2;
  var x1 = x0 + defaultSize;
  var y1 = y0 + defaultSize;

  var points = [new Point(x0, y0), new Point(x1, y0), new Point(x1, y1), new Point(x0, y1)];
  tool.setPoints(points);
  updateState(this.layer, points);
};

PerspectiveTool.prototype.setDimensions = function (widthFeet, heightFeet) {
  var w = Number.parseFloat(widthFeet);
  var h = Number.parseFloat(heightFeet);
  tool.setDimensions(!isNaN(w) ? w : 0, !isNaN(h) ? h : 0);
};

PerspectiveTool.prototype.cancelTool = function () {
  div.hide();

  MaskingModule.state.currentTool = null;
  $(window.MaskingModule).trigger(Events.ToolChanged, null);

  return $.when();
};

PerspectiveTool.prototype.startTool = function (e) {};
PerspectiveTool.prototype.moveTool = function (e) {};
PerspectiveTool.prototype.endTool = function (e) {};

function Magnifier() {
  this.showing = false;
  this.element = null;

  var _this = this;
  $(window.MaskingModule).on(Events.ProjectLoaded, function () {
    if (_this.showing) {
      // reload when project changes
      _this.hide();
      _this.show();
    }
  });
}

Magnifier.prototype.show = function () {
  if (this.element) {
    $(this.element).remove();
  }

  this.showing = true;
  var canvas = document.createElement('canvas');
  var size = Settings$1.widgets.magnifier.size;
  canvas.width = size;
  canvas.height = size;

  var container = $('<div></div>').append(canvas).css({
    width: size + 'px',
    height: size + 'px',
    left: '0',
    top: '0',
    overflow: 'hidden',
    position: 'absolute'
  });

  this.element = container;

  $(canvas).css({
    width: '100%',
    height: '100%'
  }).mouseover(function () {
    if ($(container).css('left') == '0px') {
      var state = MaskingModule.state;
      $(container).animate({
        left: state.view.container.width - size
      });
    } else {
      $(container).animate({
        left: 0
      });
    }
  });

  var ctx = canvas.getContext('2d');
  MaskingModule.state.project.image.load.then(function (projectImage) {
    MaskingModule.view.addWidget(container, {
      mousemove: mousemove,
      touchmove: mousemove
    });

    function mousemove(e) {
      // click and drag just distorts magnifier view
      if (MaskingModule.view.isPanning() && e.which > 0) {
        return;
      }

      var state = MaskingModule.state;
      var zoomSize = 30;

      ctx.save();
      ctx.imageSmoothingEnabled = false;
      ctx.clearRect(0, 0, size, size);

      // clip circle
      ctx.beginPath();
      ctx.arc(size / 2, size / 2, size / 2, 0, Math.PI * 2);
      ctx.clip();

      ctx.drawImage(projectImage, e.relative.x - zoomSize / 2 - state.gutterX, e.relative.y - zoomSize / 2 - state.gutterY, zoomSize, zoomSize, 0, 0, size, size);

      // circle border
      ctx.beginPath();
      ctx.arc(size / 2, size / 2, size / 2 - 1, 0, Math.PI * 2);
      ctx.lineWidth = 2;
      ctx.stroke();

      // crosshair (black)
      ctx.beginPath();
      ctx.strokeStyle = 'black';
      ctx.moveTo(0, size / 2);
      ctx.lineTo(size / 2 - 5, size / 2);
      ctx.moveTo(size / 2 + 5, size / 2);
      ctx.lineTo(size, size / 2);
      ctx.moveTo(size / 2, 0);
      ctx.lineTo(size / 2, size / 2 - 5);
      ctx.moveTo(size / 2, size / 2 + 5);
      ctx.lineTo(size / 2, size);
      ctx.stroke();

      // crosshair (white)
      ctx.beginPath();
      ctx.strokeStyle = 'white';
      ctx.moveTo(0, size / 2 + 1);
      ctx.lineTo(size / 2 - 5, size / 2 + 1);
      ctx.moveTo(size / 2 + 5, size / 2 + 1);
      ctx.lineTo(size, size / 2 + 1);
      ctx.moveTo(size / 2 + 1, 0);
      ctx.lineTo(size / 2 + 1, size / 2 - 5);
      ctx.moveTo(size / 2 + 1, size / 2 + 5);
      ctx.lineTo(size / 2 + 1, size);
      ctx.stroke();

      ctx.restore();
    }

    mousemove({
      // first draw
      relative: {
        x: 0, y: 0
      }
    });
  });
};

Magnifier.prototype.hide = function () {
  if (this.element) {
    $(this.element).remove();
  }

  this.showing = false;
};

var Magnifier$1 = new Magnifier();

var main = Object.assign(MaskingModule$1, {
  Settings: Settings$1,
  View: MaskingView,
  Point: Point,
  Polygon: Polygon,
  Perspective: Perspective,
  LayerViewOption: LayerViewOption,
  LayerHoverOption: LayerHoverOption,
  Events: Events,
  Element: Element,
  Layer: MaskingLayer,
  MasterMask: MasterMask,
  StateUpdate: StateUpdate,
  State: MaskingState,
  History: History,
  Tool: MaskingTool,
  PolygonElement: PolygonElement,
  HandleElement: HandleElement,
  Tools: {
    PolygonBase: PolygonBase,
    RectangleBase: RectangleBase,
    RasterRectangle: RasterRectangle,
    VectorRectangle: VectorRectangle,
    RasterPolygon: RasterPolygon,
    VectorPolygon: VectorPolygon,
    Stamp: StampTool,
    FloodFill: FloodFillTool,
    Brush: BrushTool,
    Lasso: LassoTool,
    Opening: OpeningTool,
    SetScale: SetScaleTool,
    SetScaleProgressive: SetScaleProgressiveTool,
    Perspective: PerspectiveTool
  },
  Widgets: {
    Magnifier: Magnifier$1
  }
});

return main;

})));



//////////////////
// WEBPACK FOOTER
// ./node_modules/@renoworks/masking-module/dist/masking-module.js
// module id = Kzt1
// module chunks = 0